// tslint:disable
/**
 * SendHub
 * SendHub\'s REST-like API allows you to control & interact with your SendHub account programmatically.  Note: this documentation is in Beta and may be updated periodically.
 *
 * The version of the OpenAPI document: v1
 * Contact: support@sendhub.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as globalImportUrl from 'url'
import { Configuration } from './configuration'
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios'
// Some imports not used depending on template conditions
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  RequestArgs,
  BaseAPI,
  RequiredError,
} from './base'

/**
 *
 * @export
 * @interface AddRemoveGroupContacts202Response
 */
export interface AddRemoveGroupContacts202Response {
  /**
   * Contact ids successfully added to this group
   * @type {Array<string | number>}
   * @memberof AddRemoveGroupContacts202Response
   */
  add?: Array<string | number>
  /**
   *
   * @type {object}
   * @memberof AddRemoveGroupContacts202Response
   */
  errors?: object
  /**
   * Contact ids successfully removed from this group
   * @type {Array<string | number>}
   * @memberof AddRemoveGroupContacts202Response
   */
  remove?: Array<string | number>
}
/**
 *
 * @export
 * @interface AddRemoveGroupContacts202ResponseAdd
 */
export interface AddRemoveGroupContacts202ResponseAdd {
  /**
   * Contact ids that failed to be added to this group
   * @type {Array<string>}
   * @memberof AddRemoveGroupContacts202ResponseAdd
   */
  add?: Array<string>
}
/**
 *
 * @export
 * @interface AddRemoveGroupContacts202ResponseRemove
 */
export interface AddRemoveGroupContacts202ResponseRemove {
  /**
   * Contact ids that failed to be removed from this group
   * @type {Array<string>}
   * @memberof AddRemoveGroupContacts202ResponseRemove
   */
  remove?: Array<string>
}
/**
 * @type AddRemoveGroupContactsRequest
 * @export
 */
export type AddRemoveGroupContactsRequest =
  | AddRemoveGroupContactsRequestAdd
  | AddRemoveGroupContactsRequestBoth
  | AddRemoveGroupContactsRequestRemove

/**
 *
 * @export
 * @interface AddRemoveGroupContactsRequestAdd
 */
export interface AddRemoveGroupContactsRequestAdd {
  /**
   * Contact ids that you want to add to this group
   * @type {Array<string | number>}
   * @memberof AddRemoveGroupContactsRequestAdd
   */
  add: Array<string | number>
}
/**
 *
 * @export
 * @interface AddRemoveGroupContactsRequestBoth
 */
export interface AddRemoveGroupContactsRequestBoth {
  /**
   * Contact ids that you want to add to this group
   * @type {Array<string | number>}
   * @memberof AddRemoveGroupContactsRequestBoth
   */
  add: Array<string | number>
  /**
   * Contact ids that you want to remove from this group
   * @type {Array<string | number>}
   * @memberof AddRemoveGroupContactsRequestBoth
   */
  remove: Array<string | number>
}
/**
 *
 * @export
 * @interface AddRemoveGroupContactsRequestRemove
 */
export interface AddRemoveGroupContactsRequestRemove {
  /**
   * Contact ids that you want to remove from this group
   * @type {Array<string | number>}
   * @memberof AddRemoveGroupContactsRequestRemove
   */
  remove: Array<string | number>
}
/**
 *
 * @export
 * @enum {string}
 */
export enum AttachmentContainer {
  SendhubAttachments = 'sendhub-attachments',
}

/**
 *
 * @export
 * @interface AttachmentViaBase64EncodedFile
 */
export interface AttachmentViaBase64EncodedFile {
  /**
   *
   * @type {string}
   * @memberof AttachmentViaBase64EncodedFile
   */
  filename: string
  /**
   * Base64-encoded file
   * @type {string}
   * @memberof AttachmentViaBase64EncodedFile
   */
  data: string
}
/**
 *
 * @export
 * @interface AttachmentViaURL
 */
export interface AttachmentViaURL {
  /**
   *
   * @type {string}
   * @memberof AttachmentViaURL
   */
  filename: string
  /**
   * Publicly-accessible URL
   * @type {string}
   * @memberof AttachmentViaURL
   */
  url: string
}
/**
 *
 * @export
 * @interface AuthGroup
 */
export interface AuthGroup {
  /**
   *
   * @type {number}
   * @memberof AuthGroup
   */
  id: AuthGroupIdEnum
  /**
   *
   * @type {string}
   * @memberof AuthGroup
   */
  name: AuthGroupNameEnum
}

/**
 * @export
 * @enum {string}
 */
export enum AuthGroupIdEnum {
  NUMBER_7 = 7,
}
/**
 * @export
 * @enum {string}
 */
export enum AuthGroupNameEnum {
  AccountAdministrators = 'Account Administrators',
}

/**
 *
 * @export
 * @interface AuthGroup1
 */
export interface AuthGroup1 {
  /**
   *
   * @type {number}
   * @memberof AuthGroup1
   */
  id: AuthGroup1IdEnum
  /**
   *
   * @type {string}
   * @memberof AuthGroup1
   */
  name: AuthGroup1NameEnum
}

/**
 * @export
 * @enum {string}
 */
export enum AuthGroup1IdEnum {
  NUMBER_5 = 5,
}
/**
 * @export
 * @enum {string}
 */
export enum AuthGroup1NameEnum {
  RestrictedUsers = 'Restricted Users',
}

/**
 *
 * @export
 * @interface AuthGroup2
 */
export interface AuthGroup2 {
  /**
   *
   * @type {number}
   * @memberof AuthGroup2
   */
  id: AuthGroup2IdEnum
  /**
   *
   * @type {string}
   * @memberof AuthGroup2
   */
  name: AuthGroup2NameEnum
}

/**
 * @export
 * @enum {string}
 */
export enum AuthGroup2IdEnum {
  NUMBER_9 = 9,
}
/**
 * @export
 * @enum {string}
 */
export enum AuthGroup2NameEnum {
  BillingAdministrators = 'Billing Administrators',
}

/**
 *
 * @export
 * @interface AuthGroup3
 */
export interface AuthGroup3 {
  /**
   *
   * @type {number}
   * @memberof AuthGroup3
   */
  id: AuthGroup3IdEnum
  /**
   *
   * @type {string}
   * @memberof AuthGroup3
   */
  name: AuthGroup3NameEnum
}

/**
 * @export
 * @enum {string}
 */
export enum AuthGroup3IdEnum {
  NUMBER_6 = 6,
}
/**
 * @export
 * @enum {string}
 */
export enum AuthGroup3NameEnum {
  AccountUsers = 'Account Users',
}

/**
 *
 * @export
 * @enum {string}
 */
export enum AuthenticationType {
  Sendhub = 'sendhub',
  Manager = 'manager',
}

/**
 *
 * @export
 * @interface BaseSendMessageRequest
 */
export interface BaseSendMessageRequest {
  /**
   * The text content of the message **Note:** Be sure you understand SMS segmenting ((learn more here)[https://sendhub.force.com/support/s/article/how-am-i-billed-for-long-messages])
   * @type {string}
   * @memberof BaseSendMessageRequest
   */
  text: string
  /**
   * The date & time **in UTC** to schedule the message to be sent at.  **Note:** it **must** be exactly 24-characters long and in this format: `2022-04-13T15:29:40+0000`
   * @type {string}
   * @memberof BaseSendMessageRequest
   */
  scheduled_at?: string | null
  /**
   *
   * @type {object}
   * @memberof BaseSendMessageRequest
   */
  mms?: object
}
/**
 *
 * @export
 * @interface BulkUpsertContactRequest
 */
export interface BulkUpsertContactRequest {
  /**
   *
   * @type {Array<UpsertContactRequestWithoutId | UpsertContactRequestWithId>}
   * @memberof BulkUpsertContactRequest
   */
  objects?: Array<UpsertContactRequestWithoutId | UpsertContactRequestWithId>
}
/**
 *
 * @export
 * @interface Contact
 */
export interface Contact {
  /**
   * Opt-out status (eg. if they texted `Stop`, `Cancel`, `Block`, `Quit` or `End` - [more info](https://sendhub.force.com/support/s/article/SendHub-Number-FAQ))
   * @type {boolean}
   * @memberof Contact
   */
  blocked?: boolean
  /**
   *
   * @type {boolean}
   * @memberof Contact
   */
  deleted?: boolean
  /**
   * Same as id but always a string
   * @type {string}
   * @memberof Contact
   */
  id_str?: string
  /**
   * This is used internally and may be expanded upon or removed in the future
   * @type {boolean}
   * @memberof Contact
   */
  is_owned?: boolean
  /**
   * The keyword must be unique and is generated by the contact\'s name by default. [Learn more about how contact keywords are used here.](https://sendhub.force.com/support/s/article/contacts-faq)
   * @type {string}
   * @memberof Contact
   */
  keyword?: string
  /**
   * The contact\'s name
   * @type {string}
   * @memberof Contact
   */
  name: string
  /**
   * The contact\'s phone number
   * @type {string}
   * @memberof Contact
   */
  number: string
  /**
   * Whether the contact has been blocked by you
   * @type {boolean}
   * @memberof Contact
   */
  screened?: boolean
  /**
   * The contact ID
   * @type {string}
   * @memberof Contact
   */
  id?: string
  /**
   * A UTC timestamp  `2021-08-01T03:48:55.350453` equals August 1st, 2021 at 3:48 and 55.350453 seconds AM (UTC)
   * @type {string}
   * @memberof Contact
   */
  date_created?: string
  /**
   * A UTC timestamp  `2021-08-01T03:48:55.350453` equals August 1st, 2021 at 3:48 and 55.350453 seconds AM (UTC)
   * @type {string}
   * @memberof Contact
   */
  date_modified?: string
  /**
   * True if the contact is a SendHub line
   * @type {boolean}
   * @memberof Contact
   */
  local_gateway?: boolean
  /**
   * Resource URI for this contact
   * @type {string}
   * @memberof Contact
   */
  resource_uri?: string
  /**
   * List of group resource URIs
   * @type {Array<string>}
   * @memberof Contact
   */
  groups?: Array<string>
  /**
   * Whether SendHub has determined the contact\'s number is a landline number
   * @type {boolean}
   * @memberof Contact
   */
  landline?: boolean
  /**
   * TODO:
   * @type {boolean}
   * @memberof Contact
   */
  landline_override?: boolean
}
/**
 *
 * @export
 * @interface Contact1
 */
export interface Contact1 {
  /**
   * Opt-out status (eg. if they texted `Stop`, `Cancel`, `Block`, `Quit` or `End` - [more info](https://sendhub.force.com/support/s/article/SendHub-Number-FAQ))
   * @type {boolean}
   * @memberof Contact1
   */
  blocked?: boolean
  /**
   *
   * @type {boolean}
   * @memberof Contact1
   */
  deleted?: boolean
  /**
   * Same as id but always a string
   * @type {string}
   * @memberof Contact1
   */
  id_str?: string
  /**
   * This is used internally and may be expanded upon or removed in the future
   * @type {boolean}
   * @memberof Contact1
   */
  is_owned?: boolean
  /**
   * The keyword must be unique and is generated by the contact\'s name by default. [Learn more about how contact keywords are used here.](https://sendhub.force.com/support/s/article/contacts-faq)
   * @type {string}
   * @memberof Contact1
   */
  keyword?: string
  /**
   * The contact\'s name
   * @type {string}
   * @memberof Contact1
   */
  name: string
  /**
   * The contact\'s phone number
   * @type {string}
   * @memberof Contact1
   */
  number: string
  /**
   * Whether the contact has been blocked by you
   * @type {boolean}
   * @memberof Contact1
   */
  screened?: boolean
  /**
   * The contact ID
   * @type {string}
   * @memberof Contact1
   */
  id?: string
  /**
   * A UTC timestamp  `2021-08-01T03:48:55.350453` equals August 1st, 2021 at 3:48 and 55.350453 seconds AM (UTC)
   * @type {string}
   * @memberof Contact1
   */
  date_created?: string
  /**
   * A UTC timestamp  `2021-08-01T03:48:55.350453` equals August 1st, 2021 at 3:48 and 55.350453 seconds AM (UTC)
   * @type {string}
   * @memberof Contact1
   */
  date_modified?: string
  /**
   * True if the contact is a SendHub line
   * @type {boolean}
   * @memberof Contact1
   */
  local_gateway?: boolean
  /**
   * Resource URI for this contact
   * @type {string}
   * @memberof Contact1
   */
  resource_uri?: string
  /**
   * List of group resource URIs
   * @type {Array<string>}
   * @memberof Contact1
   */
  groups?: Array<string>
  /**
   * Whether SendHub has determined the contact\'s number is a landline number
   * @type {boolean}
   * @memberof Contact1
   */
  landline?: boolean
  /**
   * TODO:
   * @type {boolean}
   * @memberof Contact1
   */
  landline_override?: boolean
  /**
   *
   * @type {string | number}
   * @memberof Contact1
   */
  contact_id?: string | number
}
/**
 *
 * @export
 * @interface ContactIdBoth
 */
export interface ContactIdBoth {}
/**
 *
 * @export
 * @interface ContactWithContactId
 */
export interface ContactWithContactId {
  [key: string]: string | any

  /**
   * Opt-out status (eg. if they texted `Stop`, `Cancel`, `Block`, `Quit` or `End` - [more info](https://sendhub.force.com/support/s/article/SendHub-Number-FAQ))
   * @type {boolean}
   * @memberof ContactWithContactId
   */
  blocked?: boolean
  /**
   *
   * @type {boolean}
   * @memberof ContactWithContactId
   */
  deleted?: boolean
  /**
   * Same as id but always a string
   * @type {string}
   * @memberof ContactWithContactId
   */
  id_str?: string
  /**
   * This is used internally and may be expanded upon or removed in the future
   * @type {boolean}
   * @memberof ContactWithContactId
   */
  is_owned?: boolean
  /**
   * The keyword must be unique and is generated by the contact\'s name by default. [Learn more about how contact keywords are used here.](https://sendhub.force.com/support/s/article/contacts-faq)
   * @type {string}
   * @memberof ContactWithContactId
   */
  keyword?: string
  /**
   * The contact\'s name
   * @type {string}
   * @memberof ContactWithContactId
   */
  name: string
  /**
   * The contact\'s phone number
   * @type {string}
   * @memberof ContactWithContactId
   */
  number: string
  /**
   * Whether the contact has been blocked by you
   * @type {boolean}
   * @memberof ContactWithContactId
   */
  screened?: boolean
  /**
   * The contact ID
   * @type {string}
   * @memberof ContactWithContactId
   */
  id?: string
  /**
   * A UTC timestamp  `2021-08-01T03:48:55.350453` equals August 1st, 2021 at 3:48 and 55.350453 seconds AM (UTC)
   * @type {string}
   * @memberof ContactWithContactId
   */
  date_created?: string
  /**
   * A UTC timestamp  `2021-08-01T03:48:55.350453` equals August 1st, 2021 at 3:48 and 55.350453 seconds AM (UTC)
   * @type {string}
   * @memberof ContactWithContactId
   */
  date_modified?: string
  /**
   * True if the contact is a SendHub line
   * @type {boolean}
   * @memberof ContactWithContactId
   */
  local_gateway?: boolean
  /**
   * Resource URI for this contact
   * @type {string}
   * @memberof ContactWithContactId
   */
  resource_uri?: string
  /**
   * List of group resource URIs
   * @type {Array<string>}
   * @memberof ContactWithContactId
   */
  groups?: Array<string>
  /**
   * Whether SendHub has determined the contact\'s number is a landline number
   * @type {boolean}
   * @memberof ContactWithContactId
   */
  landline?: boolean
  /**
   * TODO:
   * @type {boolean}
   * @memberof ContactWithContactId
   */
  landline_override?: boolean
  /**
   *
   * @type {string | number}
   * @memberof ContactWithContactId
   */
  contact_id?: string | number
}
/**
 *
 * @export
 * @interface CreateGroupRequest
 */
export interface CreateGroupRequest {
  /**
   * The group\'s name
   * @type {string}
   * @memberof CreateGroupRequest
   */
  name: string
  /**
   * Whether the group is shared between the lines
   * @type {boolean}
   * @memberof CreateGroupRequest
   */
  is_shared?: boolean
  /**
   * The \"keyword\" used to text-to-join  Defaults to the group name lowercased, without any spaces and not duplicate by appending an incrementing number if needed
   * @type {string}
   * @memberof CreateGroupRequest
   */
  slug?: string
  /**
   * This is used internally and may be expanded upon or removed in the future
   * @type {string}
   * @memberof CreateGroupRequest
   */
  mediums?: string | null
  /**
   *
   * @type {string}
   * @memberof CreateGroupRequest
   */
  permissions?: CreateGroupRequestPermissionsEnum
  /**
   * Whether to enable text-to-join functionality for this group
   * @type {boolean}
   * @memberof CreateGroupRequest
   */
  text_to_subscribe?: boolean
  /**
   * A custom response sent when someone texts-to-join this group
   * @type {string}
   * @memberof CreateGroupRequest
   */
  ttjResponse?: string
}

/**
 * @export
 * @enum {string}
 */
export enum CreateGroupRequestPermissionsEnum {
  Write = 'write',
}

/**
 * The direction of the message; `outbound-api` or `incoming`
 * @export
 * @enum {string}
 */
export enum Direction {
  OutboundApi = 'outbound-api',
  Incoming = 'incoming',
}

/**
 * The direction of the message; `to` or `from` the contact
 * @export
 * @enum {string}
 */
export enum DirectionToFrom {
  To = 'to',
  From = 'from',
}

/**
 *
 * @export
 * @interface Enterprise
 */
export interface Enterprise {
  /**
   * 10DLC Brand ID
   * @type {string}
   * @memberof Enterprise
   */
  brand_id?: string | null
  /**
   *
   * @type {string}
   * @memberof Enterprise
   */
  createdTs: string
  /**
   *
   * @type {string}
   * @memberof Enterprise
   */
  customerId: string
  /**
   *
   * @type {boolean}
   * @memberof Enterprise
   */
  hasAccessToChatSupport: boolean
  /**
   *
   * @type {string}
   * @memberof Enterprise
   */
  hash: string
  /**
   *
   * @type {string}
   * @memberof Enterprise
   */
  id: string
  /**
   *
   * @type {string}
   * @memberof Enterprise
   */
  joinUrl: string
  /**
   *
   * @type {string}
   * @memberof Enterprise
   */
  modifiedTs: string
  /**
   *
   * @type {string}
   * @memberof Enterprise
   */
  month_start: string
  /**
   * Your company name
   * @type {string}
   * @memberof Enterprise
   */
  name: string | null
  /**
   *
   * @type {number}
   * @memberof Enterprise
   */
  payment_plan_id: number
  /**
   *
   * @type {string}
   * @memberof Enterprise
   */
  resource_uri: string
  /**
   *
   * @type {string}
   * @memberof Enterprise
   */
  settingsJson: string
  /**
   *
   * @type {boolean}
   * @memberof Enterprise
   */
  shortcode_allowed: boolean
}
/**
 *
 * @export
 * @interface EnterpriseAccount
 */
export interface EnterpriseAccount {
  /**
   * 10DLC Brand ID
   * @type {string}
   * @memberof EnterpriseAccount
   */
  brand_id?: string | null
  /**
   *
   * @type {string}
   * @memberof EnterpriseAccount
   */
  createdTs: string
  /**
   *
   * @type {string}
   * @memberof EnterpriseAccount
   */
  customerId: string
  /**
   *
   * @type {boolean}
   * @memberof EnterpriseAccount
   */
  hasAccessToChatSupport: boolean
  /**
   *
   * @type {string}
   * @memberof EnterpriseAccount
   */
  hash: string
  /**
   *
   * @type {string}
   * @memberof EnterpriseAccount
   */
  id: string
  /**
   *
   * @type {string}
   * @memberof EnterpriseAccount
   */
  joinUrl: string
  /**
   *
   * @type {string}
   * @memberof EnterpriseAccount
   */
  modifiedTs: string
  /**
   *
   * @type {string}
   * @memberof EnterpriseAccount
   */
  month_start: string
  /**
   * Your company name
   * @type {string}
   * @memberof EnterpriseAccount
   */
  name: string | null
  /**
   *
   * @type {number}
   * @memberof EnterpriseAccount
   */
  payment_plan_id: number
  /**
   *
   * @type {string}
   * @memberof EnterpriseAccount
   */
  resource_uri: string
  /**
   *
   * @type {string}
   * @memberof EnterpriseAccount
   */
  settingsJson: string
  /**
   *
   * @type {boolean}
   * @memberof EnterpriseAccount
   */
  shortcode_allowed: boolean
}
/**
 * @type EnterpriseIdBoth
 * @export
 */
export type EnterpriseIdBoth = number | string

/**
 *
 * @export
 * @interface ErrorObject
 */
export interface ErrorObject {
  /**
   *
   * @type {string}
   * @memberof ErrorObject
   */
  error?: string
  /**
   *
   * @type {number}
   * @memberof ErrorObject
   */
  status?: number
}
/**
 *
 * @export
 * @interface Group
 */
export interface Group {
  /**
   * A UTC timestamp  `2021-08-01T03:48:55.350453` equals August 1st, 2021 at 3:48 and 55.350453 seconds AM (UTC)
   * @type {string}
   * @memberof Group
   */
  date_created?: string
  /**
   * A UTC timestamp  `2021-08-01T03:48:55.350453` equals August 1st, 2021 at 3:48 and 55.350453 seconds AM (UTC)
   * @type {string}
   * @memberof Group
   */
  date_modified?: string
  /**
   *
   * @type {boolean}
   * @memberof Group
   */
  deleted?: boolean
  /**
   * The group ID
   * @type {string}
   * @memberof Group
   */
  id?: string
  /**
   * Same as id but always a string
   * @type {string}
   * @memberof Group
   */
  id_str?: string
  /**
   * Whether the group is shared between the lines
   * @type {boolean}
   * @memberof Group
   */
  is_shared?: boolean
  /**
   * The group\'s name
   * @type {string}
   * @memberof Group
   */
  name?: string
  /**
   *
   * @type {string}
   * @memberof Group
   */
  parent_id?: string | null
  /**
   *
   * @type {string}
   * @memberof Group
   */
  parent_user_id?: string | null
  /**
   *
   * @type {string}
   * @memberof Group
   */
  permissions?: GroupPermissionsEnum
  /**
   * Resource URI for this group
   * @type {string}
   * @memberof Group
   */
  resource_uri?: string
  /**
   *
   * @type {number}
   * @memberof Group
   */
  share_invite_count?: number | null
  /**
   * The number of contacts that are a memeber of this group
   * @type {number}
   * @memberof Group
   */
  size?: number | null
  /**
   * The \"keyword\" used to text-to-join  Defaults to the group name lowercased, without any spaces and not duplicate by appending an incrementing number if needed
   * @type {string}
   * @memberof Group
   */
  slug?: string
  /**
   * Whether to enable text-to-join functionality for this group
   * @type {boolean}
   * @memberof Group
   */
  text_to_subscribe?: boolean
  /**
   * A custom response sent when someone texts-to-join this group
   * @type {string}
   * @memberof Group
   */
  ttjResponse?: string
}

/**
 * @export
 * @enum {string}
 */
export enum GroupPermissionsEnum {
  Write = 'write',
}

/**
 * @type GroupIdBoth
 * @export
 */
export type GroupIdBoth = number | string

/**
 *
 * @export
 * @enum {string}
 */
export enum GroupPermissions {
  Write = 'write',
}

/**
 *
 * @export
 * @interface GroupWithMediums
 */
export interface GroupWithMediums {
  /**
   * A UTC timestamp  `2021-08-01T03:48:55.350453` equals August 1st, 2021 at 3:48 and 55.350453 seconds AM (UTC)
   * @type {string}
   * @memberof GroupWithMediums
   */
  date_created?: string
  /**
   * A UTC timestamp  `2021-08-01T03:48:55.350453` equals August 1st, 2021 at 3:48 and 55.350453 seconds AM (UTC)
   * @type {string}
   * @memberof GroupWithMediums
   */
  date_modified?: string
  /**
   *
   * @type {boolean}
   * @memberof GroupWithMediums
   */
  deleted?: boolean
  /**
   * The group ID
   * @type {string}
   * @memberof GroupWithMediums
   */
  id?: string
  /**
   * Same as id but always a string
   * @type {string}
   * @memberof GroupWithMediums
   */
  id_str?: string
  /**
   * Whether the group is shared between the lines
   * @type {boolean}
   * @memberof GroupWithMediums
   */
  is_shared?: boolean
  /**
   * The group\'s name
   * @type {string}
   * @memberof GroupWithMediums
   */
  name?: string
  /**
   *
   * @type {string}
   * @memberof GroupWithMediums
   */
  parent_id?: string | null
  /**
   *
   * @type {string}
   * @memberof GroupWithMediums
   */
  parent_user_id?: string | null
  /**
   *
   * @type {string}
   * @memberof GroupWithMediums
   */
  permissions?: GroupWithMediumsPermissionsEnum
  /**
   * Resource URI for this group
   * @type {string}
   * @memberof GroupWithMediums
   */
  resource_uri?: string
  /**
   *
   * @type {number}
   * @memberof GroupWithMediums
   */
  share_invite_count?: number | null
  /**
   * The number of contacts that are a memeber of this group
   * @type {number}
   * @memberof GroupWithMediums
   */
  size?: number | null
  /**
   * The \"keyword\" used to text-to-join  Defaults to the group name lowercased, without any spaces and not duplicate by appending an incrementing number if needed
   * @type {string}
   * @memberof GroupWithMediums
   */
  slug?: string
  /**
   * Whether to enable text-to-join functionality for this group
   * @type {boolean}
   * @memberof GroupWithMediums
   */
  text_to_subscribe?: boolean
  /**
   * A custom response sent when someone texts-to-join this group
   * @type {string}
   * @memberof GroupWithMediums
   */
  ttjResponse?: string
  /**
   * This is used internally and may be expanded upon or removed in the future
   * @type {string}
   * @memberof GroupWithMediums
   */
  mediums?: string | null
}

/**
 * @export
 * @enum {string}
 */
export enum GroupWithMediumsPermissionsEnum {
  Write = 'write',
}

/**
 *
 * @export
 * @interface IdBoth
 */
export interface IdBoth {}
/**
 * Inbound attachment
 * @export
 * @interface InboundAttachment
 */
export interface InboundAttachment {
  /**
   *
   * @type {string}
   * @memberof InboundAttachment
   */
  container?: InboundAttachmentContainerEnum
  /**
   *
   * @type {string}
   * @memberof InboundAttachment
   */
  filename?: string
  /**
   *
   * @type {string}
   * @memberof InboundAttachment
   */
  id?: string
  /**
   * Size of attachment in bytes
   * @type {number}
   * @memberof InboundAttachment
   */
  size?: number
  /**
   *
   * @type {string}
   * @memberof InboundAttachment
   */
  key?: string
  /**
   *
   * @type {string}
   * @memberof InboundAttachment
   */
  url?: string
  /**
   * Mimetype of the attachment
   * @type {string}
   * @memberof InboundAttachment
   */
  type?: string
}

/**
 * @export
 * @enum {string}
 */
export enum InboundAttachmentContainerEnum {
  SendhubAttachments = 'sendhub-attachments',
}

/**
 *
 * @export
 * @interface InboxThread
 */
export interface InboxThread {
  /**
   *
   * @type {Array<{ [key: string]: string; }>}
   * @memberof InboxThread
   */
  contacts?: Array<{ [key: string]: string }>
  /**
   * A UTC timestamp  `2021-08-01T03:48:55.350453` equals August 1st, 2021 at 3:48 and 55.350453 seconds AM (UTC)
   * @type {string}
   * @memberof InboxThread
   */
  created_at?: string
  /**
   *
   * @type {boolean}
   * @memberof InboxThread
   */
  deleted?: boolean
  /**
   *
   * @type {string}
   * @memberof InboxThread
   */
  direction?: InboxThreadDirectionEnum
  /**
   *
   * @type {Array<InlineResponse2001Groups>}
   * @memberof InboxThread
   */
  groups?: Array<InlineResponse2001Groups>
  /**
   * Id of the last message in this thread
   * @type {string}
   * @memberof InboxThread
   */
  id?: string
  /**
   *
   * @type {Array<string>}
   * @memberof InboxThread
   */
  labels?: Array<string>
  /**
   *
   * @type {string}
   * @memberof InboxThread
   */
  last_read_at?: string
  /**
   * A UTC timestamp  `2021-08-01T03:48:55.350453` equals August 1st, 2021 at 3:48 and 55.350453 seconds AM (UTC)
   * @type {string}
   * @memberof InboxThread
   */
  modified_at?: string
  /**
   *
   * @type {string}
   * @memberof InboxThread
   */
  resource_uri?: string
  /**
   * The date & time **in UTC** to schedule the message to be sent at.  **Note:** it **must** be exactly 24-characters long and in this format: `2022-04-13T15:29:40+0000`
   * @type {string}
   * @memberof InboxThread
   */
  scheduled_at?: string | null
  /**
   * A UTC timestamp  `2021-08-01T03:48:55.350453` equals August 1st, 2021 at 3:48 and 55.350453 seconds AM (UTC)
   * @type {string}
   * @memberof InboxThread
   */
  sent?: string
  /**
   *
   * @type {string}
   * @memberof InboxThread
   */
  text?: string
  /**
   * The thread ID
   * @type {string}
   * @memberof InboxThread
   */
  threadId?: string
  /**
   * The message type of the last item in the thread
   * @type {string}
   * @memberof InboxThread
   */
  type?: InboxThreadTypeEnum
  /**
   * Whether or not the message is marked as unread Changing this will mark the corresponding thread as read or unread
   * @type {boolean}
   * @memberof InboxThread
   */
  unread?: boolean | null
}

/**
 * @export
 * @enum {string}
 */
export enum InboxThreadDirectionEnum {
  OutboundApi = 'outbound-api',
  Incoming = 'incoming',
}
/**
 * @export
 * @enum {string}
 */
export enum InboxThreadTypeEnum {
  VoicecallIn = 'voicecall-in',
  VoicecallOut = 'voicecall-out',
  VoicecallMissed = 'voicecall-missed',
  VoicecallVoicemail = 'voicecall-voicemail',
  MessageOut = 'message-out',
  MessageIn = 'message-in',
}

/**
 *
 * @export
 * @interface InlineObject
 */
export interface InlineObject {
  /**
   * The group\'s name
   * @type {string}
   * @memberof InlineObject
   */
  name: string
  /**
   * Whether the group is shared between the lines
   * @type {boolean}
   * @memberof InlineObject
   */
  is_shared?: boolean
  /**
   * The \"keyword\" used to text-to-join  Defaults to the group name lowercased, without any spaces and not duplicate by appending an incrementing number if needed
   * @type {string}
   * @memberof InlineObject
   */
  slug?: string
  /**
   * This is used internally and may be expanded upon or removed in the future
   * @type {string}
   * @memberof InlineObject
   */
  mediums?: string | null
  /**
   *
   * @type {string}
   * @memberof InlineObject
   */
  permissions?: InlineObjectPermissionsEnum
  /**
   * Whether to enable text-to-join functionality for this group
   * @type {boolean}
   * @memberof InlineObject
   */
  text_to_subscribe?: boolean
  /**
   * A custom response sent when someone texts-to-join this group
   * @type {string}
   * @memberof InlineObject
   */
  ttjResponse?: string
}

/**
 * @export
 * @enum {string}
 */
export enum InlineObjectPermissionsEnum {
  Write = 'write',
}

/**
 *
 * @export
 * @interface InlineObject1
 */
export interface InlineObject1 {
  /**
   * The group\'s name
   * @type {string}
   * @memberof InlineObject1
   */
  name: string
  /**
   * Whether the group is shared between the lines
   * @type {boolean}
   * @memberof InlineObject1
   */
  is_shared?: boolean
  /**
   * The \"keyword\" used to text-to-join  Defaults to the group name lowercased, without any spaces and not duplicate by appending an incrementing number if needed
   * @type {string}
   * @memberof InlineObject1
   */
  slug?: string
  /**
   * This is used internally and may be expanded upon or removed in the future
   * @type {string}
   * @memberof InlineObject1
   */
  mediums?: string | null
  /**
   *
   * @type {string}
   * @memberof InlineObject1
   */
  permissions?: InlineObject1PermissionsEnum
  /**
   * Whether to enable text-to-join functionality for this group
   * @type {boolean}
   * @memberof InlineObject1
   */
  text_to_subscribe?: boolean
  /**
   * A custom response sent when someone texts-to-join this group
   * @type {string}
   * @memberof InlineObject1
   */
  ttjResponse?: string
  /**
   * The contact ID
   * @type {string}
   * @memberof InlineObject1
   */
  id: string
}

/**
 * @export
 * @enum {string}
 */
export enum InlineObject1PermissionsEnum {
  Write = 'write',
}

/**
 *
 * @export
 * @interface InlineObject2
 */
export interface InlineObject2 {
  /**
   *
   * @type {AuthenticationType}
   * @memberof InlineObject2
   */
  authenticationType?: AuthenticationType
  /**
   *
   * @type {string}
   * @memberof InlineObject2
   */
  sessionId?: string
  /**
   *
   * @type {string}
   * @memberof InlineObject2
   */
  username?: string
  /**
   *
   * @type {string}
   * @memberof InlineObject2
   */
  password?: string
}
/**
 *
 * @export
 * @interface InlineResponse200
 */
export interface InlineResponse200 {
  /**
   *
   * @type {InlineResponse200Meta}
   * @memberof InlineResponse200
   */
  meta?: InlineResponse200Meta
  /**
   *
   * @type {Array<InlineResponse200Objects>}
   * @memberof InlineResponse200
   */
  objects?: Array<InlineResponse200Objects>
}
/**
 *
 * @export
 * @interface InlineResponse2001
 */
export interface InlineResponse2001 {
  /**
   *
   * @type {InlineResponse200Meta}
   * @memberof InlineResponse2001
   */
  meta?: InlineResponse200Meta
  /**
   *
   * @type {Array<InlineResponse2001Objects>}
   * @memberof InlineResponse2001
   */
  objects?: Array<InlineResponse2001Objects>
}
/**
 *
 * @export
 * @interface InlineResponse2001Groups
 */
export interface InlineResponse2001Groups {
  /**
   * The group ID
   * @type {string}
   * @memberof InlineResponse2001Groups
   */
  id?: string
  /**
   * Same as id but always a string
   * @type {string}
   * @memberof InlineResponse2001Groups
   */
  id_str?: string
  /**
   * The group\'s name
   * @type {string}
   * @memberof InlineResponse2001Groups
   */
  name?: string
  /**
   * The \"keyword\" used to text-to-join  Defaults to the group name lowercased, without any spaces and not duplicate by appending an incrementing number if needed
   * @type {string}
   * @memberof InlineResponse2001Groups
   */
  slug?: string
  /**
   * Whether to enable text-to-join functionality for this group
   * @type {boolean}
   * @memberof InlineResponse2001Groups
   */
  text_to_subscribe?: boolean
  /**
   * This is used internally and may be expanded upon or removed in the future
   * @type {string}
   * @memberof InlineResponse2001Groups
   */
  mediums?: string | null
  /**
   * This is used internally and may be expanded upon or removed in the future
   * @type {boolean}
   * @memberof InlineResponse2001Groups
   */
  check_all?: boolean
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse2001Groups
   */
  deleted?: boolean
  /**
   * A custom response sent when someone texts-to-join this group
   * @type {string}
   * @memberof InlineResponse2001Groups
   */
  ttjResponse?: string
}
/**
 *
 * @export
 * @interface InlineResponse2001Objects
 */
export interface InlineResponse2001Objects {
  /**
   *
   * @type {Array<{ [key: string]: string; }>}
   * @memberof InlineResponse2001Objects
   */
  contacts?: Array<{ [key: string]: string }>
  /**
   * A UTC timestamp  `2021-08-01T03:48:55.350453` equals August 1st, 2021 at 3:48 and 55.350453 seconds AM (UTC)
   * @type {string}
   * @memberof InlineResponse2001Objects
   */
  created_at?: string
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse2001Objects
   */
  deleted?: boolean
  /**
   *
   * @type {string}
   * @memberof InlineResponse2001Objects
   */
  direction?: InlineResponse2001ObjectsDirectionEnum
  /**
   *
   * @type {Array<InlineResponse2001Groups>}
   * @memberof InlineResponse2001Objects
   */
  groups?: Array<InlineResponse2001Groups>
  /**
   * Id of the last message in this thread
   * @type {string}
   * @memberof InlineResponse2001Objects
   */
  id?: string
  /**
   *
   * @type {Array<string>}
   * @memberof InlineResponse2001Objects
   */
  labels?: Array<string>
  /**
   *
   * @type {string}
   * @memberof InlineResponse2001Objects
   */
  last_read_at?: string
  /**
   * A UTC timestamp  `2021-08-01T03:48:55.350453` equals August 1st, 2021 at 3:48 and 55.350453 seconds AM (UTC)
   * @type {string}
   * @memberof InlineResponse2001Objects
   */
  modified_at?: string
  /**
   *
   * @type {string}
   * @memberof InlineResponse2001Objects
   */
  resource_uri?: string
  /**
   * The date & time **in UTC** to schedule the message to be sent at.  **Note:** it **must** be exactly 24-characters long and in this format: `2022-04-13T15:29:40+0000`
   * @type {string}
   * @memberof InlineResponse2001Objects
   */
  scheduled_at?: string | null
  /**
   * A UTC timestamp  `2021-08-01T03:48:55.350453` equals August 1st, 2021 at 3:48 and 55.350453 seconds AM (UTC)
   * @type {string}
   * @memberof InlineResponse2001Objects
   */
  sent?: string
  /**
   *
   * @type {string}
   * @memberof InlineResponse2001Objects
   */
  text?: string
  /**
   * The thread ID
   * @type {string}
   * @memberof InlineResponse2001Objects
   */
  threadId?: string
  /**
   * The message type of the last item in the thread
   * @type {string}
   * @memberof InlineResponse2001Objects
   */
  type?: InlineResponse2001ObjectsTypeEnum
  /**
   * Whether or not the message is marked as unread Changing this will mark the corresponding thread as read or unread
   * @type {boolean}
   * @memberof InlineResponse2001Objects
   */
  unread?: boolean | null
}

/**
 * @export
 * @enum {string}
 */
export enum InlineResponse2001ObjectsDirectionEnum {
  OutboundApi = 'outbound-api',
  Incoming = 'incoming',
}
/**
 * @export
 * @enum {string}
 */
export enum InlineResponse2001ObjectsTypeEnum {
  VoicecallIn = 'voicecall-in',
  VoicecallOut = 'voicecall-out',
  VoicecallMissed = 'voicecall-missed',
  VoicecallVoicemail = 'voicecall-voicemail',
  MessageOut = 'message-out',
  MessageIn = 'message-in',
}

/**
 *
 * @export
 * @interface InlineResponse2002
 */
export interface InlineResponse2002 {
  /**
   *
   * @type {InlineResponse2002Meta}
   * @memberof InlineResponse2002
   */
  meta?: InlineResponse2002Meta
  /**
   *
   * @type {Array<InlineResponse2002Objects>}
   * @memberof InlineResponse2002
   */
  objects?: Array<InlineResponse2002Objects>
}
/**
 *
 * @export
 * @interface InlineResponse2002Meta
 */
export interface InlineResponse2002Meta {
  /**
   *
   * @type {number}
   * @memberof InlineResponse2002Meta
   */
  offset?: number
  /**
   *
   * @type {number}
   * @memberof InlineResponse2002Meta
   */
  limit?: number
  /**
   *
   * @type {string}
   * @memberof InlineResponse2002Meta
   */
  previous?: string | null
  /**
   *
   * @type {string}
   * @memberof InlineResponse2002Meta
   */
  next?: string | null
  /**
   * Whether this thread has messages marked as unread or not
   * @type {boolean}
   * @memberof InlineResponse2002Meta
   */
  hasUnread?: boolean
  /**
   *
   * @type {Array<string>}
   * @memberof InlineResponse2002Meta
   */
  labels?: Array<string>
}
/**
 *
 * @export
 * @interface InlineResponse2002Objects
 */
export interface InlineResponse2002Objects {
  /**
   * List of attachments
   * @type {Array<object>}
   * @memberof InlineResponse2002Objects
   */
  attachments?: Array<object>
  /**
   *
   * @type {Array<{ [key: string]: string; }>}
   * @memberof InlineResponse2002Objects
   */
  contacts?: Array<{ [key: string]: string }>
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse2002Objects
   */
  deleted?: boolean
  /**
   * The direction of the message; `to` or `from` the contact
   * @type {string}
   * @memberof InlineResponse2002Objects
   */
  direction?: InlineResponse2002ObjectsDirectionEnum
  /**
   *
   * @type {Array<InlineResponse2001Groups>}
   * @memberof InlineResponse2002Objects
   */
  groups?: Array<InlineResponse2001Groups>
  /**
   * This is used internally and may be expanded upon or removed in the future
   * @type {string}
   * @memberof InlineResponse2002Objects
   */
  hash?: string
  /**
   *
   * @type {string}
   * @memberof InlineResponse2002Objects
   */
  id?: string
  /**
   * A UTC timestamp  `2021-08-01T03:48:55.350453` equals August 1st, 2021 at 3:48 and 55.350453 seconds AM (UTC)
   * @type {string}
   * @memberof InlineResponse2002Objects
   */
  modified_at?: string
  /**
   * Resource URI for this message
   * @type {string}
   * @memberof InlineResponse2002Objects
   */
  resource_uri?: string
  /**
   * The date & time **in UTC** the message was scheduled to be sent at.
   * @type {string}
   * @memberof InlineResponse2002Objects
   */
  scheduled_at?: string | null
  /**
   * The date & time **in UTC** the message was sent at.
   * @type {string}
   * @memberof InlineResponse2002Objects
   */
  sent?: string | null
  /**
   * A short link generated by SendHub when you send a message with an attachment or with `force_shortlink_creation` set to `true`
   * @type {string}
   * @memberof InlineResponse2002Objects
   */
  shortlink?: string
  /**
   * The text content of the message **Note:** Be sure you understand SMS segmenting ((learn more here)[https://sendhub.force.com/support/s/article/how-am-i-billed-for-long-messages])
   * @type {string}
   * @memberof InlineResponse2002Objects
   */
  text?: string
  /**
   * The type of the message (if on the thread object, then the type of the last message in the thread)
   * @type {string}
   * @memberof InlineResponse2002Objects
   */
  type?: InlineResponse2002ObjectsTypeEnum
  /**
   * Whether or not the thread is marked as unread
   * @type {boolean}
   * @memberof InlineResponse2002Objects
   */
  unread?: boolean
}

/**
 * @export
 * @enum {string}
 */
export enum InlineResponse2002ObjectsDirectionEnum {
  To = 'to',
  From = 'from',
}
/**
 * @export
 * @enum {string}
 */
export enum InlineResponse2002ObjectsTypeEnum {
  VoicecallIn = 'voicecall-in',
  VoicecallOut = 'voicecall-out',
  VoicecallMissed = 'voicecall-missed',
  VoicecallVoicemail = 'voicecall-voicemail',
  MessageOut = 'message-out',
  MessageIn = 'message-in',
}

/**
 *
 * @export
 * @interface InlineResponse2003
 */
export interface InlineResponse2003 {
  /**
   *
   * @type {string}
   * @memberof InlineResponse2003
   */
  message?: string
}
/**
 *
 * @export
 * @interface InlineResponse2004
 */
export interface InlineResponse2004 {
  /**
   * Success message
   * @type {string}
   * @memberof InlineResponse2004
   */
  message?: string
}
/**
 *
 * @export
 * @interface InlineResponse2005
 */
export interface InlineResponse2005 {
  /**
   *
   * @type {Array<object>}
   * @memberof InlineResponse2005
   */
  objects?: Array<object>
}
/**
 *
 * @export
 * @interface InlineResponse2006
 */
export interface InlineResponse2006 {
  /**
   *
   * @type {string}
   * @memberof InlineResponse2006
   */
  authToken?: string
  /**
   *
   * @type {string}
   * @memberof InlineResponse2006
   */
  authenticationType?: InlineResponse2006AuthenticationTypeEnum
  /**
   *
   * @type {string}
   * @memberof InlineResponse2006
   */
  csrf_token?: string
  /**
   *
   * @type {string}
   * @memberof InlineResponse2006
   */
  emailAddress?: string
  /**
   *
   * @type {string}
   * @memberof InlineResponse2006
   */
  kazooApiPassword?: string | null
  /**
   * Always giong to return \'******\'
   * @type {string}
   * @memberof InlineResponse2006
   */
  password?: string
  /**
   *
   * @type {string}
   * @memberof InlineResponse2006
   */
  resource_uri?: InlineResponse2006ResourceUriEnum
  /**
   * This line\'s SendHub number (E.164 format)
   * @type {string}
   * @memberof InlineResponse2006
   */
  sendhub_number?: string
  /**
   *
   * @type {InlineResponse2006Settings}
   * @memberof InlineResponse2006
   */
  settings?: InlineResponse2006Settings
  /**
   *
   * @type {string}
   * @memberof InlineResponse2006
   */
  sipDeviceId?: string | null
  /**
   *
   * @type {string}
   * @memberof InlineResponse2006
   */
  sipPassword?: string | null
  /**
   * The ID of a SendHub user (an individual line)
   * @type {string}
   * @memberof InlineResponse2006
   */
  user_id?: string
  /**
   * User\'s (SendHub line\'s) username
   * @type {string}
   * @memberof InlineResponse2006
   */
  username?: string
}

/**
 * @export
 * @enum {string}
 */
export enum InlineResponse2006AuthenticationTypeEnum {
  Sendhub = 'sendhub',
  Manager = 'manager',
}
/**
 * @export
 * @enum {string}
 */
export enum InlineResponse2006ResourceUriEnum {
  ApiV1Auth = '/api/v1/auth',
}

/**
 *
 * @export
 * @interface InlineResponse2006Settings
 */
export interface InlineResponse2006Settings {
  /**
   *
   * @type {string}
   * @memberof InlineResponse2006Settings
   */
  automated_sms_response?: string | null
  /**
   *
   * @type {string}
   * @memberof InlineResponse2006Settings
   */
  customer_id?: string | null
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse2006Settings
   */
  deleted?: boolean | null
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse2006Settings
   */
  disable_incoming_sms?: boolean
  /**
   * How manu Users (lines) your account has
   * @type {number}
   * @memberof InlineResponse2006Settings
   */
  enterprise?: number
  /**
   *
   * @type {string}
   * @memberof InlineResponse2006Settings
   */
  entitlement?: string | null
  /**
   *
   * @type {string | number}
   * @memberof InlineResponse2006Settings
   */
  id?: string | number
  /**
   * Whether this user\'s email has been verified
   * @type {boolean}
   * @memberof InlineResponse2006Settings
   */
  is_verified_email?: boolean
  /**
   *
   * @type {string}
   * @memberof InlineResponse2006Settings
   */
  mixpanelid?: string | null
  /**
   * This is used internally and may be expanded upon or removed in the future
   * @type {boolean}
   * @memberof InlineResponse2006Settings
   */
  onboarding_mobile_finished?: boolean
  /**
   * This is used internally and may be expanded upon or removed in the future
   * @type {boolean}
   * @memberof InlineResponse2006Settings
   */
  onboarding_web_finished?: boolean
  /**
   * Your plan\'s payment schedule type: 1. Monthly 2. Yearly 3. Consumable (eg. free trial)
   * @type {number}
   * @memberof InlineResponse2006Settings
   */
  payment_schedule?: number
  /**
   *
   * @type {string}
   * @memberof InlineResponse2006Settings
   */
  pending_email?: string | null
  /**
   *
   * @type {string}
   * @memberof InlineResponse2006Settings
   */
  pending_phone_number?: string | null
  /**
   * The `Personal Cell` number in your [My Settings page](https://app.sendhub.com/settings)
   * @type {string}
   * @memberof InlineResponse2006Settings
   */
  phone_number?: string
  /**
   *
   * @type {string}
   * @memberof InlineResponse2006Settings
   */
  registration_status?: InlineResponse2006SettingsRegistrationStatusEnum
  /**
   *
   * @type {string}
   * @memberof InlineResponse2006Settings
   */
  settings_json?: string
  /**
   *
   * @type {string}
   * @memberof InlineResponse2006Settings
   */
  siftScienceLabel?: string | null
  /**
   * Signature that the SendHub apps append to new messages **Note:** SendHub does not use this field when sending via the API
   * @type {string}
   * @memberof InlineResponse2006Settings
   */
  signature?: string
  /**
   *
   * @type {number}
   * @memberof InlineResponse2006Settings
   */
  smsForwardingNumber?: number | null
  /**
   * This is used internally and may be expanded upon or removed in the future
   * @type {string | number}
   * @memberof InlineResponse2006Settings
   */
  twilio_phone_number?: string | number
  /**
   *
   * @type {number}
   * @memberof InlineResponse2006Settings
   */
  user?: number
  /**
   *
   * @type {string}
   * @memberof InlineResponse2006Settings
   */
  _payment_plan?: string | null
}

/**
 * @export
 * @enum {string}
 */
export enum InlineResponse2006SettingsRegistrationStatusEnum {
  Created = 'created',
  EmailVerified = 'email_verified',
  PaymentMethodAbsent = 'payment_method_absent',
  Completed = 'completed',
}

/**
 *
 * @export
 * @interface InlineResponse200Meta
 */
export interface InlineResponse200Meta {
  /**
   *
   * @type {number}
   * @memberof InlineResponse200Meta
   */
  offset?: number
  /**
   *
   * @type {number}
   * @memberof InlineResponse200Meta
   */
  limit?: number
  /**
   *
   * @type {string}
   * @memberof InlineResponse200Meta
   */
  previous?: string | null
  /**
   *
   * @type {string}
   * @memberof InlineResponse200Meta
   */
  next?: string | null
}
/**
 *
 * @export
 * @interface InlineResponse200Objects
 */
export interface InlineResponse200Objects {
  /**
   * A UTC timestamp  `2021-08-01T03:48:55.350453` equals August 1st, 2021 at 3:48 and 55.350453 seconds AM (UTC)
   * @type {string}
   * @memberof InlineResponse200Objects
   */
  date_created?: string
  /**
   * A UTC timestamp  `2021-08-01T03:48:55.350453` equals August 1st, 2021 at 3:48 and 55.350453 seconds AM (UTC)
   * @type {string}
   * @memberof InlineResponse200Objects
   */
  date_modified?: string
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse200Objects
   */
  deleted?: boolean
  /**
   * The group ID
   * @type {string}
   * @memberof InlineResponse200Objects
   */
  id?: string
  /**
   * Same as id but always a string
   * @type {string}
   * @memberof InlineResponse200Objects
   */
  id_str?: string
  /**
   * Whether the group is shared between the lines
   * @type {boolean}
   * @memberof InlineResponse200Objects
   */
  is_shared?: boolean
  /**
   * The group\'s name
   * @type {string}
   * @memberof InlineResponse200Objects
   */
  name?: string
  /**
   *
   * @type {string}
   * @memberof InlineResponse200Objects
   */
  parent_id?: string | null
  /**
   *
   * @type {string}
   * @memberof InlineResponse200Objects
   */
  parent_user_id?: string | null
  /**
   *
   * @type {string}
   * @memberof InlineResponse200Objects
   */
  permissions?: InlineResponse200ObjectsPermissionsEnum
  /**
   * Resource URI for this group
   * @type {string}
   * @memberof InlineResponse200Objects
   */
  resource_uri?: string
  /**
   *
   * @type {number}
   * @memberof InlineResponse200Objects
   */
  share_invite_count?: number | null
  /**
   * The number of contacts that are a memeber of this group
   * @type {number}
   * @memberof InlineResponse200Objects
   */
  size?: number | null
  /**
   * The \"keyword\" used to text-to-join  Defaults to the group name lowercased, without any spaces and not duplicate by appending an incrementing number if needed
   * @type {string}
   * @memberof InlineResponse200Objects
   */
  slug?: string
  /**
   * Whether to enable text-to-join functionality for this group
   * @type {boolean}
   * @memberof InlineResponse200Objects
   */
  text_to_subscribe?: boolean
  /**
   * A custom response sent when someone texts-to-join this group
   * @type {string}
   * @memberof InlineResponse200Objects
   */
  ttjResponse?: string
}

/**
 * @export
 * @enum {string}
 */
export enum InlineResponse200ObjectsPermissionsEnum {
  Write = 'write',
}

/**
 *
 * @export
 * @interface InlineResponse201
 */
export interface InlineResponse201 {
  /**
   * A UTC timestamp  `2021-08-01T03:48:55.350453` equals August 1st, 2021 at 3:48 and 55.350453 seconds AM (UTC)
   * @type {string}
   * @memberof InlineResponse201
   */
  date_created?: string
  /**
   * A UTC timestamp  `2021-08-01T03:48:55.350453` equals August 1st, 2021 at 3:48 and 55.350453 seconds AM (UTC)
   * @type {string}
   * @memberof InlineResponse201
   */
  date_modified?: string
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse201
   */
  deleted?: boolean
  /**
   * The group ID
   * @type {string}
   * @memberof InlineResponse201
   */
  id?: string
  /**
   * Same as id but always a string
   * @type {string}
   * @memberof InlineResponse201
   */
  id_str?: string
  /**
   * Whether the group is shared between the lines
   * @type {boolean}
   * @memberof InlineResponse201
   */
  is_shared?: boolean
  /**
   * The group\'s name
   * @type {string}
   * @memberof InlineResponse201
   */
  name?: string
  /**
   *
   * @type {string}
   * @memberof InlineResponse201
   */
  parent_id?: string | null
  /**
   *
   * @type {string}
   * @memberof InlineResponse201
   */
  parent_user_id?: string | null
  /**
   *
   * @type {string}
   * @memberof InlineResponse201
   */
  permissions?: InlineResponse201PermissionsEnum
  /**
   * Resource URI for this group
   * @type {string}
   * @memberof InlineResponse201
   */
  resource_uri?: string
  /**
   *
   * @type {number}
   * @memberof InlineResponse201
   */
  share_invite_count?: number | null
  /**
   * The number of contacts that are a memeber of this group
   * @type {number}
   * @memberof InlineResponse201
   */
  size?: number | null
  /**
   * The \"keyword\" used to text-to-join  Defaults to the group name lowercased, without any spaces and not duplicate by appending an incrementing number if needed
   * @type {string}
   * @memberof InlineResponse201
   */
  slug?: string
  /**
   * Whether to enable text-to-join functionality for this group
   * @type {boolean}
   * @memberof InlineResponse201
   */
  text_to_subscribe?: boolean
  /**
   * A custom response sent when someone texts-to-join this group
   * @type {string}
   * @memberof InlineResponse201
   */
  ttjResponse?: string
  /**
   * This is used internally and may be expanded upon or removed in the future
   * @type {string}
   * @memberof InlineResponse201
   */
  mediums?: string | null
}

/**
 * @export
 * @enum {string}
 */
export enum InlineResponse201PermissionsEnum {
  Write = 'write',
}

/**
 * Successfully queued or scheduled the message for sending
 * @export
 * @interface InlineResponse2011
 */
export interface InlineResponse2011 {
  /**
   *
   * @type {string}
   * @memberof InlineResponse2011
   */
  acknowledgment: string | null
  /**
   *
   * @type {Array<object>}
   * @memberof InlineResponse2011
   */
  contacts: Array<object>
  /**
   * UTC timestamp of when the message was created
   * @type {string}
   * @memberof InlineResponse2011
   */
  created_at: string
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse2011
   */
  deleted: boolean
  /**
   * The direction of the message; `to` or `from` the contact
   * @type {string}
   * @memberof InlineResponse2011
   */
  direction: InlineResponse2011DirectionEnum
  /**
   * If `true`, creates a shortlink for this message regardless if there\'s an attachment.
   * @type {boolean}
   * @memberof InlineResponse2011
   */
  force_shortlink_creation: boolean
  /**
   *
   * @type {Array<object>}
   * @memberof InlineResponse2011
   */
  groups: Array<object>
  /**
   *
   * @type {string}
   * @memberof InlineResponse2011
   */
  id: string
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse2011
   */
  id_is_thread_id: boolean
  /**
   *
   * @type {string}
   * @memberof InlineResponse2011
   */
  message_id: string
  /**
   *
   * @type {InlineResponse2011Mms}
   * @memberof InlineResponse2011
   */
  mms: InlineResponse2011Mms
  /**
   *
   * @type {string}
   * @memberof InlineResponse2011
   */
  modified_at: string
  /**
   *
   * @type {string}
   * @memberof InlineResponse2011
   */
  resource_uri: string
  /**
   * The date & time **in UTC** to schedule the message to be sent at.  **Note:** it **must** be exactly 24-characters long and in this format: `2022-04-13T15:29:40+0000`
   * @type {string}
   * @memberof InlineResponse2011
   */
  scheduled_at: string | null
  /**
   * The date & time **in UTC** the message was sent at.
   * @type {string}
   * @memberof InlineResponse2011
   */
  sent?: string | null
  /**
   *
   * @type {string}
   * @memberof InlineResponse2011
   */
  shortlink: string
  /**
   *
   * @type {string}
   * @memberof InlineResponse2011
   */
  text: string
  /**
   *
   * @type {string}
   * @memberof InlineResponse2011
   */
  thread_id: string
  /**
   *
   * @type {string}
   * @memberof InlineResponse2011
   */
  type: string
  /**
   * Whether or not the message is marked as unread Changing this will mark the corresponding thread as read or unread
   * @type {boolean}
   * @memberof InlineResponse2011
   */
  unread?: boolean | null
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse2011
   */
  via_shortcode: boolean
}

/**
 * @export
 * @enum {string}
 */
export enum InlineResponse2011DirectionEnum {
  To = 'to',
  From = 'from',
}

/**
 *
 * @export
 * @interface InlineResponse2011Mms
 */
export interface InlineResponse2011Mms {
  /**
   *
   * @type {string}
   * @memberof InlineResponse2011Mms
   */
  filename: string
}
/**
 *
 * @export
 * @interface InlineResponse202
 */
export interface InlineResponse202 {
  /**
   * Contact ids successfully added to this group
   * @type {Array<string | number>}
   * @memberof InlineResponse202
   */
  add?: Array<string | number>
  /**
   *
   * @type {object}
   * @memberof InlineResponse202
   */
  errors?: object
  /**
   * Contact ids successfully removed from this group
   * @type {Array<string | number>}
   * @memberof InlineResponse202
   */
  remove?: Array<string | number>
}
/**
 *
 * @export
 * @interface InlineResponse404
 */
export interface InlineResponse404 {
  /**
   *
   * @type {string}
   * @memberof InlineResponse404
   */
  error?: string
  /**
   *
   * @type {number}
   * @memberof InlineResponse404
   */
  status?: number
}
/**
 *
 * @export
 * @interface ListContacts200Response
 */
export interface ListContacts200Response {
  /**
   *
   * @type {Meta}
   * @memberof ListContacts200Response
   */
  meta?: Meta
  /**
   *
   * @type {Array<Contact>}
   * @memberof ListContacts200Response
   */
  objects?: Array<Contact>
}
/**
 *
 * @export
 * @interface ListContacts200Response1
 */
export interface ListContacts200Response1 {
  /**
   *
   * @type {Meta}
   * @memberof ListContacts200Response1
   */
  meta?: Meta
  /**
   *
   * @type {Array<Contact>}
   * @memberof ListContacts200Response1
   */
  objects?: Array<Contact>
}
/**
 *
 * @export
 * @interface ListGroups200Response
 */
export interface ListGroups200Response {
  /**
   *
   * @type {InlineResponse200Meta}
   * @memberof ListGroups200Response
   */
  meta?: InlineResponse200Meta
  /**
   *
   * @type {Array<InlineResponse200Objects>}
   * @memberof ListGroups200Response
   */
  objects?: Array<InlineResponse200Objects>
}
/**
 *
 * @export
 * @interface ListNestedUser
 */
export interface ListNestedUser {
  /**
   * A UTC timestamp  `2021-08-01T03:48:34` equals August 1st, 2021 at 3:48 and 34 seconds AM (UTC)
   * @type {string}
   * @memberof ListNestedUser
   */
  createdTs: string
  /**
   *
   * @type {boolean}
   * @memberof ListNestedUser
   */
  disable_incoming_sms: boolean
  /**
   * The enterprise ID
   * @type {string}
   * @memberof ListNestedUser
   */
  enterprise_id: string
  /**
   * The enterprise ID
   * @type {string}
   * @memberof ListNestedUser
   */
  enterprise_id_str: string
  /**
   *
   * @type {string}
   * @memberof ListNestedUser
   */
  id: string
  /**
   * Same as id but always a string
   * @type {string}
   * @memberof ListNestedUser
   */
  id_str: string
  /**
   * The URL for this user\'s profile image
   * @type {string}
   * @memberof ListNestedUser
   */
  image: string
  /**
   * Whether this user\'s email has been verified
   * @type {boolean}
   * @memberof ListNestedUser
   */
  is_verified_email: boolean
  /**
   * A UTC timestamp  `2021-08-01T03:48:34` equals August 1st, 2021 at 3:48 and 34 seconds AM (UTC)
   * @type {string}
   * @memberof ListNestedUser
   */
  modifiedTs: string
  /**
   * User\'s (SendHub line\'s) name
   * @type {string}
   * @memberof ListNestedUser
   */
  name: string
  /**
   * This is used internally and may be expanded upon or removed in the future
   * @type {boolean}
   * @memberof ListNestedUser
   */
  onboarding_mobile_finished: boolean
  /**
   * This is used internally and may be expanded upon or removed in the future
   * @type {boolean}
   * @memberof ListNestedUser
   */
  onboarding_web_finished: boolean
  /**
   *
   * @type {string}
   * @memberof ListNestedUser
   */
  payment_period_end: string
  /**
   *
   * @type {string}
   * @memberof ListNestedUser
   */
  payment_period_start: string
  /**
   * Your plan\'s payment schedule type: 1. Monthly 2. Yearly 3. Consumable (eg. free trial)
   * @type {string}
   * @memberof ListNestedUser
   */
  payment_schedule_id: ListNestedUserPaymentScheduleIdEnum
  /**
   * Phone number waiting to be verified for the \"Personal Cell\" field
   * @type {string}
   * @memberof ListNestedUser
   */
  pending_phone_number?: string
  /**
   * The `Personal Cell` number in your [My Settings page](https://app.sendhub.com/settings)
   * @type {string}
   * @memberof ListNestedUser
   */
  phone_number?: string
  /**
   *
   * @type {string}
   * @memberof ListNestedUser
   */
  registration_status: ListNestedUserRegistrationStatusEnum
  /**
   * This line\'s SendHub number (E.164 format)
   * @type {string}
   * @memberof ListNestedUser
   */
  sendhub_number: string
  /**
   *
   * @type {string}
   * @memberof ListNestedUser
   */
  settings_json: string
  /**
   * Signature that the SendHub apps append to new messages **Note:** SendHub does not use this field when sending via the API
   * @type {string}
   * @memberof ListNestedUser
   */
  signature: string
  /**
   * This is used internally and may be expanded upon or removed in the future
   * @type {string | number}
   * @memberof ListNestedUser
   */
  twilio_phone_number_id: string | number
  /**
   * This is used internally and may be expanded upon or removed in the future
   * @type {string | number}
   * @memberof ListNestedUser
   */
  twilio_phone_number_id_str: string | number
  /**
   * The ID of a SendHub user (an individual line)
   * @type {string}
   * @memberof ListNestedUser
   */
  user_id: string
  /**
   * The ID of a SendHub user (an individual line)
   * @type {string}
   * @memberof ListNestedUser
   */
  user_id_str: string
}

/**
 * @export
 * @enum {string}
 */
export enum ListNestedUserPaymentScheduleIdEnum {
  _1 = '1',
  _2 = '2',
  _3 = '3',
}
/**
 * @export
 * @enum {string}
 */
export enum ListNestedUserRegistrationStatusEnum {
  Created = 'created',
  EmailVerified = 'email_verified',
  PaymentMethodAbsent = 'payment_method_absent',
  Completed = 'completed',
}

/**
 *
 * @export
 * @interface ListScheduledMessagesResponse
 */
export interface ListScheduledMessagesResponse {
  /**
   *
   * @type {Array<object>}
   * @memberof ListScheduledMessagesResponse
   */
  objects?: Array<object>
}
/**
 *
 * @export
 * @interface ListThreads200Response
 */
export interface ListThreads200Response {
  /**
   *
   * @type {InlineResponse200Meta}
   * @memberof ListThreads200Response
   */
  meta?: InlineResponse200Meta
  /**
   *
   * @type {Array<InlineResponse2001Objects>}
   * @memberof ListThreads200Response
   */
  objects?: Array<InlineResponse2001Objects>
}
/**
 *
 * @export
 * @interface ListUsersResponse
 */
export interface ListUsersResponse {
  /**
   *
   * @type {InlineResponse200Meta}
   * @memberof ListUsersResponse
   */
  meta?: InlineResponse200Meta
  /**
   *
   * @type {Array<ListNestedUser>}
   * @memberof ListUsersResponse
   */
  objects?: Array<ListNestedUser>
}
/**
 *
 * @export
 * @interface Login200Response
 */
export interface Login200Response {
  /**
   *
   * @type {string}
   * @memberof Login200Response
   */
  authToken?: string
  /**
   *
   * @type {string}
   * @memberof Login200Response
   */
  authenticationType?: Login200ResponseAuthenticationTypeEnum
  /**
   *
   * @type {string}
   * @memberof Login200Response
   */
  csrf_token?: string
  /**
   *
   * @type {string}
   * @memberof Login200Response
   */
  emailAddress?: string
  /**
   *
   * @type {string}
   * @memberof Login200Response
   */
  kazooApiPassword?: string | null
  /**
   * Always giong to return \'******\'
   * @type {string}
   * @memberof Login200Response
   */
  password?: string
  /**
   *
   * @type {string}
   * @memberof Login200Response
   */
  resource_uri?: Login200ResponseResourceUriEnum
  /**
   * This line\'s SendHub number (E.164 format)
   * @type {string}
   * @memberof Login200Response
   */
  sendhub_number?: string
  /**
   *
   * @type {InlineResponse2006Settings}
   * @memberof Login200Response
   */
  settings?: InlineResponse2006Settings
  /**
   *
   * @type {string}
   * @memberof Login200Response
   */
  sipDeviceId?: string | null
  /**
   *
   * @type {string}
   * @memberof Login200Response
   */
  sipPassword?: string | null
  /**
   * The ID of a SendHub user (an individual line)
   * @type {string}
   * @memberof Login200Response
   */
  user_id?: string
  /**
   * User\'s (SendHub line\'s) username
   * @type {string}
   * @memberof Login200Response
   */
  username?: string
}

/**
 * @export
 * @enum {string}
 */
export enum Login200ResponseAuthenticationTypeEnum {
  Sendhub = 'sendhub',
  Manager = 'manager',
}
/**
 * @export
 * @enum {string}
 */
export enum Login200ResponseResourceUriEnum {
  ApiV1Auth = '/api/v1/auth',
}

/**
 *
 * @export
 * @interface LoginRequest
 */
export interface LoginRequest {
  /**
   *
   * @type {AuthenticationType}
   * @memberof LoginRequest
   */
  authenticationType?: AuthenticationType
  /**
   *
   * @type {string}
   * @memberof LoginRequest
   */
  sessionId?: string
  /**
   *
   * @type {string}
   * @memberof LoginRequest
   */
  username?: string
  /**
   *
   * @type {string}
   * @memberof LoginRequest
   */
  password?: string
}
/**
 *
 * @export
 * @interface Message
 */
export interface Message {
  /**
   *
   * @type {string}
   * @memberof Message
   */
  acknowledgment: string | null
  /**
   *
   * @type {Array<MessageNestedContact>}
   * @memberof Message
   */
  contacts: Array<MessageNestedContact>
  /**
   * A UTC timestamp  `2021-08-01T03:48:55.350453` equals August 1st, 2021 at 3:48 and 55.350453 seconds AM (UTC)
   * @type {string}
   * @memberof Message
   */
  created_at: string
  /**
   *
   * @type {boolean}
   * @memberof Message
   */
  deleted: boolean
  /**
   * The direction of the message; `outbound-api` or `incoming`
   * @type {string}
   * @memberof Message
   */
  direction: MessageDirectionEnum
  /**
   * If `true`, creates a shortlink for this message regardless if there\'s an attachment.
   * @type {boolean}
   * @memberof Message
   */
  force_shortlink_creation: boolean
  /**
   *
   * @type {Array<ScheduledNestedMessageGroups>}
   * @memberof Message
   */
  groups: Array<ScheduledNestedMessageGroups>
  /**
   * If `id_is_thread_id` is true, this is the `thread_id`, otherwise it\'s the `message_id`
   * @type {string}
   * @memberof Message
   */
  id: string
  /**
   * Determines whether `id` is the thread ID or the message ID
   * @type {boolean}
   * @memberof Message
   */
  id_is_thread_id: boolean
  /**
   * The message ID
   * @type {string}
   * @memberof Message
   */
  message_id: string
  /**
   * A UTC timestamp  `2021-08-01T03:48:55.350453` equals August 1st, 2021 at 3:48 and 55.350453 seconds AM (UTC)
   * @type {string}
   * @memberof Message
   */
  modified_at: string
  /**
   * Resource URI for this message
   * @type {string}
   * @memberof Message
   */
  resource_uri: string
  /**
   * The date & time **in UTC** to schedule the message to be sent at.  **Note:** it **must** be exactly 24-characters long and in this format: `2022-04-13T15:29:40+0000`
   * @type {string}
   * @memberof Message
   */
  scheduled_at: string | null
  /**
   * The date & time **in UTC** the message was sent at.
   * @type {string}
   * @memberof Message
   */
  sent: string | null
  /**
   * A short link generated by SendHub when you send a message with an attachment or with `force_shortlink_creation` set to `true`
   * @type {string}
   * @memberof Message
   */
  shortlink: string
  /**
   * The text content of the message **Note:** Be sure you understand SMS segmenting ((learn more here)[https://sendhub.force.com/support/s/article/how-am-i-billed-for-long-messages])
   * @type {string}
   * @memberof Message
   */
  text: string
  /**
   * The thread ID
   * @type {string}
   * @memberof Message
   */
  thread_id: string
  /**
   * The type of the message (if on the thread object, then the type of the last message in the thread)
   * @type {string}
   * @memberof Message
   */
  type: MessageTypeEnum
  /**
   * Whether or not the message is marked as unread Changing this will mark the corresponding thread as read or unread
   * @type {boolean}
   * @memberof Message
   */
  unread: boolean | null
  /**
   * Send the message via your account\'s Short Code number (requires a plan with Short Code access (learn more here)[https://sendhub.force.com/support/s/article/shortcode])
   * @type {boolean}
   * @memberof Message
   */
  via_shortcode: boolean
  /**
   *
   * @type {object}
   * @memberof Message
   */
  mms?: object
}

/**
 * @export
 * @enum {string}
 */
export enum MessageDirectionEnum {
  OutboundApi = 'outbound-api',
  Incoming = 'incoming',
}
/**
 * @export
 * @enum {string}
 */
export enum MessageTypeEnum {
  VoicecallIn = 'voicecall-in',
  VoicecallOut = 'voicecall-out',
  VoicecallMissed = 'voicecall-missed',
  VoicecallVoicemail = 'voicecall-voicemail',
  MessageOut = 'message-out',
  MessageIn = 'message-in',
}

/**
 * @type MessageIdBoth
 * @export
 */
export type MessageIdBoth = number | string

/**
 *
 * @export
 * @interface MessageNestedContact
 */
export interface MessageNestedContact {
  /**
   * Opt-out status (eg. if they texted `Stop`, `Cancel`, `Block`, `Quit` or `End` - [more info](https://sendhub.force.com/support/s/article/SendHub-Number-FAQ))
   * @type {boolean}
   * @memberof MessageNestedContact
   */
  blocked?: boolean
  /**
   *
   * @type {boolean}
   * @memberof MessageNestedContact
   */
  deleted?: boolean
  /**
   * The contact ID
   * @type {string}
   * @memberof MessageNestedContact
   */
  id?: string
  /**
   * Same as id but always a string
   * @type {string}
   * @memberof MessageNestedContact
   */
  id_str?: string
  /**
   * This is used internally and may be expanded upon or removed in the future
   * @type {boolean}
   * @memberof MessageNestedContact
   */
  is_owned?: boolean
  /**
   * The keyword must be unique and is generated by the contact\'s name by default. [Learn more about how contact keywords are used here.](https://sendhub.force.com/support/s/article/contacts-faq)
   * @type {string}
   * @memberof MessageNestedContact
   */
  keyword?: string
  /**
   * The contact\'s name
   * @type {string}
   * @memberof MessageNestedContact
   */
  name?: string
  /**
   * The contact\'s phone number
   * @type {string}
   * @memberof MessageNestedContact
   */
  number?: string
  /**
   * Whether the contact has been blocked by you
   * @type {boolean}
   * @memberof MessageNestedContact
   */
  screened?: boolean
  /**
   * The ID of a SendHub user (an individual line)
   * @type {string}
   * @memberof MessageNestedContact
   */
  user_id?: string
  /**
   * A UTC timestamp  `2021-08-01T03:48:34` equals August 1st, 2021 at 3:48 and 34 seconds AM (UTC)
   * @type {string}
   * @memberof MessageNestedContact
   */
  date_created?: string
  /**
   * A UTC timestamp  `2021-08-01T03:48:34` equals August 1st, 2021 at 3:48 and 34 seconds AM (UTC)
   * @type {string}
   * @memberof MessageNestedContact
   */
  date_modified?: string
  /**
   * JSON-escaped object containing this contact\'s custom field(s)
   * @type {string}
   * @memberof MessageNestedContact
   */
  extra_info?: string
  /**
   * This is used internally and may be expanded upon or removed in the future
   * @type {string}
   * @memberof MessageNestedContact
   */
  smsGateway?: string
}
/**
 *
 * @export
 * @interface MessageNestedGroup
 */
export interface MessageNestedGroup {
  /**
   * The group ID
   * @type {string}
   * @memberof MessageNestedGroup
   */
  id?: string
  /**
   * Same as id but always a string
   * @type {string}
   * @memberof MessageNestedGroup
   */
  id_str?: string
  /**
   * The group\'s name
   * @type {string}
   * @memberof MessageNestedGroup
   */
  name?: string
  /**
   * The \"keyword\" used to text-to-join  Defaults to the group name lowercased, without any spaces and not duplicate by appending an incrementing number if needed
   * @type {string}
   * @memberof MessageNestedGroup
   */
  slug?: string
  /**
   * Whether to enable text-to-join functionality for this group
   * @type {boolean}
   * @memberof MessageNestedGroup
   */
  text_to_subscribe?: boolean
  /**
   * This is used internally and may be expanded upon or removed in the future
   * @type {string}
   * @memberof MessageNestedGroup
   */
  mediums?: string | null
  /**
   * This is used internally and may be expanded upon or removed in the future
   * @type {boolean}
   * @memberof MessageNestedGroup
   */
  check_all?: boolean
  /**
   *
   * @type {boolean}
   * @memberof MessageNestedGroup
   */
  deleted?: boolean
  /**
   * A custom response sent when someone texts-to-join this group
   * @type {string}
   * @memberof MessageNestedGroup
   */
  ttjResponse?: string
  /**
   * A UTC timestamp  `2021-08-01T03:48:34` equals August 1st, 2021 at 3:48 and 34 seconds AM (UTC)
   * @type {string}
   * @memberof MessageNestedGroup
   */
  date_created?: string
  /**
   * A UTC timestamp  `2021-08-01T03:48:34` equals August 1st, 2021 at 3:48 and 34 seconds AM (UTC)
   * @type {string}
   * @memberof MessageNestedGroup
   */
  date_modified?: string
  /**
   * Whether the group is shared between the lines
   * @type {boolean}
   * @memberof MessageNestedGroup
   */
  is_shared?: boolean
  /**
   *
   * @type {string}
   * @memberof MessageNestedGroup
   */
  permissions?: MessageNestedGroupPermissionsEnum
  /**
   * The ID of a SendHub user (an individual line)
   * @type {string}
   * @memberof MessageNestedGroup
   */
  user_id?: string
}

/**
 * @export
 * @enum {string}
 */
export enum MessageNestedGroupPermissionsEnum {
  Write = 'write',
}

/**
 * The type of the message (if on the thread object, then the type of the last message in the thread)
 * @export
 * @enum {string}
 */
export enum MessageType {
  VoicecallIn = 'voicecall-in',
  VoicecallOut = 'voicecall-out',
  VoicecallMissed = 'voicecall-missed',
  VoicecallVoicemail = 'voicecall-voicemail',
  MessageOut = 'message-out',
  MessageIn = 'message-in',
}

/**
 *
 * @export
 * @interface Meta
 */
export interface Meta {
  /**
   *
   * @type {number}
   * @memberof Meta
   */
  offset?: number
  /**
   *
   * @type {number}
   * @memberof Meta
   */
  limit?: number
  /**
   *
   * @type {string}
   * @memberof Meta
   */
  previous?: string | null
  /**
   *
   * @type {string}
   * @memberof Meta
   */
  next?: string | null
}
/**
 * @type Mms
 * @export
 */
export type Mms = AttachmentViaBase64EncodedFile | AttachmentViaURL

/**
 * @type MmsOnlyFilename
 * @export
 */
export type MmsOnlyFilename = AttachmentViaBase64EncodedFile | AttachmentViaURL

/**
 *
 * @export
 * @interface NameErrorObject
 */
export interface NameErrorObject {
  /**
   *
   * @type {Array<string>}
   * @memberof NameErrorObject
   */
  name?: Array<string>
}
/**
 *
 * @export
 * @interface NameOrNumberError
 */
export interface NameOrNumberError {
  /**
   *
   * @type {Array<string>}
   * @memberof NameOrNumberError
   */
  name?: Array<string>
}
/**
 *
 * @export
 * @interface NameOrNumberErrorAnyOf
 */
export interface NameOrNumberErrorAnyOf {
  /**
   *
   * @type {Array<string>}
   * @memberof NameOrNumberErrorAnyOf
   */
  name?: Array<string>
}
/**
 *
 * @export
 * @interface NullableTimestamp
 */
export interface NullableTimestamp {}
/**
 *
 * @export
 * @interface NumberErrorObject
 */
export interface NumberErrorObject {
  /**
   *
   * @type {Array<string>}
   * @memberof NumberErrorObject
   */
  name?: Array<string>
}
/**
 * Outbound attachment
 * @export
 * @interface OutboundAttachment
 */
export interface OutboundAttachment {
  /**
   *
   * @type {string}
   * @memberof OutboundAttachment
   */
  container?: OutboundAttachmentContainerEnum
  /**
   *
   * @type {string}
   * @memberof OutboundAttachment
   */
  filename?: string
  /**
   *
   * @type {string}
   * @memberof OutboundAttachment
   */
  id?: string
  /**
   *
   * @type {boolean}
   * @memberof OutboundAttachment
   */
  isWriteable?: boolean
  /**
   *
   * @type {string}
   * @memberof OutboundAttachment
   */
  key?: string
  /**
   * Mimetype of the attachment
   * @type {string}
   * @memberof OutboundAttachment
   */
  mimetype?: string
  /**
   * Size of attachment in bytes
   * @type {number}
   * @memberof OutboundAttachment
   */
  size?: number
  /**
   *
   * @type {string}
   * @memberof OutboundAttachment
   */
  url?: string
}

/**
 * @export
 * @enum {string}
 */
export enum OutboundAttachmentContainerEnum {
  SendhubAttachments = 'sendhub-attachments',
}

/**
 * Your plan\'s payment schedule type: 1. Monthly 2. Yearly 3. Consumable (eg. free trial)
 * @export
 * @enum {string}
 */
export enum PaymentScheduleId {
  _1 = '1',
  _2 = '2',
  _3 = '3',
}

/**
 *
 * @export
 * @interface RateLimitingResponse
 */
export interface RateLimitingResponse {
  /**
   *
   * @type {string}
   * @memberof RateLimitingResponse
   */
  message?: string
  /**
   *
   * @type {string}
   * @memberof RateLimitingResponse
   */
  code?: string
  /**
   *
   * @type {string}
   * @memberof RateLimitingResponse
   */
  error?: string
  /**
   *
   * @type {string}
   * @memberof RateLimitingResponse
   */
  devMessage?: string
  /**
   *
   * @type {string}
   * @memberof RateLimitingResponse
   */
  moreInfo?: string
  /**
   *
   * @type {string}
   * @memberof RateLimitingResponse
   */
  timeLeft?: string
}
/**
 *
 * @export
 * @enum {string}
 */
export enum RegistrationStatus {
  Created = 'created',
  EmailVerified = 'email_verified',
  PaymentMethodAbsent = 'payment_method_absent',
  Completed = 'completed',
}

/**
 *
 * @export
 * @interface ScheduledNestedMessage
 */
export interface ScheduledNestedMessage {
  /**
   *
   * @type {Array<object>}
   * @memberof ScheduledNestedMessage
   */
  contacts: Array<object>
  /**
   * UTC timestamp of when the message was created
   * @type {string}
   * @memberof ScheduledNestedMessage
   */
  created_at: string
  /**
   *
   * @type {boolean}
   * @memberof ScheduledNestedMessage
   */
  deleted: boolean
  /**
   * The direction of the message; `outbound-api` or `incoming`
   * @type {string}
   * @memberof ScheduledNestedMessage
   */
  direction: ScheduledNestedMessageDirectionEnum
  /**
   *
   * @type {Array<ScheduledNestedMessageGroups>}
   * @memberof ScheduledNestedMessage
   */
  groups: Array<ScheduledNestedMessageGroups>
  /**
   * This is used internally and may be expanded upon or removed in the future
   * @type {string}
   * @memberof ScheduledNestedMessage
   */
  hash: string
  /**
   * The message ID
   * @type {string}
   * @memberof ScheduledNestedMessage
   */
  id: string
  /**
   * This is used internally and may be expanded upon or removed in the future
   * @type {string}
   * @memberof ScheduledNestedMessage
   */
  link: string
  /**
   * The message ID
   * @type {string}
   * @memberof ScheduledNestedMessage
   */
  message_id: string
  /**
   * UTC timestamp of when the message was last modified
   * @type {string}
   * @memberof ScheduledNestedMessage
   */
  modified_at: string
  /**
   * The date & time **in UTC** the message was scheduled to be sent at.
   * @type {string}
   * @memberof ScheduledNestedMessage
   */
  scheduled_at: string | null
  /**
   * The shortlink ID Note: This field won\'t show up if the message doesn\'t have a shortlink
   * @type {string}
   * @memberof ScheduledNestedMessage
   */
  shortlink_id?: string
  /**
   * The text content of the message **Note:** Be sure you understand SMS segmenting ((learn more here)[https://sendhub.force.com/support/s/article/how-am-i-billed-for-long-messages])
   * @type {string}
   * @memberof ScheduledNestedMessage
   */
  text: string
  /**
   * The thread ID
   * @type {string}
   * @memberof ScheduledNestedMessage
   */
  thread_id: string
  /**
   * The ID of a SendHub user (an individual line)
   * @type {string}
   * @memberof ScheduledNestedMessage
   */
  user_id: string
}

/**
 * @export
 * @enum {string}
 */
export enum ScheduledNestedMessageDirectionEnum {
  OutboundApi = 'outbound-api',
  Incoming = 'incoming',
}

/**
 *
 * @export
 * @interface ScheduledNestedMessageGroups
 */
export interface ScheduledNestedMessageGroups {
  /**
   * The group ID
   * @type {string}
   * @memberof ScheduledNestedMessageGroups
   */
  id?: string
  /**
   * Same as id but always a string
   * @type {string}
   * @memberof ScheduledNestedMessageGroups
   */
  id_str?: string
  /**
   * The group\'s name
   * @type {string}
   * @memberof ScheduledNestedMessageGroups
   */
  name?: string
  /**
   * The \"keyword\" used to text-to-join  Defaults to the group name lowercased, without any spaces and not duplicate by appending an incrementing number if needed
   * @type {string}
   * @memberof ScheduledNestedMessageGroups
   */
  slug?: string
  /**
   * Whether to enable text-to-join functionality for this group
   * @type {boolean}
   * @memberof ScheduledNestedMessageGroups
   */
  text_to_subscribe?: boolean
  /**
   * This is used internally and may be expanded upon or removed in the future
   * @type {string}
   * @memberof ScheduledNestedMessageGroups
   */
  mediums?: string | null
  /**
   * This is used internally and may be expanded upon or removed in the future
   * @type {boolean}
   * @memberof ScheduledNestedMessageGroups
   */
  check_all?: boolean
  /**
   *
   * @type {boolean}
   * @memberof ScheduledNestedMessageGroups
   */
  deleted?: boolean
  /**
   * A custom response sent when someone texts-to-join this group
   * @type {string}
   * @memberof ScheduledNestedMessageGroups
   */
  ttjResponse?: string
  /**
   * A UTC timestamp  `2021-08-01T03:48:34` equals August 1st, 2021 at 3:48 and 34 seconds AM (UTC)
   * @type {string}
   * @memberof ScheduledNestedMessageGroups
   */
  date_created?: string
  /**
   * A UTC timestamp  `2021-08-01T03:48:34` equals August 1st, 2021 at 3:48 and 34 seconds AM (UTC)
   * @type {string}
   * @memberof ScheduledNestedMessageGroups
   */
  date_modified?: string
  /**
   * Whether the group is shared between the lines
   * @type {boolean}
   * @memberof ScheduledNestedMessageGroups
   */
  is_shared?: boolean
  /**
   *
   * @type {string}
   * @memberof ScheduledNestedMessageGroups
   */
  permissions?: ScheduledNestedMessageGroupsPermissionsEnum
  /**
   * The ID of a SendHub user (an individual line)
   * @type {string}
   * @memberof ScheduledNestedMessageGroups
   */
  user_id?: string
}

/**
 * @export
 * @enum {string}
 */
export enum ScheduledNestedMessageGroupsPermissionsEnum {
  Write = 'write',
}

/**
 * @type SendMessageRequest
 * @export
 */
export type SendMessageRequest =
  | SendMessageRequestAtLeastContacts
  | SendMessageRequestAtLeastGroups
  | SendMessageRequestBoth

/**
 *
 * @export
 * @interface SendMessageRequestAtLeastContacts
 */
export interface SendMessageRequestAtLeastContacts {
  /**
   * The text content of the message **Note:** Be sure you understand SMS segmenting ((learn more here)[https://sendhub.force.com/support/s/article/how-am-i-billed-for-long-messages])
   * @type {string}
   * @memberof SendMessageRequestAtLeastContacts
   */
  text: string
  /**
   * The date & time **in UTC** to schedule the message to be sent at.  **Note:** it **must** be exactly 24-characters long and in this format: `2022-04-13T15:29:40+0000`
   * @type {string}
   * @memberof SendMessageRequestAtLeastContacts
   */
  scheduled_at?: string | null
  /**
   *
   * @type {object}
   * @memberof SendMessageRequestAtLeastContacts
   */
  mms?: object
  /**
   *
   * @type {Array<string | number | string>}
   * @memberof SendMessageRequestAtLeastContacts
   */
  contacts: Array<string | number | string>
}
/**
 *
 * @export
 * @interface SendMessageRequestAtLeastGroups
 */
export interface SendMessageRequestAtLeastGroups {
  /**
   * The text content of the message **Note:** Be sure you understand SMS segmenting ((learn more here)[https://sendhub.force.com/support/s/article/how-am-i-billed-for-long-messages])
   * @type {string}
   * @memberof SendMessageRequestAtLeastGroups
   */
  text: string
  /**
   * The date & time **in UTC** to schedule the message to be sent at.  **Note:** it **must** be exactly 24-characters long and in this format: `2022-04-13T15:29:40+0000`
   * @type {string}
   * @memberof SendMessageRequestAtLeastGroups
   */
  scheduled_at?: string | null
  /**
   *
   * @type {object}
   * @memberof SendMessageRequestAtLeastGroups
   */
  mms?: object
  /**
   * Group ids
   * @type {Array<string | number>}
   * @memberof SendMessageRequestAtLeastGroups
   */
  groups: Array<string | number>
}
/**
 *
 * @export
 * @interface SendMessageRequestBoth
 */
export interface SendMessageRequestBoth {
  /**
   * The text content of the message **Note:** Be sure you understand SMS segmenting ((learn more here)[https://sendhub.force.com/support/s/article/how-am-i-billed-for-long-messages])
   * @type {string}
   * @memberof SendMessageRequestBoth
   */
  text: string
  /**
   * The date & time **in UTC** to schedule the message to be sent at.  **Note:** it **must** be exactly 24-characters long and in this format: `2022-04-13T15:29:40+0000`
   * @type {string}
   * @memberof SendMessageRequestBoth
   */
  scheduled_at?: string | null
  /**
   *
   * @type {object}
   * @memberof SendMessageRequestBoth
   */
  mms?: object
  /**
   * Group ids
   * @type {Array<string | number>}
   * @memberof SendMessageRequestBoth
   */
  groups: Array<string | number>
  /**
   *
   * @type {Array<string | number | string>}
   * @memberof SendMessageRequestBoth
   */
  contacts: Array<string | number | string>
}
/**
 * Successfully queued or scheduled the message for sending
 * @export
 * @interface SendMessageResponse
 */
export interface SendMessageResponse {
  /**
   *
   * @type {string}
   * @memberof SendMessageResponse
   */
  acknowledgment: string | null
  /**
   *
   * @type {Array<object>}
   * @memberof SendMessageResponse
   */
  contacts: Array<object>
  /**
   * UTC timestamp of when the message was created
   * @type {string}
   * @memberof SendMessageResponse
   */
  created_at: string
  /**
   *
   * @type {boolean}
   * @memberof SendMessageResponse
   */
  deleted: boolean
  /**
   * The direction of the message; `to` or `from` the contact
   * @type {string}
   * @memberof SendMessageResponse
   */
  direction: SendMessageResponseDirectionEnum
  /**
   * If `true`, creates a shortlink for this message regardless if there\'s an attachment.
   * @type {boolean}
   * @memberof SendMessageResponse
   */
  force_shortlink_creation: boolean
  /**
   *
   * @type {Array<object>}
   * @memberof SendMessageResponse
   */
  groups: Array<object>
  /**
   *
   * @type {string}
   * @memberof SendMessageResponse
   */
  id: string
  /**
   *
   * @type {boolean}
   * @memberof SendMessageResponse
   */
  id_is_thread_id: boolean
  /**
   *
   * @type {string}
   * @memberof SendMessageResponse
   */
  message_id: string
  /**
   *
   * @type {InlineResponse2011Mms}
   * @memberof SendMessageResponse
   */
  mms: InlineResponse2011Mms
  /**
   *
   * @type {string}
   * @memberof SendMessageResponse
   */
  modified_at: string
  /**
   *
   * @type {string}
   * @memberof SendMessageResponse
   */
  resource_uri: string
  /**
   * The date & time **in UTC** to schedule the message to be sent at.  **Note:** it **must** be exactly 24-characters long and in this format: `2022-04-13T15:29:40+0000`
   * @type {string}
   * @memberof SendMessageResponse
   */
  scheduled_at: string | null
  /**
   * The date & time **in UTC** the message was sent at.
   * @type {string}
   * @memberof SendMessageResponse
   */
  sent?: string | null
  /**
   *
   * @type {string}
   * @memberof SendMessageResponse
   */
  shortlink: string
  /**
   *
   * @type {string}
   * @memberof SendMessageResponse
   */
  text: string
  /**
   *
   * @type {string}
   * @memberof SendMessageResponse
   */
  thread_id: string
  /**
   *
   * @type {string}
   * @memberof SendMessageResponse
   */
  type: string
  /**
   * Whether or not the message is marked as unread Changing this will mark the corresponding thread as read or unread
   * @type {boolean}
   * @memberof SendMessageResponse
   */
  unread?: boolean | null
  /**
   *
   * @type {boolean}
   * @memberof SendMessageResponse
   */
  via_shortcode: boolean
}

/**
 * @export
 * @enum {string}
 */
export enum SendMessageResponseDirectionEnum {
  To = 'to',
  From = 'from',
}

/**
 * Settings for an individual user (SendHub line)
 * @export
 * @interface Settings
 */
export interface Settings {
  /**
   *
   * @type {string}
   * @memberof Settings
   */
  api_key?: string
  /**
   *
   * @type {string}
   * @memberof Settings
   */
  auto_attendant_greeting_url?: string | null
  /**
   *
   * @type {boolean}
   * @memberof Settings
   */
  auto_upgrade_plan?: boolean
  /**
   *
   * @type {string}
   * @memberof Settings
   */
  automated_sms_response?: string | null
  /**
   *
   * @type {boolean}
   * @memberof Settings
   */
  conference_lines_enabled?: boolean
  /**
   * A UTC timestamp  `2021-08-01T03:48:55.350453` equals August 1st, 2021 at 3:48 and 55.350453 seconds AM (UTC)
   * @type {string}
   * @memberof Settings
   */
  createdTs?: string
  /**
   *
   * @type {string}
   * @memberof Settings
   */
  customer_id?: string | null
  /**
   *
   * @type {boolean}
   * @memberof Settings
   */
  deleted?: boolean | null
  /**
   *
   * @type {boolean}
   * @memberof Settings
   */
  desktop_notifications?: boolean
  /**
   *
   * @type {boolean}
   * @memberof Settings
   */
  disable_incoming_sms?: boolean
  /**
   *
   * @type {boolean}
   * @memberof Settings
   */
  email_calling_notifications?: boolean
  /**
   *
   * @type {boolean}
   * @memberof Settings
   */
  ent_toll_free_enabled?: boolean | null
  /**
   * The enterprise ID
   * @type {string}
   * @memberof Settings
   */
  enterprise_id?: string
  /**
   *
   * @type {string}
   * @memberof Settings
   */
  firstPaymentTs?: string | null
  /**
   *
   * @type {boolean}
   * @memberof Settings
   */
  hide_link_in_bulk_messages?: boolean
  /**
   * This is an internal ID and is not the same as a user ID (SendHub line)
   * @type {string}
   * @memberof Settings
   */
  id?: string
  /**
   *
   * @type {string}
   * @memberof Settings
   */
  image?: string | null
  /**
   *
   * @type {boolean}
   * @memberof Settings
   */
  is_verified_email?: boolean
  /**
   *
   * @type {boolean}
   * @memberof Settings
   */
  mfa_enabled?: boolean | null
  /**
   *
   * @type {boolean}
   * @memberof Settings
   */
  mfa_enforced?: boolean
  /**
   * This is used internally and may be expanded upon or removed in the future
   * @type {string}
   * @memberof Settings
   */
  mixpanelid?: string | null
  /**
   * A UTC timestamp  `2021-08-01T03:48:55.350453` equals August 1st, 2021 at 3:48 and 55.350453 seconds AM (UTC)
   * @type {string}
   * @memberof Settings
   */
  modifiedTs?: string
  /**
   *
   * @type {string}
   * @memberof Settings
   */
  month_start?: string
  /**
   * User\'s (SendHub line\'s) name
   * @type {string}
   * @memberof Settings
   */
  name?: string
  /**
   * This is used internally and may be expanded upon or removed in the future
   * @type {boolean}
   * @memberof Settings
   */
  onboarding_mobile_finished?: boolean
  /**
   * This is used internally and may be expanded upon or removed in the future
   * @type {boolean}
   * @memberof Settings
   */
  onboarding_web_finished?: boolean
  /**
   *
   * @type {string}
   * @memberof Settings
   */
  payment_period_end?: string
  /**
   *
   * @type {string}
   * @memberof Settings
   */
  payment_period_start?: string
  /**
   *
   * @type {string}
   * @memberof Settings
   */
  pending_email?: string | null
  /**
   *
   * @type {string}
   * @memberof Settings
   */
  pending_phone_number?: string | null
  /**
   * The `Personal Cell` number in your [My Settings page](https://app.sendhub.com/settings)
   * @type {string}
   * @memberof Settings
   */
  phone_number?: string
  /**
   *
   * @type {UserSettingsPlanUsage}
   * @memberof Settings
   */
  plan_usage?: UserSettingsPlanUsage
  /**
   *
   * @type {string}
   * @memberof Settings
   */
  pusher_key?: string
  /**
   *
   * @type {string}
   * @memberof Settings
   */
  registration_status?: SettingsRegistrationStatusEnum
  /**
   *
   * @type {string}
   * @memberof Settings
   */
  resource_uri?: SettingsResourceUriEnum
  /**
   *
   * @type {boolean}
   * @memberof Settings
   */
  send_only_via_short_code?: boolean
  /**
   *
   * @type {boolean}
   * @memberof Settings
   */
  send_only_via_toll_free?: boolean
  /**
   *
   * @type {string}
   * @memberof Settings
   */
  settings_json?: string
  /**
   *
   * @type {string}
   * @memberof Settings
   */
  siftScienceLabel?: string | null
  /**
   *
   * @type {string}
   * @memberof Settings
   */
  signature?: string | null
  /**
   *
   * @type {string}
   * @memberof Settings
   */
  sms_forwarding?: string | null
  /**
   *
   * @type {boolean}
   * @memberof Settings
   */
  sms_fwd_help?: boolean
  /**
   *
   * @type {string}
   * @memberof Settings
   */
  sms_webhook_url?: string | null
  /**
   *
   * @type {boolean}
   * @memberof Settings
   */
  sound_notifications?: boolean
  /**
   *
   * @type {string}
   * @memberof Settings
   */
  toll_free_number?: string | null
  /**
   *
   * @type {boolean}
   * @memberof Settings
   */
  toll_free_primary?: boolean
  /**
   *
   * @type {boolean}
   * @memberof Settings
   */
  transcribe_voice_mails?: boolean
  /**
   *
   * @type {string}
   * @memberof Settings
   */
  voicemail_greeting_url?: string | null
}

/**
 * @export
 * @enum {string}
 */
export enum SettingsRegistrationStatusEnum {
  Created = 'created',
  EmailVerified = 'email_verified',
  PaymentMethodAbsent = 'payment_method_absent',
  Completed = 'completed',
}
/**
 * @export
 * @enum {string}
 */
export enum SettingsResourceUriEnum {
  Settings = '/settings',
}

/**
 *
 * @export
 * @interface Thread
 */
export interface Thread {
  /**
   *
   * @type {InlineResponse2002Meta}
   * @memberof Thread
   */
  meta?: InlineResponse2002Meta
  /**
   *
   * @type {Array<InlineResponse2002Objects>}
   * @memberof Thread
   */
  objects?: Array<InlineResponse2002Objects>
}
/**
 * @type ThreadIdBoth
 * @export
 */
export type ThreadIdBoth = number | string

/**
 *
 * @export
 * @interface ThreadMeta
 */
export interface ThreadMeta {
  /**
   *
   * @type {number}
   * @memberof ThreadMeta
   */
  offset?: number
  /**
   *
   * @type {number}
   * @memberof ThreadMeta
   */
  limit?: number
  /**
   *
   * @type {string}
   * @memberof ThreadMeta
   */
  previous?: string | null
  /**
   *
   * @type {string}
   * @memberof ThreadMeta
   */
  next?: string | null
  /**
   * Whether this thread has messages marked as unread or not
   * @type {boolean}
   * @memberof ThreadMeta
   */
  hasUnread?: boolean
  /**
   *
   * @type {Array<string>}
   * @memberof ThreadMeta
   */
  labels?: Array<string>
}
/**
 *
 * @export
 * @interface ThreadNestedContact
 */
export interface ThreadNestedContact {
  [key: string]: string | any

  /**
   * Opt-out status (eg. if they texted `Stop`, `Cancel`, `Block`, `Quit` or `End` - [more info](https://sendhub.force.com/support/s/article/SendHub-Number-FAQ))
   * @type {boolean}
   * @memberof ThreadNestedContact
   */
  blocked?: boolean
  /**
   *
   * @type {boolean}
   * @memberof ThreadNestedContact
   */
  deleted?: boolean
  /**
   * The contact ID
   * @type {number}
   * @memberof ThreadNestedContact
   */
  id?: number
  /**
   * Same as id but always a string
   * @type {string}
   * @memberof ThreadNestedContact
   */
  id_str?: string
  /**
   * This is used internally and may be expanded upon or removed in the future
   * @type {boolean}
   * @memberof ThreadNestedContact
   */
  is_owned?: boolean
  /**
   * The keyword must be unique and is generated by the contact\'s name by default. [Learn more about how contact keywords are used here.](https://sendhub.force.com/support/s/article/contacts-faq)
   * @type {string}
   * @memberof ThreadNestedContact
   */
  keyword?: string
  /**
   * The contact\'s name
   * @type {string}
   * @memberof ThreadNestedContact
   */
  name?: string
  /**
   * The contact\'s phone number
   * @type {string}
   * @memberof ThreadNestedContact
   */
  number?: string
  /**
   * Whether the contact has been blocked by you
   * @type {boolean}
   * @memberof ThreadNestedContact
   */
  screened?: boolean
  /**
   * List of group names
   * @type {Array<string>}
   * @memberof ThreadNestedContact
   */
  groups?: Array<string>
}
/**
 *
 * @export
 * @interface ThreadNestedGroup
 */
export interface ThreadNestedGroup {
  /**
   * The group ID
   * @type {string}
   * @memberof ThreadNestedGroup
   */
  id?: string
  /**
   * Same as id but always a string
   * @type {string}
   * @memberof ThreadNestedGroup
   */
  id_str?: string
  /**
   * The group\'s name
   * @type {string}
   * @memberof ThreadNestedGroup
   */
  name?: string
  /**
   * The \"keyword\" used to text-to-join  Defaults to the group name lowercased, without any spaces and not duplicate by appending an incrementing number if needed
   * @type {string}
   * @memberof ThreadNestedGroup
   */
  slug?: string
  /**
   * Whether to enable text-to-join functionality for this group
   * @type {boolean}
   * @memberof ThreadNestedGroup
   */
  text_to_subscribe?: boolean
  /**
   * This is used internally and may be expanded upon or removed in the future
   * @type {string}
   * @memberof ThreadNestedGroup
   */
  mediums?: string | null
  /**
   * This is used internally and may be expanded upon or removed in the future
   * @type {boolean}
   * @memberof ThreadNestedGroup
   */
  check_all?: boolean
  /**
   *
   * @type {boolean}
   * @memberof ThreadNestedGroup
   */
  deleted?: boolean
  /**
   * A custom response sent when someone texts-to-join this group
   * @type {string}
   * @memberof ThreadNestedGroup
   */
  ttjResponse?: string
}
/**
 * This is used internally and may be expanded upon or removed in the future
 * @export
 * @interface TwilioPhoneNumberId
 */
export interface TwilioPhoneNumberId {}
/**
 * This is used internally and may be expanded upon or removed in the future
 * @export
 * @interface TwilioPhoneNumberIdStr
 */
export interface TwilioPhoneNumberIdStr {}
/**
 *
 * @export
 * @interface UpdateContactResponse
 */
export interface UpdateContactResponse {
  [key: string]: string | any

  /**
   * Opt-out status (eg. if they texted `Stop`, `Cancel`, `Block`, `Quit` or `End` - [more info](https://sendhub.force.com/support/s/article/SendHub-Number-FAQ))
   * @type {boolean}
   * @memberof UpdateContactResponse
   */
  blocked?: boolean
  /**
   *
   * @type {boolean}
   * @memberof UpdateContactResponse
   */
  deleted?: boolean
  /**
   * Same as id but always a string
   * @type {string}
   * @memberof UpdateContactResponse
   */
  id_str?: string
  /**
   * This is used internally and may be expanded upon or removed in the future
   * @type {boolean}
   * @memberof UpdateContactResponse
   */
  is_owned?: boolean
  /**
   * The keyword must be unique and is generated by the contact\'s name by default. [Learn more about how contact keywords are used here.](https://sendhub.force.com/support/s/article/contacts-faq)
   * @type {string}
   * @memberof UpdateContactResponse
   */
  keyword?: string
  /**
   * The contact\'s name
   * @type {string}
   * @memberof UpdateContactResponse
   */
  name: string
  /**
   * The contact\'s phone number
   * @type {string}
   * @memberof UpdateContactResponse
   */
  number: string
  /**
   * Whether the contact has been blocked by you
   * @type {boolean}
   * @memberof UpdateContactResponse
   */
  screened?: boolean
  /**
   * The contact ID
   * @type {string}
   * @memberof UpdateContactResponse
   */
  id?: string
  /**
   * A UTC timestamp  `2021-08-01T03:48:55.350453` equals August 1st, 2021 at 3:48 and 55.350453 seconds AM (UTC)
   * @type {string}
   * @memberof UpdateContactResponse
   */
  date_created?: string
  /**
   * A UTC timestamp  `2021-08-01T03:48:55.350453` equals August 1st, 2021 at 3:48 and 55.350453 seconds AM (UTC)
   * @type {string}
   * @memberof UpdateContactResponse
   */
  date_modified?: string
  /**
   * True if the contact is a SendHub line
   * @type {boolean}
   * @memberof UpdateContactResponse
   */
  local_gateway?: boolean
  /**
   * Resource URI for this contact
   * @type {string}
   * @memberof UpdateContactResponse
   */
  resource_uri?: string
  /**
   * List of group resource URIs
   * @type {Array<string>}
   * @memberof UpdateContactResponse
   */
  groups?: Array<string>
  /**
   * Whether SendHub has determined the contact\'s number is a landline number
   * @type {boolean}
   * @memberof UpdateContactResponse
   */
  landline?: boolean
  /**
   * TODO:
   * @type {boolean}
   * @memberof UpdateContactResponse
   */
  landline_override?: boolean
  /**
   *
   * @type {string | number}
   * @memberof UpdateContactResponse
   */
  contact_id?: string | number
}
/**
 *
 * @export
 * @interface UpdateEnterpriseRequest
 */
export interface UpdateEnterpriseRequest {
  /**
   * 10DLC Brand ID
   * @type {string}
   * @memberof UpdateEnterpriseRequest
   */
  brand_id?: string | null
  /**
   *
   * @type {string}
   * @memberof UpdateEnterpriseRequest
   */
  createdTs: string
  /**
   *
   * @type {string}
   * @memberof UpdateEnterpriseRequest
   */
  customerId: string
  /**
   *
   * @type {string}
   * @memberof UpdateEnterpriseRequest
   */
  hash: string
  /**
   *
   * @type {string}
   * @memberof UpdateEnterpriseRequest
   */
  joinUrl: string
  /**
   *
   * @type {string}
   * @memberof UpdateEnterpriseRequest
   */
  month_start: string
  /**
   *
   * @type {string}
   * @memberof UpdateEnterpriseRequest
   */
  name: string
  /**
   *
   * @type {number}
   * @memberof UpdateEnterpriseRequest
   */
  payment_plan_id: number
  /**
   *
   * @type {string}
   * @memberof UpdateEnterpriseRequest
   */
  settingsJson: string
  /**
   *
   * @type {boolean}
   * @memberof UpdateEnterpriseRequest
   */
  shortcode_allowed: boolean
}
/**
 *
 * @export
 * @interface UpdateGroupRequest
 */
export interface UpdateGroupRequest {
  /**
   * The group\'s name
   * @type {string}
   * @memberof UpdateGroupRequest
   */
  name: string
  /**
   * Whether the group is shared between the lines
   * @type {boolean}
   * @memberof UpdateGroupRequest
   */
  is_shared?: boolean
  /**
   * The \"keyword\" used to text-to-join  Defaults to the group name lowercased, without any spaces and not duplicate by appending an incrementing number if needed
   * @type {string}
   * @memberof UpdateGroupRequest
   */
  slug?: string
  /**
   * This is used internally and may be expanded upon or removed in the future
   * @type {string}
   * @memberof UpdateGroupRequest
   */
  mediums?: string | null
  /**
   *
   * @type {string}
   * @memberof UpdateGroupRequest
   */
  permissions?: UpdateGroupRequestPermissionsEnum
  /**
   * Whether to enable text-to-join functionality for this group
   * @type {boolean}
   * @memberof UpdateGroupRequest
   */
  text_to_subscribe?: boolean
  /**
   * A custom response sent when someone texts-to-join this group
   * @type {string}
   * @memberof UpdateGroupRequest
   */
  ttjResponse?: string
  /**
   * The contact ID
   * @type {string}
   * @memberof UpdateGroupRequest
   */
  id: string
}

/**
 * @export
 * @enum {string}
 */
export enum UpdateGroupRequestPermissionsEnum {
  Write = 'write',
}

/**
 * Settings for an individual user (SendHub line)
 * @export
 * @interface UpdateSettings
 */
export interface UpdateSettings {
  /**
   *
   * @type {string}
   * @memberof UpdateSettings
   */
  api_key?: string
  /**
   *
   * @type {string}
   * @memberof UpdateSettings
   */
  auto_attendant_greeting_url?: string | null
  /**
   *
   * @type {boolean}
   * @memberof UpdateSettings
   */
  auto_upgrade_plan?: boolean
  /**
   *
   * @type {string}
   * @memberof UpdateSettings
   */
  automated_sms_response?: string | null
  /**
   *
   * @type {boolean}
   * @memberof UpdateSettings
   */
  conference_lines_enabled?: boolean
  /**
   * A UTC timestamp  `2021-08-01T03:48:55.350453` equals August 1st, 2021 at 3:48 and 55.350453 seconds AM (UTC)
   * @type {string}
   * @memberof UpdateSettings
   */
  createdTs?: string
  /**
   *
   * @type {string}
   * @memberof UpdateSettings
   */
  customer_id?: string | null
  /**
   *
   * @type {boolean}
   * @memberof UpdateSettings
   */
  deleted?: boolean | null
  /**
   *
   * @type {boolean}
   * @memberof UpdateSettings
   */
  desktop_notifications?: boolean
  /**
   *
   * @type {boolean}
   * @memberof UpdateSettings
   */
  disable_incoming_sms?: boolean
  /**
   *
   * @type {boolean}
   * @memberof UpdateSettings
   */
  email_calling_notifications?: boolean
  /**
   *
   * @type {boolean}
   * @memberof UpdateSettings
   */
  ent_toll_free_enabled?: boolean | null
  /**
   * The enterprise ID
   * @type {string}
   * @memberof UpdateSettings
   */
  enterprise_id?: string
  /**
   *
   * @type {string}
   * @memberof UpdateSettings
   */
  firstPaymentTs?: string | null
  /**
   *
   * @type {boolean}
   * @memberof UpdateSettings
   */
  hide_link_in_bulk_messages?: boolean
  /**
   * This is an internal ID and is not the same as a user ID (SendHub line)
   * @type {string}
   * @memberof UpdateSettings
   */
  id?: string
  /**
   *
   * @type {string}
   * @memberof UpdateSettings
   */
  image?: string | null
  /**
   *
   * @type {boolean}
   * @memberof UpdateSettings
   */
  is_verified_email?: boolean
  /**
   *
   * @type {boolean}
   * @memberof UpdateSettings
   */
  mfa_enabled?: boolean | null
  /**
   *
   * @type {boolean}
   * @memberof UpdateSettings
   */
  mfa_enforced?: boolean
  /**
   * This is used internally and may be expanded upon or removed in the future
   * @type {string}
   * @memberof UpdateSettings
   */
  mixpanelid?: string | null
  /**
   * A UTC timestamp  `2021-08-01T03:48:55.350453` equals August 1st, 2021 at 3:48 and 55.350453 seconds AM (UTC)
   * @type {string}
   * @memberof UpdateSettings
   */
  modifiedTs?: string
  /**
   *
   * @type {string}
   * @memberof UpdateSettings
   */
  month_start?: string
  /**
   * User\'s (SendHub line\'s) name
   * @type {string}
   * @memberof UpdateSettings
   */
  name?: string
  /**
   * This is used internally and may be expanded upon or removed in the future
   * @type {boolean}
   * @memberof UpdateSettings
   */
  onboarding_mobile_finished?: boolean
  /**
   * This is used internally and may be expanded upon or removed in the future
   * @type {boolean}
   * @memberof UpdateSettings
   */
  onboarding_web_finished?: boolean
  /**
   *
   * @type {string}
   * @memberof UpdateSettings
   */
  payment_period_end?: string
  /**
   *
   * @type {string}
   * @memberof UpdateSettings
   */
  payment_period_start?: string
  /**
   *
   * @type {string}
   * @memberof UpdateSettings
   */
  pending_email?: string | null
  /**
   *
   * @type {string}
   * @memberof UpdateSettings
   */
  pending_phone_number?: string | null
  /**
   * The `Personal Cell` number in your [My Settings page](https://app.sendhub.com/settings)
   * @type {string}
   * @memberof UpdateSettings
   */
  phone_number?: string
  /**
   *
   * @type {UserSettingsPlanUsage}
   * @memberof UpdateSettings
   */
  plan_usage?: UserSettingsPlanUsage
  /**
   *
   * @type {string}
   * @memberof UpdateSettings
   */
  pusher_key?: string
  /**
   *
   * @type {string}
   * @memberof UpdateSettings
   */
  registration_status?: UpdateSettingsRegistrationStatusEnum
  /**
   *
   * @type {string}
   * @memberof UpdateSettings
   */
  resource_uri?: UpdateSettingsResourceUriEnum
  /**
   *
   * @type {boolean}
   * @memberof UpdateSettings
   */
  send_only_via_short_code?: boolean
  /**
   *
   * @type {boolean}
   * @memberof UpdateSettings
   */
  send_only_via_toll_free?: boolean
  /**
   *
   * @type {string}
   * @memberof UpdateSettings
   */
  settings_json?: string
  /**
   *
   * @type {string}
   * @memberof UpdateSettings
   */
  siftScienceLabel?: string | null
  /**
   *
   * @type {string}
   * @memberof UpdateSettings
   */
  signature?: string | null
  /**
   *
   * @type {string}
   * @memberof UpdateSettings
   */
  sms_forwarding?: string | null
  /**
   *
   * @type {boolean}
   * @memberof UpdateSettings
   */
  sms_fwd_help?: boolean
  /**
   *
   * @type {string}
   * @memberof UpdateSettings
   */
  sms_webhook_url?: string | null
  /**
   *
   * @type {boolean}
   * @memberof UpdateSettings
   */
  sound_notifications?: boolean
  /**
   *
   * @type {string}
   * @memberof UpdateSettings
   */
  toll_free_number?: string | null
  /**
   *
   * @type {boolean}
   * @memberof UpdateSettings
   */
  toll_free_primary?: boolean
  /**
   *
   * @type {boolean}
   * @memberof UpdateSettings
   */
  transcribe_voice_mails?: boolean
  /**
   *
   * @type {string}
   * @memberof UpdateSettings
   */
  voicemail_greeting_url?: string | null
  /**
   *
   * @type {boolean}
   * @memberof UpdateSettings
   */
  mask_caller_id?: boolean
}

/**
 * @export
 * @enum {string}
 */
export enum UpdateSettingsRegistrationStatusEnum {
  Created = 'created',
  EmailVerified = 'email_verified',
  PaymentMethodAbsent = 'payment_method_absent',
  Completed = 'completed',
}
/**
 * @export
 * @enum {string}
 */
export enum UpdateSettingsResourceUriEnum {
  Settings = '/settings',
}

/**
 *
 * @export
 * @interface UpsertContactRequest
 */
export interface UpsertContactRequest {
  /**
   * Opt-out status (eg. if they texted `Stop`, `Cancel`, `Block`, `Quit` or `End` - [more info](https://sendhub.force.com/support/s/article/SendHub-Number-FAQ))
   * @type {boolean}
   * @memberof UpsertContactRequest
   */
  blocked?: boolean
  /**
   *
   * @type {boolean}
   * @memberof UpsertContactRequest
   */
  deleted?: boolean
  /**
   *
   * @type {ContactIdBoth}
   * @memberof UpsertContactRequest
   */
  id: ContactIdBoth
  /**
   * The keyword must be unique and is generated by the contact\'s name by default. [Learn more about how contact keywords are used here.](https://sendhub.force.com/support/s/article/contacts-faq)
   * @type {string}
   * @memberof UpsertContactRequest
   */
  keyword?: string
  /**
   * The contact\'s name
   * @type {string}
   * @memberof UpsertContactRequest
   */
  name: string
  /**
   * The contact\'s phone number
   * @type {string}
   * @memberof UpsertContactRequest
   */
  number: string
  /**
   * Whether the contact has been blocked by you
   * @type {boolean}
   * @memberof UpsertContactRequest
   */
  screened?: boolean
  /**
   * List of group resource URIs and/or IDs
   * @type {Array<string | number>}
   * @memberof UpsertContactRequest
   */
  groups?: Array<string | number>
}
/**
 *
 * @export
 * @interface UpsertContactRequestWithId
 */
export interface UpsertContactRequestWithId {
  [key: string]: string | any

  /**
   * Opt-out status (eg. if they texted `Stop`, `Cancel`, `Block`, `Quit` or `End` - [more info](https://sendhub.force.com/support/s/article/SendHub-Number-FAQ))
   * @type {boolean}
   * @memberof UpsertContactRequestWithId
   */
  blocked?: boolean
  /**
   *
   * @type {boolean}
   * @memberof UpsertContactRequestWithId
   */
  deleted?: boolean
  /**
   *
   * @type {ContactIdBoth}
   * @memberof UpsertContactRequestWithId
   */
  id: ContactIdBoth
  /**
   * The keyword must be unique and is generated by the contact\'s name by default. [Learn more about how contact keywords are used here.](https://sendhub.force.com/support/s/article/contacts-faq)
   * @type {string}
   * @memberof UpsertContactRequestWithId
   */
  keyword?: string
  /**
   * The contact\'s name
   * @type {string}
   * @memberof UpsertContactRequestWithId
   */
  name: string
  /**
   * The contact\'s phone number
   * @type {string}
   * @memberof UpsertContactRequestWithId
   */
  number: string
  /**
   * Whether the contact has been blocked by you
   * @type {boolean}
   * @memberof UpsertContactRequestWithId
   */
  screened?: boolean
  /**
   * List of group resource URIs and/or IDs
   * @type {Array<string | number>}
   * @memberof UpsertContactRequestWithId
   */
  groups?: Array<string | number>
}
/**
 *
 * @export
 * @interface UpsertContactRequestWithoutId
 */
export interface UpsertContactRequestWithoutId {
  [key: string]: string | any

  /**
   * Opt-out status (eg. if they texted `Stop`, `Cancel`, `Block`, `Quit` or `End` - [more info](https://sendhub.force.com/support/s/article/SendHub-Number-FAQ))
   * @type {boolean}
   * @memberof UpsertContactRequestWithoutId
   */
  blocked?: boolean
  /**
   *
   * @type {boolean}
   * @memberof UpsertContactRequestWithoutId
   */
  deleted?: boolean
  /**
   *
   * @type {ContactIdBoth}
   * @memberof UpsertContactRequestWithoutId
   */
  id?: ContactIdBoth
  /**
   * The keyword must be unique and is generated by the contact\'s name by default. [Learn more about how contact keywords are used here.](https://sendhub.force.com/support/s/article/contacts-faq)
   * @type {string}
   * @memberof UpsertContactRequestWithoutId
   */
  keyword?: string
  /**
   * The contact\'s name
   * @type {string}
   * @memberof UpsertContactRequestWithoutId
   */
  name: string
  /**
   * The contact\'s phone number
   * @type {string}
   * @memberof UpsertContactRequestWithoutId
   */
  number: string
  /**
   * Whether the contact has been blocked by you
   * @type {boolean}
   * @memberof UpsertContactRequestWithoutId
   */
  screened?: boolean
  /**
   * List of group resource URIs and/or IDs
   * @type {Array<string | number>}
   * @memberof UpsertContactRequestWithoutId
   */
  groups?: Array<string | number>
}
/**
 *
 * @export
 * @interface UpsertContactResponse
 */
export interface UpsertContactResponse {
  /**
   * Opt-out status (eg. if they texted `Stop`, `Cancel`, `Block`, `Quit` or `End` - [more info](https://sendhub.force.com/support/s/article/SendHub-Number-FAQ))
   * @type {boolean}
   * @memberof UpsertContactResponse
   */
  blocked?: boolean
  /**
   *
   * @type {boolean}
   * @memberof UpsertContactResponse
   */
  deleted?: boolean
  /**
   * Same as id but always a string
   * @type {string}
   * @memberof UpsertContactResponse
   */
  id_str?: string
  /**
   * This is used internally and may be expanded upon or removed in the future
   * @type {boolean}
   * @memberof UpsertContactResponse
   */
  is_owned?: boolean
  /**
   * The keyword must be unique and is generated by the contact\'s name by default. [Learn more about how contact keywords are used here.](https://sendhub.force.com/support/s/article/contacts-faq)
   * @type {string}
   * @memberof UpsertContactResponse
   */
  keyword?: string
  /**
   * The contact\'s name
   * @type {string}
   * @memberof UpsertContactResponse
   */
  name: string
  /**
   * The contact\'s phone number
   * @type {string}
   * @memberof UpsertContactResponse
   */
  number: string
  /**
   * Whether the contact has been blocked by you
   * @type {boolean}
   * @memberof UpsertContactResponse
   */
  screened?: boolean
  /**
   * The contact ID
   * @type {string}
   * @memberof UpsertContactResponse
   */
  id?: string
  /**
   * A UTC timestamp  `2021-08-01T03:48:55.350453` equals August 1st, 2021 at 3:48 and 55.350453 seconds AM (UTC)
   * @type {string}
   * @memberof UpsertContactResponse
   */
  date_created?: string
  /**
   * A UTC timestamp  `2021-08-01T03:48:55.350453` equals August 1st, 2021 at 3:48 and 55.350453 seconds AM (UTC)
   * @type {string}
   * @memberof UpsertContactResponse
   */
  date_modified?: string
  /**
   * True if the contact is a SendHub line
   * @type {boolean}
   * @memberof UpsertContactResponse
   */
  local_gateway?: boolean
  /**
   * Resource URI for this contact
   * @type {string}
   * @memberof UpsertContactResponse
   */
  resource_uri?: string
  /**
   * List of group resource URIs
   * @type {Array<string>}
   * @memberof UpsertContactResponse
   */
  groups?: Array<string>
  /**
   * Whether SendHub has determined the contact\'s number is a landline number
   * @type {boolean}
   * @memberof UpsertContactResponse
   */
  landline?: boolean
  /**
   * TODO:
   * @type {boolean}
   * @memberof UpsertContactResponse
   */
  landline_override?: boolean
  /**
   *
   * @type {string | number}
   * @memberof UpsertContactResponse
   */
  contact_id?: string | number
}
/**
 * Individual SendHub user (line)
 * @export
 * @interface User
 */
export interface User {
  /**
   * A UTC timestamp  `2021-08-01T03:48:34` equals August 1st, 2021 at 3:48 and 34 seconds AM (UTC)
   * @type {string}
   * @memberof User
   */
  createdTs: string
  /**
   *
   * @type {boolean}
   * @memberof User
   */
  disable_incoming_sms: boolean
  /**
   * The enterprise ID
   * @type {string}
   * @memberof User
   */
  enterprise_id: string
  /**
   * The enterprise ID
   * @type {string}
   * @memberof User
   */
  enterprise_id_str: string
  /**
   *
   * @type {string}
   * @memberof User
   */
  id: string
  /**
   * Same as id but always a string
   * @type {string}
   * @memberof User
   */
  id_str: string
  /**
   * The URL for this user\'s profile image
   * @type {string}
   * @memberof User
   */
  image: string
  /**
   * Whether this user\'s email has been verified
   * @type {boolean}
   * @memberof User
   */
  is_verified_email: boolean
  /**
   * A UTC timestamp  `2021-08-01T03:48:34` equals August 1st, 2021 at 3:48 and 34 seconds AM (UTC)
   * @type {string}
   * @memberof User
   */
  modifiedTs: string
  /**
   * User\'s (SendHub line\'s) name
   * @type {string}
   * @memberof User
   */
  name: string
  /**
   * This is used internally and may be expanded upon or removed in the future
   * @type {boolean}
   * @memberof User
   */
  onboarding_mobile_finished: boolean
  /**
   * This is used internally and may be expanded upon or removed in the future
   * @type {boolean}
   * @memberof User
   */
  onboarding_web_finished: boolean
  /**
   *
   * @type {string}
   * @memberof User
   */
  payment_period_end: string
  /**
   *
   * @type {string}
   * @memberof User
   */
  payment_period_start: string
  /**
   * Your plan\'s payment schedule type: 1. Monthly 2. Yearly 3. Consumable (eg. free trial)
   * @type {string}
   * @memberof User
   */
  payment_schedule_id: UserPaymentScheduleIdEnum
  /**
   * Phone number waiting to be verified for the \"Personal Cell\" field
   * @type {string}
   * @memberof User
   */
  pending_phone_number?: string
  /**
   * The `Personal Cell` number in your [My Settings page](https://app.sendhub.com/settings)
   * @type {string}
   * @memberof User
   */
  phone_number?: string
  /**
   *
   * @type {string}
   * @memberof User
   */
  registration_status: UserRegistrationStatusEnum
  /**
   * This line\'s SendHub number (E.164 format)
   * @type {string}
   * @memberof User
   */
  sendhub_number: string
  /**
   *
   * @type {string}
   * @memberof User
   */
  settings_json: string
  /**
   * Signature that the SendHub apps append to new messages **Note:** SendHub does not use this field when sending via the API
   * @type {string}
   * @memberof User
   */
  signature: string
  /**
   * This is used internally and may be expanded upon or removed in the future
   * @type {string | number}
   * @memberof User
   */
  twilio_phone_number_id: string | number
  /**
   * This is used internally and may be expanded upon or removed in the future
   * @type {string | number}
   * @memberof User
   */
  twilio_phone_number_id_str: string | number
  /**
   * The ID of a SendHub user (an individual line)
   * @type {string}
   * @memberof User
   */
  user_id: string
  /**
   * The ID of a SendHub user (an individual line)
   * @type {string}
   * @memberof User
   */
  user_id_str: string
  /**
   *
   * @type {Array<object>}
   * @memberof User
   */
  auth_groups: Array<object>
  /**
   * User\'s (SendHub line\'s) username
   * @type {string}
   * @memberof User
   */
  username: string
}

/**
 * @export
 * @enum {string}
 */
export enum UserPaymentScheduleIdEnum {
  _1 = '1',
  _2 = '2',
  _3 = '3',
}
/**
 * @export
 * @enum {string}
 */
export enum UserRegistrationStatusEnum {
  Created = 'created',
  EmailVerified = 'email_verified',
  PaymentMethodAbsent = 'payment_method_absent',
  Completed = 'completed',
}

/**
 * @type UserIdBoth
 * @export
 */
export type UserIdBoth = number | string

/**
 *
 * @export
 * @interface UserProfile
 */
export interface UserProfile {
  /**
   *
   * @type {Array<object>}
   * @memberof UserProfile
   */
  auth_groups: Array<object>
  /**
   * Timestamp that this SendHub User (line) was created
   * @type {string}
   * @memberof UserProfile
   */
  date_joined: string
  /**
   * This is used internally and may be expanded upon or removed in the future
   * @type {number}
   * @memberof UserProfile
   */
  downvotes: number
  /**
   *
   * @type {string}
   * @memberof UserProfile
   */
  email: string
  /**
   * Your company name
   * @type {string}
   * @memberof UserProfile
   */
  enterprise: string | null
  /**
   * The enterprise ID
   * @type {string}
   * @memberof UserProfile
   */
  enterprise_id: string
  /**
   * This is used internally and may be expanded upon or removed in the future
   * @type {string}
   * @memberof UserProfile
   */
  enterpriseJoinLink: string
  /**
   * How manu Users (lines) your account has
   * @type {number}
   * @memberof UserProfile
   */
  enterpriseSize: number
  /**
   * This is used internally and may be expanded upon or removed in the future
   * @type {string}
   * @memberof UserProfile
   */
  mixpanel_id: string | null
  /**
   * Your company name
   * @type {string}
   * @memberof UserProfile
   */
  name: string | null
  /**
   * This is used internally and may be expanded upon or removed in the future
   * @type {boolean}
   * @memberof UserProfile
   */
  onboarding_mobile_finished: boolean
  /**
   * This is used internally and may be expanded upon or removed in the future
   * @type {boolean}
   * @memberof UserProfile
   */
  onboarding_web_finished: boolean
  /**
   * The plan ID
   * @type {number}
   * @memberof UserProfile
   */
  payment_plan_id: number
  /**
   * Resource URI for this User\'s profile
   * @type {string}
   * @memberof UserProfile
   */
  resource_uri: string
  /**
   * This line\'s SendHub number (formatted)
   * @type {string}
   * @memberof UserProfile
   */
  sendhub_number: string
  /**
   * Shows how many unread threads this User (line) has
   * @type {number}
   * @memberof UserProfile
   */
  unread: number
  /**
   * This is used internally and may be expanded upon or removed in the future
   * @type {number}
   * @memberof UserProfile
   */
  upvotes: number
  /**
   * The ID of a SendHub user (an individual line)
   * @type {string}
   * @memberof UserProfile
   */
  user_id: string
  /**
   * User\'s (SendHub line\'s) username
   * @type {string}
   * @memberof UserProfile
   */
  username: string
}
/**
 * Settings for an individual user (SendHub line)
 * @export
 * @interface UserSettings
 */
export interface UserSettings {
  /**
   *
   * @type {string}
   * @memberof UserSettings
   */
  api_key?: string
  /**
   *
   * @type {string}
   * @memberof UserSettings
   */
  auto_attendant_greeting_url?: string | null
  /**
   *
   * @type {boolean}
   * @memberof UserSettings
   */
  auto_upgrade_plan?: boolean
  /**
   *
   * @type {string}
   * @memberof UserSettings
   */
  automated_sms_response?: string | null
  /**
   *
   * @type {boolean}
   * @memberof UserSettings
   */
  conference_lines_enabled?: boolean
  /**
   * A UTC timestamp  `2021-08-01T03:48:55.350453` equals August 1st, 2021 at 3:48 and 55.350453 seconds AM (UTC)
   * @type {string}
   * @memberof UserSettings
   */
  createdTs?: string
  /**
   *
   * @type {string}
   * @memberof UserSettings
   */
  customer_id?: string | null
  /**
   *
   * @type {boolean}
   * @memberof UserSettings
   */
  deleted?: boolean | null
  /**
   *
   * @type {boolean}
   * @memberof UserSettings
   */
  desktop_notifications?: boolean
  /**
   *
   * @type {boolean}
   * @memberof UserSettings
   */
  disable_incoming_sms?: boolean
  /**
   *
   * @type {boolean}
   * @memberof UserSettings
   */
  email_calling_notifications?: boolean
  /**
   *
   * @type {boolean}
   * @memberof UserSettings
   */
  ent_toll_free_enabled?: boolean | null
  /**
   * The enterprise ID
   * @type {string}
   * @memberof UserSettings
   */
  enterprise_id?: string
  /**
   *
   * @type {string}
   * @memberof UserSettings
   */
  firstPaymentTs?: string | null
  /**
   *
   * @type {boolean}
   * @memberof UserSettings
   */
  hide_link_in_bulk_messages?: boolean
  /**
   * This is an internal ID and is not the same as a user ID (SendHub line)
   * @type {string}
   * @memberof UserSettings
   */
  id?: string
  /**
   *
   * @type {string}
   * @memberof UserSettings
   */
  image?: string | null
  /**
   *
   * @type {boolean}
   * @memberof UserSettings
   */
  is_verified_email?: boolean
  /**
   *
   * @type {boolean}
   * @memberof UserSettings
   */
  mfa_enabled?: boolean | null
  /**
   *
   * @type {boolean}
   * @memberof UserSettings
   */
  mfa_enforced?: boolean
  /**
   * This is used internally and may be expanded upon or removed in the future
   * @type {string}
   * @memberof UserSettings
   */
  mixpanelid?: string | null
  /**
   * A UTC timestamp  `2021-08-01T03:48:55.350453` equals August 1st, 2021 at 3:48 and 55.350453 seconds AM (UTC)
   * @type {string}
   * @memberof UserSettings
   */
  modifiedTs?: string
  /**
   *
   * @type {string}
   * @memberof UserSettings
   */
  month_start?: string
  /**
   * User\'s (SendHub line\'s) name
   * @type {string}
   * @memberof UserSettings
   */
  name?: string
  /**
   * This is used internally and may be expanded upon or removed in the future
   * @type {boolean}
   * @memberof UserSettings
   */
  onboarding_mobile_finished?: boolean
  /**
   * This is used internally and may be expanded upon or removed in the future
   * @type {boolean}
   * @memberof UserSettings
   */
  onboarding_web_finished?: boolean
  /**
   *
   * @type {string}
   * @memberof UserSettings
   */
  payment_period_end?: string
  /**
   *
   * @type {string}
   * @memberof UserSettings
   */
  payment_period_start?: string
  /**
   *
   * @type {string}
   * @memberof UserSettings
   */
  pending_email?: string | null
  /**
   *
   * @type {string}
   * @memberof UserSettings
   */
  pending_phone_number?: string | null
  /**
   * The `Personal Cell` number in your [My Settings page](https://app.sendhub.com/settings)
   * @type {string}
   * @memberof UserSettings
   */
  phone_number?: string
  /**
   *
   * @type {UserSettingsPlanUsage}
   * @memberof UserSettings
   */
  plan_usage?: UserSettingsPlanUsage
  /**
   *
   * @type {string}
   * @memberof UserSettings
   */
  pusher_key?: string
  /**
   *
   * @type {string}
   * @memberof UserSettings
   */
  registration_status?: UserSettingsRegistrationStatusEnum
  /**
   *
   * @type {string}
   * @memberof UserSettings
   */
  resource_uri?: UserSettingsResourceUriEnum
  /**
   *
   * @type {boolean}
   * @memberof UserSettings
   */
  send_only_via_short_code?: boolean
  /**
   *
   * @type {boolean}
   * @memberof UserSettings
   */
  send_only_via_toll_free?: boolean
  /**
   *
   * @type {string}
   * @memberof UserSettings
   */
  settings_json?: string
  /**
   *
   * @type {string}
   * @memberof UserSettings
   */
  siftScienceLabel?: string | null
  /**
   *
   * @type {string}
   * @memberof UserSettings
   */
  signature?: string | null
  /**
   *
   * @type {string}
   * @memberof UserSettings
   */
  sms_forwarding?: string | null
  /**
   *
   * @type {boolean}
   * @memberof UserSettings
   */
  sms_fwd_help?: boolean
  /**
   *
   * @type {string}
   * @memberof UserSettings
   */
  sms_webhook_url?: string | null
  /**
   *
   * @type {boolean}
   * @memberof UserSettings
   */
  sound_notifications?: boolean
  /**
   *
   * @type {string}
   * @memberof UserSettings
   */
  toll_free_number?: string | null
  /**
   *
   * @type {boolean}
   * @memberof UserSettings
   */
  toll_free_primary?: boolean
  /**
   *
   * @type {boolean}
   * @memberof UserSettings
   */
  transcribe_voice_mails?: boolean
  /**
   *
   * @type {string}
   * @memberof UserSettings
   */
  voicemail_greeting_url?: string | null
  /**
   *
   * @type {boolean}
   * @memberof UserSettings
   */
  mask_caller_id?: boolean
}

/**
 * @export
 * @enum {string}
 */
export enum UserSettingsRegistrationStatusEnum {
  Created = 'created',
  EmailVerified = 'email_verified',
  PaymentMethodAbsent = 'payment_method_absent',
  Completed = 'completed',
}
/**
 * @export
 * @enum {string}
 */
export enum UserSettingsResourceUriEnum {
  Settings = '/settings',
}

/**
 *
 * @export
 * @interface UserSettingsPlanUsage
 */
export interface UserSettingsPlanUsage {
  /**
   *
   * @type {string}
   * @memberof UserSettingsPlanUsage
   */
  api_requests?: string
  /**
   *
   * @type {UserSettingsPlanUsageCurrentPlan}
   * @memberof UserSettingsPlanUsage
   */
  current_plan?: UserSettingsPlanUsageCurrentPlan
  /**
   *
   * @type {number}
   * @memberof UserSettingsPlanUsage
   */
  groups?: number
  /**
   *
   * @type {number}
   * @memberof UserSettingsPlanUsage
   */
  maxpergroup?: number
  /**
   *
   * @type {string}
   * @memberof UserSettingsPlanUsage
   */
  messages?: string
  /**
   *
   * @type {number}
   * @memberof UserSettingsPlanUsage
   */
  voice_mail_transcriptions?: number
  /**
   *
   * @type {string | number}
   * @memberof UserSettingsPlanUsage
   */
  voice_minutes?: string | number
}
/**
 *
 * @export
 * @interface UserSettingsPlanUsageCurrentPlan
 */
export interface UserSettingsPlanUsageCurrentPlan {
  /**
   *
   * @type {number}
   * @memberof UserSettingsPlanUsageCurrentPlan
   */
  api_requests?: number
  /**
   *
   * @type {number}
   * @memberof UserSettingsPlanUsageCurrentPlan
   */
  groups?: number
  /**
   *
   * @type {number}
   * @memberof UserSettingsPlanUsageCurrentPlan
   */
  max_sms_recipients?: number
  /**
   *
   * @type {number}
   * @memberof UserSettingsPlanUsageCurrentPlan
   */
  maxpergroup?: number
  /**
   *
   * @type {number}
   * @memberof UserSettingsPlanUsageCurrentPlan
   */
  messages?: number
  /**
   *
   * @type {number}
   * @memberof UserSettingsPlanUsageCurrentPlan
   */
  plan_cost?: number
  /**
   *
   * @type {number}
   * @memberof UserSettingsPlanUsageCurrentPlan
   */
  plan_id?: number
  /**
   *
   * @type {string}
   * @memberof UserSettingsPlanUsageCurrentPlan
   */
  plan_name?: string
  /**
   *
   * @type {number}
   * @memberof UserSettingsPlanUsageCurrentPlan
   */
  voice_minutes?: number
}

/**
 * AuthenticationApi - axios parameter creator
 * @export
 */
export const AuthenticationApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Log in via username & password
     * @summary Username & password login
     * @param {InlineObject2} [inlineObject2]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    login: async (
      inlineObject2?: InlineObject2,
      options: any = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/v1/auth`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication api_key required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('api_key')
            : await configuration.apiKey
        localVarQueryParameter['api_key'] = localVarApiKeyValue
      }

      // authentication basic_auth required
      // http basic authentication required
      if (configuration && (configuration.username || configuration.password)) {
        localVarRequestOptions['auth'] = {
          username: configuration.username,
          password: configuration.password,
        }
      }

      // authentication username required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('username')
            : await configuration.apiKey
        localVarQueryParameter['username'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      localVarUrlObj.search = null
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const needsSerialization =
        typeof inlineObject2 !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(inlineObject2 !== undefined ? inlineObject2 : {})
        : inlineObject2 || ''

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * AuthenticationApi - functional programming interface
 * @export
 */
export const AuthenticationApiFp = function (configuration?: Configuration) {
  return {
    /**
     * Log in via username & password
     * @summary Username & password login
     * @param {InlineObject2} [inlineObject2]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async login(
      inlineObject2?: InlineObject2,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<InlineResponse2006>
    > {
      const localVarAxiosArgs = await AuthenticationApiAxiosParamCreator(
        configuration
      ).login(inlineObject2, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
  }
}

/**
 * AuthenticationApi - factory interface
 * @export
 */
export const AuthenticationApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     * Log in via username & password
     * @summary Username & password login
     * @param {InlineObject2} [inlineObject2]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    login(
      inlineObject2?: InlineObject2,
      options?: any
    ): AxiosPromise<InlineResponse2006> {
      return AuthenticationApiFp(configuration)
        .login(inlineObject2, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * AuthenticationApi - interface
 * @export
 * @interface AuthenticationApi
 */
export interface AuthenticationApiInterface {
  /**
   * Log in via username & password
   * @summary Username & password login
   * @param {InlineObject2} [inlineObject2]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthenticationApiInterface
   */
  login(
    inlineObject2?: InlineObject2,
    options?: any
  ): AxiosPromise<InlineResponse2006>
}

/**
 * AuthenticationApi - object-oriented interface
 * @export
 * @class AuthenticationApi
 * @extends {BaseAPI}
 */
export class AuthenticationApi
  extends BaseAPI
  implements AuthenticationApiInterface
{
  /**
   * Log in via username & password
   * @summary Username & password login
   * @param {InlineObject2} [inlineObject2]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthenticationApi
   */
  public login(inlineObject2?: InlineObject2, options?: any) {
    return AuthenticationApiFp(this.configuration)
      .login(inlineObject2, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * ContactApi - axios parameter creator
 * @export
 */
export const ContactApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Creates, updates, or deletes multiple contacts in one request
     * @summary Creates, updates, or deletes multiple contacts in one request
     * @param {BulkUpsertContactRequest} [bulkUpsertContactRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bulkUpsertContacts: async (
      bulkUpsertContactRequest?: BulkUpsertContactRequest,
      options: any = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/v1/contacts`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = {
        method: 'PATCH',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication api_key required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('api_key')
            : await configuration.apiKey
        localVarQueryParameter['api_key'] = localVarApiKeyValue
      }

      // authentication basic_auth required
      // http basic authentication required
      if (configuration && (configuration.username || configuration.password)) {
        localVarRequestOptions['auth'] = {
          username: configuration.username,
          password: configuration.password,
        }
      }

      // authentication username required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('username')
            : await configuration.apiKey
        localVarQueryParameter['username'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      localVarUrlObj.search = null
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const needsSerialization =
        typeof bulkUpsertContactRequest !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(
            bulkUpsertContactRequest !== undefined
              ? bulkUpsertContactRequest
              : {}
          )
        : bulkUpsertContactRequest || ''

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Deletes a contact
     * @summary Delete Contact
     * @param {number | string} contactId The contact ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteContact: async (
      contactId: number | string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'contactId' is not null or undefined
      if (contactId === null || contactId === undefined) {
        throw new RequiredError(
          'contactId',
          'Required parameter contactId was null or undefined when calling deleteContact.'
        )
      }
      const localVarPath = `/v1/contacts/{contact_id}`.replace(
        `{${'contact_id'}}`,
        encodeURIComponent(String(contactId))
      )
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = {
        method: 'DELETE',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication api_key required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('api_key')
            : await configuration.apiKey
        localVarQueryParameter['api_key'] = localVarApiKeyValue
      }

      // authentication basic_auth required
      // http basic authentication required
      if (configuration && (configuration.username || configuration.password)) {
        localVarRequestOptions['auth'] = {
          username: configuration.username,
          password: configuration.password,
        }
      }

      // authentication username required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('username')
            : await configuration.apiKey
        localVarQueryParameter['username'] = localVarApiKeyValue
      }

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      localVarUrlObj.search = null
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Retrieves a contact by its id
     * @summary Get Contact
     * @param {number | string} contactId The contact ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getContact: async (
      contactId: number | string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'contactId' is not null or undefined
      if (contactId === null || contactId === undefined) {
        throw new RequiredError(
          'contactId',
          'Required parameter contactId was null or undefined when calling getContact.'
        )
      }
      const localVarPath = `/v1/contacts/{contact_id}`.replace(
        `{${'contact_id'}}`,
        encodeURIComponent(String(contactId))
      )
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication api_key required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('api_key')
            : await configuration.apiKey
        localVarQueryParameter['api_key'] = localVarApiKeyValue
      }

      // authentication basic_auth required
      // http basic authentication required
      if (configuration && (configuration.username || configuration.password)) {
        localVarRequestOptions['auth'] = {
          username: configuration.username,
          password: configuration.password,
        }
      }

      // authentication username required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('username')
            : await configuration.apiKey
        localVarQueryParameter['username'] = localVarApiKeyValue
      }

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      localVarUrlObj.search = null
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Gets a list of contacts  See also: [List Group Contacts](#listGroupContacts)
     * @summary List Contacts
     * @param {number} [limit] (Pagination) How many records to return
     * @param {number} [offset] (Pagination) How many records to skip
     * @param {string} [number] Filters contacts by their phone &#x60;number&#x60;    The value _**must**_ be in the E.164 format and URI-encoded (eg. &#x60;+18004445555&#x60; would become &#x60;%2B18004445555&#x60;)
     * @param {string} [name] Filters contacts by their &#x60;name&#x60; (Will only return contacts whose name matches **exactly**)
     * @param {boolean} [screened] Filters the contacts by their &#x60;screened&#x60; status (eg. if _**you**_ blocked them)
     * @param {boolean} [blocked] Filters the contacts by opt-out status (eg. if they texted &#x60;Stop&#x60;, &#x60;Cancel&#x60;, &#x60;Block&#x60;, &#x60;Quit&#x60; or &#x60;End&#x60; - [more info](https://sendhub.force.com/support/s/article/SendHub-Number-FAQ))
     * @param {'name' | '-name' | 'date_created' | '-date_created' | 'date_modified' | '-date_modified' | 'id' | '-id' | 'blocked' | '-blocked' | 'screened' | '-screened' | 'is_owned' | '-is_owned' | 'keyword' | '-keyword' | 'number' | '-number'} [ordering] Sort contacts by a specified field (prepend a hyphen to reverse order)  **Must** be a built-in contact field, not a custom field
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listContacts: async (
      limit?: number,
      offset?: number,
      number?: string,
      name?: string,
      screened?: boolean,
      blocked?: boolean,
      ordering?:
        | 'name'
        | '-name'
        | 'date_created'
        | '-date_created'
        | 'date_modified'
        | '-date_modified'
        | 'id'
        | '-id'
        | 'blocked'
        | '-blocked'
        | 'screened'
        | '-screened'
        | 'is_owned'
        | '-is_owned'
        | 'keyword'
        | '-keyword'
        | 'number'
        | '-number',
      options: any = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/v1/contacts`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication api_key required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('api_key')
            : await configuration.apiKey
        localVarQueryParameter['api_key'] = localVarApiKeyValue
      }

      // authentication basic_auth required
      // http basic authentication required
      if (configuration && (configuration.username || configuration.password)) {
        localVarRequestOptions['auth'] = {
          username: configuration.username,
          password: configuration.password,
        }
      }

      // authentication username required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('username')
            : await configuration.apiKey
        localVarQueryParameter['username'] = localVarApiKeyValue
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      if (offset !== undefined) {
        localVarQueryParameter['offset'] = offset
      }

      if (number !== undefined) {
        localVarQueryParameter['number'] = number
      }

      if (name !== undefined) {
        localVarQueryParameter['name'] = name
      }

      if (screened !== undefined) {
        localVarQueryParameter['screened'] = screened
      }

      if (blocked !== undefined) {
        localVarQueryParameter['blocked'] = blocked
      }

      if (ordering !== undefined) {
        localVarQueryParameter['ordering'] = ordering
      }

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      localVarUrlObj.search = null
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Lists contacts in a specified group
     * @summary List Group\'s Contacts
     * @param {string} groupId The group ID
     * @param {number} [limit] (Pagination) How many records to return
     * @param {number} [offset] (Pagination) How many records to skip
     * @param {string} [number] Filters contacts by their phone &#x60;number&#x60;    The value _**must**_ be in the E.164 format and URI-encoded (eg. &#x60;+18004445555&#x60; would become &#x60;%2B18004445555&#x60;)
     * @param {string} [name] Filters contacts by their &#x60;name&#x60; (Will only return contacts whose name matches **exactly**)
     * @param {boolean} [screened] Filters the contacts by their &#x60;screened&#x60; status (eg. if _**you**_ blocked them)
     * @param {boolean} [blocked] Filters the contacts by opt-out status (eg. if they texted &#x60;Stop&#x60;, &#x60;Cancel&#x60;, &#x60;Block&#x60;, &#x60;Quit&#x60; or &#x60;End&#x60; - [more info](https://sendhub.force.com/support/s/article/SendHub-Number-FAQ))
     * @param {'name' | '-name' | 'date_created' | '-date_created' | 'date_modified' | '-date_modified' | 'id' | '-id' | 'blocked' | '-blocked' | 'screened' | '-screened' | 'is_owned' | '-is_owned' | 'keyword' | '-keyword' | 'number' | '-number'} [ordering] Sort contacts by a specified field (prepend a hyphen to reverse order)  **Must** be a built-in contact field, not a custom field
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listGroupContacts: async (
      groupId: string,
      limit?: number,
      offset?: number,
      number?: string,
      name?: string,
      screened?: boolean,
      blocked?: boolean,
      ordering?:
        | 'name'
        | '-name'
        | 'date_created'
        | '-date_created'
        | 'date_modified'
        | '-date_modified'
        | 'id'
        | '-id'
        | 'blocked'
        | '-blocked'
        | 'screened'
        | '-screened'
        | 'is_owned'
        | '-is_owned'
        | 'keyword'
        | '-keyword'
        | 'number'
        | '-number',
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'groupId' is not null or undefined
      if (groupId === null || groupId === undefined) {
        throw new RequiredError(
          'groupId',
          'Required parameter groupId was null or undefined when calling listGroupContacts.'
        )
      }
      const localVarPath = `/v1/groups/{group_id}/contacts`.replace(
        `{${'group_id'}}`,
        encodeURIComponent(String(groupId))
      )
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication api_key required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('api_key')
            : await configuration.apiKey
        localVarQueryParameter['api_key'] = localVarApiKeyValue
      }

      // authentication basic_auth required
      // http basic authentication required
      if (configuration && (configuration.username || configuration.password)) {
        localVarRequestOptions['auth'] = {
          username: configuration.username,
          password: configuration.password,
        }
      }

      // authentication username required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('username')
            : await configuration.apiKey
        localVarQueryParameter['username'] = localVarApiKeyValue
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      if (offset !== undefined) {
        localVarQueryParameter['offset'] = offset
      }

      if (number !== undefined) {
        localVarQueryParameter['number'] = number
      }

      if (name !== undefined) {
        localVarQueryParameter['name'] = name
      }

      if (screened !== undefined) {
        localVarQueryParameter['screened'] = screened
      }

      if (blocked !== undefined) {
        localVarQueryParameter['blocked'] = blocked
      }

      if (ordering !== undefined) {
        localVarQueryParameter['ordering'] = ordering
      }

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      localVarUrlObj.search = null
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Updates an individual contact referenced by its id  You can add arbitrary custom fields to a contact (see [Custom Fields](#todo: ))  **Note:** this is a _replace_ operation; any properties the contact already has that you don\'t specify in your request will be removed  [Use POST for _upsert_ functionality](#operation/upsertContact)
     * @summary Update Contact
     * @param {number | string} contactId The contact ID
     * @param {UpsertContactRequestWithId} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateContact: async (
      contactId: number | string,
      body?: UpsertContactRequestWithId,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'contactId' is not null or undefined
      if (contactId === null || contactId === undefined) {
        throw new RequiredError(
          'contactId',
          'Required parameter contactId was null or undefined when calling updateContact.'
        )
      }
      const localVarPath = `/v1/contacts/{contact_id}`.replace(
        `{${'contact_id'}}`,
        encodeURIComponent(String(contactId))
      )
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = {
        method: 'PUT',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication api_key required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('api_key')
            : await configuration.apiKey
        localVarQueryParameter['api_key'] = localVarApiKeyValue
      }

      // authentication basic_auth required
      // http basic authentication required
      if (configuration && (configuration.username || configuration.password)) {
        localVarRequestOptions['auth'] = {
          username: configuration.username,
          password: configuration.password,
        }
      }

      // authentication username required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('username')
            : await configuration.apiKey
        localVarQueryParameter['username'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      localVarUrlObj.search = null
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const needsSerialization =
        typeof body !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(body !== undefined ? body : {})
        : body || ''

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Creates or updates a contact  You can add arbitrary custom fields to a contact (see [Custom Fields](#todo: add link here))  **Note:** the contact\'s `id` is required in the request payload if the supplied `number` already exists in your contacts  This operation _doesn\'t_ remove properties that aren\'t specified when updating an existing contact  [Use PUT to remove custom fields or groups](#operation/upsertContact)
     * @summary Create/Update Contact
     * @param {UpsertContactRequest} [upsertContactRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    upsertContact: async (
      upsertContactRequest?: UpsertContactRequest,
      options: any = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/v1/contacts`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication api_key required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('api_key')
            : await configuration.apiKey
        localVarQueryParameter['api_key'] = localVarApiKeyValue
      }

      // authentication basic_auth required
      // http basic authentication required
      if (configuration && (configuration.username || configuration.password)) {
        localVarRequestOptions['auth'] = {
          username: configuration.username,
          password: configuration.password,
        }
      }

      // authentication username required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('username')
            : await configuration.apiKey
        localVarQueryParameter['username'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      localVarUrlObj.search = null
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const needsSerialization =
        typeof upsertContactRequest !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(
            upsertContactRequest !== undefined ? upsertContactRequest : {}
          )
        : upsertContactRequest || ''

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * ContactApi - functional programming interface
 * @export
 */
export const ContactApiFp = function (configuration?: Configuration) {
  return {
    /**
     * Creates, updates, or deletes multiple contacts in one request
     * @summary Creates, updates, or deletes multiple contacts in one request
     * @param {BulkUpsertContactRequest} [bulkUpsertContactRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async bulkUpsertContacts(
      bulkUpsertContactRequest?: BulkUpsertContactRequest,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<any>>
    > {
      const localVarAxiosArgs = await ContactApiAxiosParamCreator(
        configuration
      ).bulkUpsertContacts(bulkUpsertContactRequest, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Deletes a contact
     * @summary Delete Contact
     * @param {number | string} contactId The contact ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteContact(
      contactId: number | string,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await ContactApiAxiosParamCreator(
        configuration
      ).deleteContact(contactId, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Retrieves a contact by its id
     * @summary Get Contact
     * @param {number | string} contactId The contact ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getContact(
      contactId: number | string,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Contact>
    > {
      const localVarAxiosArgs = await ContactApiAxiosParamCreator(
        configuration
      ).getContact(contactId, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Gets a list of contacts  See also: [List Group Contacts](#listGroupContacts)
     * @summary List Contacts
     * @param {number} [limit] (Pagination) How many records to return
     * @param {number} [offset] (Pagination) How many records to skip
     * @param {string} [number] Filters contacts by their phone &#x60;number&#x60;    The value _**must**_ be in the E.164 format and URI-encoded (eg. &#x60;+18004445555&#x60; would become &#x60;%2B18004445555&#x60;)
     * @param {string} [name] Filters contacts by their &#x60;name&#x60; (Will only return contacts whose name matches **exactly**)
     * @param {boolean} [screened] Filters the contacts by their &#x60;screened&#x60; status (eg. if _**you**_ blocked them)
     * @param {boolean} [blocked] Filters the contacts by opt-out status (eg. if they texted &#x60;Stop&#x60;, &#x60;Cancel&#x60;, &#x60;Block&#x60;, &#x60;Quit&#x60; or &#x60;End&#x60; - [more info](https://sendhub.force.com/support/s/article/SendHub-Number-FAQ))
     * @param {'name' | '-name' | 'date_created' | '-date_created' | 'date_modified' | '-date_modified' | 'id' | '-id' | 'blocked' | '-blocked' | 'screened' | '-screened' | 'is_owned' | '-is_owned' | 'keyword' | '-keyword' | 'number' | '-number'} [ordering] Sort contacts by a specified field (prepend a hyphen to reverse order)  **Must** be a built-in contact field, not a custom field
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listContacts(
      limit?: number,
      offset?: number,
      number?: string,
      name?: string,
      screened?: boolean,
      blocked?: boolean,
      ordering?:
        | 'name'
        | '-name'
        | 'date_created'
        | '-date_created'
        | 'date_modified'
        | '-date_modified'
        | 'id'
        | '-id'
        | 'blocked'
        | '-blocked'
        | 'screened'
        | '-screened'
        | 'is_owned'
        | '-is_owned'
        | 'keyword'
        | '-keyword'
        | 'number'
        | '-number',
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<ListContacts200Response>
    > {
      const localVarAxiosArgs = await ContactApiAxiosParamCreator(
        configuration
      ).listContacts(
        limit,
        offset,
        number,
        name,
        screened,
        blocked,
        ordering,
        options
      )
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Lists contacts in a specified group
     * @summary List Group\'s Contacts
     * @param {string} groupId The group ID
     * @param {number} [limit] (Pagination) How many records to return
     * @param {number} [offset] (Pagination) How many records to skip
     * @param {string} [number] Filters contacts by their phone &#x60;number&#x60;    The value _**must**_ be in the E.164 format and URI-encoded (eg. &#x60;+18004445555&#x60; would become &#x60;%2B18004445555&#x60;)
     * @param {string} [name] Filters contacts by their &#x60;name&#x60; (Will only return contacts whose name matches **exactly**)
     * @param {boolean} [screened] Filters the contacts by their &#x60;screened&#x60; status (eg. if _**you**_ blocked them)
     * @param {boolean} [blocked] Filters the contacts by opt-out status (eg. if they texted &#x60;Stop&#x60;, &#x60;Cancel&#x60;, &#x60;Block&#x60;, &#x60;Quit&#x60; or &#x60;End&#x60; - [more info](https://sendhub.force.com/support/s/article/SendHub-Number-FAQ))
     * @param {'name' | '-name' | 'date_created' | '-date_created' | 'date_modified' | '-date_modified' | 'id' | '-id' | 'blocked' | '-blocked' | 'screened' | '-screened' | 'is_owned' | '-is_owned' | 'keyword' | '-keyword' | 'number' | '-number'} [ordering] Sort contacts by a specified field (prepend a hyphen to reverse order)  **Must** be a built-in contact field, not a custom field
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listGroupContacts(
      groupId: string,
      limit?: number,
      offset?: number,
      number?: string,
      name?: string,
      screened?: boolean,
      blocked?: boolean,
      ordering?:
        | 'name'
        | '-name'
        | 'date_created'
        | '-date_created'
        | 'date_modified'
        | '-date_modified'
        | 'id'
        | '-id'
        | 'blocked'
        | '-blocked'
        | 'screened'
        | '-screened'
        | 'is_owned'
        | '-is_owned'
        | 'keyword'
        | '-keyword'
        | 'number'
        | '-number',
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<ListContacts200Response1>
    > {
      const localVarAxiosArgs = await ContactApiAxiosParamCreator(
        configuration
      ).listGroupContacts(
        groupId,
        limit,
        offset,
        number,
        name,
        screened,
        blocked,
        ordering,
        options
      )
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Updates an individual contact referenced by its id  You can add arbitrary custom fields to a contact (see [Custom Fields](#todo: ))  **Note:** this is a _replace_ operation; any properties the contact already has that you don\'t specify in your request will be removed  [Use POST for _upsert_ functionality](#operation/upsertContact)
     * @summary Update Contact
     * @param {number | string} contactId The contact ID
     * @param {UpsertContactRequestWithId} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateContact(
      contactId: number | string,
      body?: UpsertContactRequestWithId,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<{ [key: string]: string }>
    > {
      const localVarAxiosArgs = await ContactApiAxiosParamCreator(
        configuration
      ).updateContact(contactId, body, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Creates or updates a contact  You can add arbitrary custom fields to a contact (see [Custom Fields](#todo: add link here))  **Note:** the contact\'s `id` is required in the request payload if the supplied `number` already exists in your contacts  This operation _doesn\'t_ remove properties that aren\'t specified when updating an existing contact  [Use PUT to remove custom fields or groups](#operation/upsertContact)
     * @summary Create/Update Contact
     * @param {UpsertContactRequest} [upsertContactRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async upsertContact(
      upsertContactRequest?: UpsertContactRequest,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>
    > {
      const localVarAxiosArgs = await ContactApiAxiosParamCreator(
        configuration
      ).upsertContact(upsertContactRequest, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
  }
}

/**
 * ContactApi - factory interface
 * @export
 */
export const ContactApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     * Creates, updates, or deletes multiple contacts in one request
     * @summary Creates, updates, or deletes multiple contacts in one request
     * @param {BulkUpsertContactRequest} [bulkUpsertContactRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    bulkUpsertContacts(
      bulkUpsertContactRequest?: BulkUpsertContactRequest,
      options?: any
    ): AxiosPromise<Array<any>> {
      return ContactApiFp(configuration)
        .bulkUpsertContacts(bulkUpsertContactRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Deletes a contact
     * @summary Delete Contact
     * @param {number | string} contactId The contact ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteContact(
      contactId: number | string,
      options?: any
    ): AxiosPromise<void> {
      return ContactApiFp(configuration)
        .deleteContact(contactId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieves a contact by its id
     * @summary Get Contact
     * @param {number | string} contactId The contact ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getContact(
      contactId: number | string,
      options?: any
    ): AxiosPromise<Contact> {
      return ContactApiFp(configuration)
        .getContact(contactId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Gets a list of contacts  See also: [List Group Contacts](#listGroupContacts)
     * @summary List Contacts
     * @param {number} [limit] (Pagination) How many records to return
     * @param {number} [offset] (Pagination) How many records to skip
     * @param {string} [number] Filters contacts by their phone &#x60;number&#x60;    The value _**must**_ be in the E.164 format and URI-encoded (eg. &#x60;+18004445555&#x60; would become &#x60;%2B18004445555&#x60;)
     * @param {string} [name] Filters contacts by their &#x60;name&#x60; (Will only return contacts whose name matches **exactly**)
     * @param {boolean} [screened] Filters the contacts by their &#x60;screened&#x60; status (eg. if _**you**_ blocked them)
     * @param {boolean} [blocked] Filters the contacts by opt-out status (eg. if they texted &#x60;Stop&#x60;, &#x60;Cancel&#x60;, &#x60;Block&#x60;, &#x60;Quit&#x60; or &#x60;End&#x60; - [more info](https://sendhub.force.com/support/s/article/SendHub-Number-FAQ))
     * @param {'name' | '-name' | 'date_created' | '-date_created' | 'date_modified' | '-date_modified' | 'id' | '-id' | 'blocked' | '-blocked' | 'screened' | '-screened' | 'is_owned' | '-is_owned' | 'keyword' | '-keyword' | 'number' | '-number'} [ordering] Sort contacts by a specified field (prepend a hyphen to reverse order)  **Must** be a built-in contact field, not a custom field
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listContacts(
      limit?: number,
      offset?: number,
      number?: string,
      name?: string,
      screened?: boolean,
      blocked?: boolean,
      ordering?:
        | 'name'
        | '-name'
        | 'date_created'
        | '-date_created'
        | 'date_modified'
        | '-date_modified'
        | 'id'
        | '-id'
        | 'blocked'
        | '-blocked'
        | 'screened'
        | '-screened'
        | 'is_owned'
        | '-is_owned'
        | 'keyword'
        | '-keyword'
        | 'number'
        | '-number',
      options?: any
    ): AxiosPromise<ListContacts200Response> {
      return ContactApiFp(configuration)
        .listContacts(
          limit,
          offset,
          number,
          name,
          screened,
          blocked,
          ordering,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Lists contacts in a specified group
     * @summary List Group\'s Contacts
     * @param {string} groupId The group ID
     * @param {number} [limit] (Pagination) How many records to return
     * @param {number} [offset] (Pagination) How many records to skip
     * @param {string} [number] Filters contacts by their phone &#x60;number&#x60;    The value _**must**_ be in the E.164 format and URI-encoded (eg. &#x60;+18004445555&#x60; would become &#x60;%2B18004445555&#x60;)
     * @param {string} [name] Filters contacts by their &#x60;name&#x60; (Will only return contacts whose name matches **exactly**)
     * @param {boolean} [screened] Filters the contacts by their &#x60;screened&#x60; status (eg. if _**you**_ blocked them)
     * @param {boolean} [blocked] Filters the contacts by opt-out status (eg. if they texted &#x60;Stop&#x60;, &#x60;Cancel&#x60;, &#x60;Block&#x60;, &#x60;Quit&#x60; or &#x60;End&#x60; - [more info](https://sendhub.force.com/support/s/article/SendHub-Number-FAQ))
     * @param {'name' | '-name' | 'date_created' | '-date_created' | 'date_modified' | '-date_modified' | 'id' | '-id' | 'blocked' | '-blocked' | 'screened' | '-screened' | 'is_owned' | '-is_owned' | 'keyword' | '-keyword' | 'number' | '-number'} [ordering] Sort contacts by a specified field (prepend a hyphen to reverse order)  **Must** be a built-in contact field, not a custom field
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listGroupContacts(
      groupId: string,
      limit?: number,
      offset?: number,
      number?: string,
      name?: string,
      screened?: boolean,
      blocked?: boolean,
      ordering?:
        | 'name'
        | '-name'
        | 'date_created'
        | '-date_created'
        | 'date_modified'
        | '-date_modified'
        | 'id'
        | '-id'
        | 'blocked'
        | '-blocked'
        | 'screened'
        | '-screened'
        | 'is_owned'
        | '-is_owned'
        | 'keyword'
        | '-keyword'
        | 'number'
        | '-number',
      options?: any
    ): AxiosPromise<ListContacts200Response1> {
      return ContactApiFp(configuration)
        .listGroupContacts(
          groupId,
          limit,
          offset,
          number,
          name,
          screened,
          blocked,
          ordering,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Updates an individual contact referenced by its id  You can add arbitrary custom fields to a contact (see [Custom Fields](#todo: ))  **Note:** this is a _replace_ operation; any properties the contact already has that you don\'t specify in your request will be removed  [Use POST for _upsert_ functionality](#operation/upsertContact)
     * @summary Update Contact
     * @param {number | string} contactId The contact ID
     * @param {UpsertContactRequestWithId} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateContact(
      contactId: number | string,
      body?: UpsertContactRequestWithId,
      options?: any
    ): AxiosPromise<{ [key: string]: string }> {
      return ContactApiFp(configuration)
        .updateContact(contactId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Creates or updates a contact  You can add arbitrary custom fields to a contact (see [Custom Fields](#todo: add link here))  **Note:** the contact\'s `id` is required in the request payload if the supplied `number` already exists in your contacts  This operation _doesn\'t_ remove properties that aren\'t specified when updating an existing contact  [Use PUT to remove custom fields or groups](#operation/upsertContact)
     * @summary Create/Update Contact
     * @param {UpsertContactRequest} [upsertContactRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    upsertContact(
      upsertContactRequest?: UpsertContactRequest,
      options?: any
    ): AxiosPromise<any> {
      return ContactApiFp(configuration)
        .upsertContact(upsertContactRequest, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * ContactApi - interface
 * @export
 * @interface ContactApi
 */
export interface ContactApiInterface {
  /**
   * Creates, updates, or deletes multiple contacts in one request
   * @summary Creates, updates, or deletes multiple contacts in one request
   * @param {BulkUpsertContactRequest} [bulkUpsertContactRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContactApiInterface
   */
  bulkUpsertContacts(
    bulkUpsertContactRequest?: BulkUpsertContactRequest,
    options?: any
  ): AxiosPromise<Array<any>>

  /**
   * Deletes a contact
   * @summary Delete Contact
   * @param {number | string} contactId The contact ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContactApiInterface
   */
  deleteContact(contactId: number | string, options?: any): AxiosPromise<void>

  /**
   * Retrieves a contact by its id
   * @summary Get Contact
   * @param {number | string} contactId The contact ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContactApiInterface
   */
  getContact(contactId: number | string, options?: any): AxiosPromise<Contact>

  /**
   * Gets a list of contacts  See also: [List Group Contacts](#listGroupContacts)
   * @summary List Contacts
   * @param {number} [limit] (Pagination) How many records to return
   * @param {number} [offset] (Pagination) How many records to skip
   * @param {string} [number] Filters contacts by their phone &#x60;number&#x60;    The value _**must**_ be in the E.164 format and URI-encoded (eg. &#x60;+18004445555&#x60; would become &#x60;%2B18004445555&#x60;)
   * @param {string} [name] Filters contacts by their &#x60;name&#x60; (Will only return contacts whose name matches **exactly**)
   * @param {boolean} [screened] Filters the contacts by their &#x60;screened&#x60; status (eg. if _**you**_ blocked them)
   * @param {boolean} [blocked] Filters the contacts by opt-out status (eg. if they texted &#x60;Stop&#x60;, &#x60;Cancel&#x60;, &#x60;Block&#x60;, &#x60;Quit&#x60; or &#x60;End&#x60; - [more info](https://sendhub.force.com/support/s/article/SendHub-Number-FAQ))
   * @param {'name' | '-name' | 'date_created' | '-date_created' | 'date_modified' | '-date_modified' | 'id' | '-id' | 'blocked' | '-blocked' | 'screened' | '-screened' | 'is_owned' | '-is_owned' | 'keyword' | '-keyword' | 'number' | '-number'} [ordering] Sort contacts by a specified field (prepend a hyphen to reverse order)  **Must** be a built-in contact field, not a custom field
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContactApiInterface
   */
  listContacts(
    limit?: number,
    offset?: number,
    number?: string,
    name?: string,
    screened?: boolean,
    blocked?: boolean,
    ordering?:
      | 'name'
      | '-name'
      | 'date_created'
      | '-date_created'
      | 'date_modified'
      | '-date_modified'
      | 'id'
      | '-id'
      | 'blocked'
      | '-blocked'
      | 'screened'
      | '-screened'
      | 'is_owned'
      | '-is_owned'
      | 'keyword'
      | '-keyword'
      | 'number'
      | '-number',
    options?: any
  ): AxiosPromise<ListContacts200Response>

  /**
   * Lists contacts in a specified group
   * @summary List Group\'s Contacts
   * @param {string} groupId The group ID
   * @param {number} [limit] (Pagination) How many records to return
   * @param {number} [offset] (Pagination) How many records to skip
   * @param {string} [number] Filters contacts by their phone &#x60;number&#x60;    The value _**must**_ be in the E.164 format and URI-encoded (eg. &#x60;+18004445555&#x60; would become &#x60;%2B18004445555&#x60;)
   * @param {string} [name] Filters contacts by their &#x60;name&#x60; (Will only return contacts whose name matches **exactly**)
   * @param {boolean} [screened] Filters the contacts by their &#x60;screened&#x60; status (eg. if _**you**_ blocked them)
   * @param {boolean} [blocked] Filters the contacts by opt-out status (eg. if they texted &#x60;Stop&#x60;, &#x60;Cancel&#x60;, &#x60;Block&#x60;, &#x60;Quit&#x60; or &#x60;End&#x60; - [more info](https://sendhub.force.com/support/s/article/SendHub-Number-FAQ))
   * @param {'name' | '-name' | 'date_created' | '-date_created' | 'date_modified' | '-date_modified' | 'id' | '-id' | 'blocked' | '-blocked' | 'screened' | '-screened' | 'is_owned' | '-is_owned' | 'keyword' | '-keyword' | 'number' | '-number'} [ordering] Sort contacts by a specified field (prepend a hyphen to reverse order)  **Must** be a built-in contact field, not a custom field
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContactApiInterface
   */
  listGroupContacts(
    groupId: string,
    limit?: number,
    offset?: number,
    number?: string,
    name?: string,
    screened?: boolean,
    blocked?: boolean,
    ordering?:
      | 'name'
      | '-name'
      | 'date_created'
      | '-date_created'
      | 'date_modified'
      | '-date_modified'
      | 'id'
      | '-id'
      | 'blocked'
      | '-blocked'
      | 'screened'
      | '-screened'
      | 'is_owned'
      | '-is_owned'
      | 'keyword'
      | '-keyword'
      | 'number'
      | '-number',
    options?: any
  ): AxiosPromise<ListContacts200Response1>

  /**
   * Updates an individual contact referenced by its id  You can add arbitrary custom fields to a contact (see [Custom Fields](#todo: ))  **Note:** this is a _replace_ operation; any properties the contact already has that you don\'t specify in your request will be removed  [Use POST for _upsert_ functionality](#operation/upsertContact)
   * @summary Update Contact
   * @param {number | string} contactId The contact ID
   * @param {UpsertContactRequestWithId} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContactApiInterface
   */
  updateContact(
    contactId: number | string,
    body?: UpsertContactRequestWithId,
    options?: any
  ): AxiosPromise<{ [key: string]: string }>

  /**
   * Creates or updates a contact  You can add arbitrary custom fields to a contact (see [Custom Fields](#todo: add link here))  **Note:** the contact\'s `id` is required in the request payload if the supplied `number` already exists in your contacts  This operation _doesn\'t_ remove properties that aren\'t specified when updating an existing contact  [Use PUT to remove custom fields or groups](#operation/upsertContact)
   * @summary Create/Update Contact
   * @param {UpsertContactRequest} [upsertContactRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContactApiInterface
   */
  upsertContact(
    upsertContactRequest?: UpsertContactRequest,
    options?: any
  ): AxiosPromise<any>
}

/**
 * ContactApi - object-oriented interface
 * @export
 * @class ContactApi
 * @extends {BaseAPI}
 */
export class ContactApi extends BaseAPI implements ContactApiInterface {
  /**
   * Creates, updates, or deletes multiple contacts in one request
   * @summary Creates, updates, or deletes multiple contacts in one request
   * @param {BulkUpsertContactRequest} [bulkUpsertContactRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContactApi
   */
  public bulkUpsertContacts(
    bulkUpsertContactRequest?: BulkUpsertContactRequest,
    options?: any
  ) {
    return ContactApiFp(this.configuration)
      .bulkUpsertContacts(bulkUpsertContactRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Deletes a contact
   * @summary Delete Contact
   * @param {number | string} contactId The contact ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContactApi
   */
  public deleteContact(contactId: number | string, options?: any) {
    return ContactApiFp(this.configuration)
      .deleteContact(contactId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieves a contact by its id
   * @summary Get Contact
   * @param {number | string} contactId The contact ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContactApi
   */
  public getContact(contactId: number | string, options?: any) {
    return ContactApiFp(this.configuration)
      .getContact(contactId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Gets a list of contacts  See also: [List Group Contacts](#listGroupContacts)
   * @summary List Contacts
   * @param {number} [limit] (Pagination) How many records to return
   * @param {number} [offset] (Pagination) How many records to skip
   * @param {string} [number] Filters contacts by their phone &#x60;number&#x60;    The value _**must**_ be in the E.164 format and URI-encoded (eg. &#x60;+18004445555&#x60; would become &#x60;%2B18004445555&#x60;)
   * @param {string} [name] Filters contacts by their &#x60;name&#x60; (Will only return contacts whose name matches **exactly**)
   * @param {boolean} [screened] Filters the contacts by their &#x60;screened&#x60; status (eg. if _**you**_ blocked them)
   * @param {boolean} [blocked] Filters the contacts by opt-out status (eg. if they texted &#x60;Stop&#x60;, &#x60;Cancel&#x60;, &#x60;Block&#x60;, &#x60;Quit&#x60; or &#x60;End&#x60; - [more info](https://sendhub.force.com/support/s/article/SendHub-Number-FAQ))
   * @param {'name' | '-name' | 'date_created' | '-date_created' | 'date_modified' | '-date_modified' | 'id' | '-id' | 'blocked' | '-blocked' | 'screened' | '-screened' | 'is_owned' | '-is_owned' | 'keyword' | '-keyword' | 'number' | '-number'} [ordering] Sort contacts by a specified field (prepend a hyphen to reverse order)  **Must** be a built-in contact field, not a custom field
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContactApi
   */
  public listContacts(
    limit?: number,
    offset?: number,
    number?: string,
    name?: string,
    screened?: boolean,
    blocked?: boolean,
    ordering?:
      | 'name'
      | '-name'
      | 'date_created'
      | '-date_created'
      | 'date_modified'
      | '-date_modified'
      | 'id'
      | '-id'
      | 'blocked'
      | '-blocked'
      | 'screened'
      | '-screened'
      | 'is_owned'
      | '-is_owned'
      | 'keyword'
      | '-keyword'
      | 'number'
      | '-number',
    options?: any
  ) {
    return ContactApiFp(this.configuration)
      .listContacts(
        limit,
        offset,
        number,
        name,
        screened,
        blocked,
        ordering,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Lists contacts in a specified group
   * @summary List Group\'s Contacts
   * @param {string} groupId The group ID
   * @param {number} [limit] (Pagination) How many records to return
   * @param {number} [offset] (Pagination) How many records to skip
   * @param {string} [number] Filters contacts by their phone &#x60;number&#x60;    The value _**must**_ be in the E.164 format and URI-encoded (eg. &#x60;+18004445555&#x60; would become &#x60;%2B18004445555&#x60;)
   * @param {string} [name] Filters contacts by their &#x60;name&#x60; (Will only return contacts whose name matches **exactly**)
   * @param {boolean} [screened] Filters the contacts by their &#x60;screened&#x60; status (eg. if _**you**_ blocked them)
   * @param {boolean} [blocked] Filters the contacts by opt-out status (eg. if they texted &#x60;Stop&#x60;, &#x60;Cancel&#x60;, &#x60;Block&#x60;, &#x60;Quit&#x60; or &#x60;End&#x60; - [more info](https://sendhub.force.com/support/s/article/SendHub-Number-FAQ))
   * @param {'name' | '-name' | 'date_created' | '-date_created' | 'date_modified' | '-date_modified' | 'id' | '-id' | 'blocked' | '-blocked' | 'screened' | '-screened' | 'is_owned' | '-is_owned' | 'keyword' | '-keyword' | 'number' | '-number'} [ordering] Sort contacts by a specified field (prepend a hyphen to reverse order)  **Must** be a built-in contact field, not a custom field
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContactApi
   */
  public listGroupContacts(
    groupId: string,
    limit?: number,
    offset?: number,
    number?: string,
    name?: string,
    screened?: boolean,
    blocked?: boolean,
    ordering?:
      | 'name'
      | '-name'
      | 'date_created'
      | '-date_created'
      | 'date_modified'
      | '-date_modified'
      | 'id'
      | '-id'
      | 'blocked'
      | '-blocked'
      | 'screened'
      | '-screened'
      | 'is_owned'
      | '-is_owned'
      | 'keyword'
      | '-keyword'
      | 'number'
      | '-number',
    options?: any
  ) {
    return ContactApiFp(this.configuration)
      .listGroupContacts(
        groupId,
        limit,
        offset,
        number,
        name,
        screened,
        blocked,
        ordering,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Updates an individual contact referenced by its id  You can add arbitrary custom fields to a contact (see [Custom Fields](#todo: ))  **Note:** this is a _replace_ operation; any properties the contact already has that you don\'t specify in your request will be removed  [Use POST for _upsert_ functionality](#operation/upsertContact)
   * @summary Update Contact
   * @param {number | string} contactId The contact ID
   * @param {UpsertContactRequestWithId} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContactApi
   */
  public updateContact(
    contactId: number | string,
    body?: UpsertContactRequestWithId,
    options?: any
  ) {
    return ContactApiFp(this.configuration)
      .updateContact(contactId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Creates or updates a contact  You can add arbitrary custom fields to a contact (see [Custom Fields](#todo: add link here))  **Note:** the contact\'s `id` is required in the request payload if the supplied `number` already exists in your contacts  This operation _doesn\'t_ remove properties that aren\'t specified when updating an existing contact  [Use PUT to remove custom fields or groups](#operation/upsertContact)
   * @summary Create/Update Contact
   * @param {UpsertContactRequest} [upsertContactRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ContactApi
   */
  public upsertContact(
    upsertContactRequest?: UpsertContactRequest,
    options?: any
  ) {
    return ContactApiFp(this.configuration)
      .upsertContact(upsertContactRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * GroupApi - axios parameter creator
 * @export
 */
export const GroupApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Add and/or remove contacts from a group
     * @summary Add/Remove Group\'s Contacts
     * @param {string} groupId The group ID
     * @param {AddRemoveGroupContactsRequest} [addRemoveGroupContactsRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addRemoveGroupContacts: async (
      groupId: string,
      addRemoveGroupContactsRequest?: AddRemoveGroupContactsRequest,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'groupId' is not null or undefined
      if (groupId === null || groupId === undefined) {
        throw new RequiredError(
          'groupId',
          'Required parameter groupId was null or undefined when calling addRemoveGroupContacts.'
        )
      }
      const localVarPath = `/v1/groups/{group_id}/contacts`.replace(
        `{${'group_id'}}`,
        encodeURIComponent(String(groupId))
      )
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication api_key required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('api_key')
            : await configuration.apiKey
        localVarQueryParameter['api_key'] = localVarApiKeyValue
      }

      // authentication basic_auth required
      // http basic authentication required
      if (configuration && (configuration.username || configuration.password)) {
        localVarRequestOptions['auth'] = {
          username: configuration.username,
          password: configuration.password,
        }
      }

      // authentication username required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('username')
            : await configuration.apiKey
        localVarQueryParameter['username'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      localVarUrlObj.search = null
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const needsSerialization =
        typeof addRemoveGroupContactsRequest !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(
            addRemoveGroupContactsRequest !== undefined
              ? addRemoveGroupContactsRequest
              : {}
          )
        : addRemoveGroupContactsRequest || ''

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Creates a group
     * @summary Create Group
     * @param {InlineObject} [inlineObject]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createGroup: async (
      inlineObject?: InlineObject,
      options: any = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/v1/groups`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication api_key required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('api_key')
            : await configuration.apiKey
        localVarQueryParameter['api_key'] = localVarApiKeyValue
      }

      // authentication basic_auth required
      // http basic authentication required
      if (configuration && (configuration.username || configuration.password)) {
        localVarRequestOptions['auth'] = {
          username: configuration.username,
          password: configuration.password,
        }
      }

      // authentication username required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('username')
            : await configuration.apiKey
        localVarQueryParameter['username'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      localVarUrlObj.search = null
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const needsSerialization =
        typeof inlineObject !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(inlineObject !== undefined ? inlineObject : {})
        : inlineObject || ''

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Deletes a group
     * @summary Delete Group
     * @param {string} groupId The group ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteGroup: async (
      groupId: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'groupId' is not null or undefined
      if (groupId === null || groupId === undefined) {
        throw new RequiredError(
          'groupId',
          'Required parameter groupId was null or undefined when calling deleteGroup.'
        )
      }
      const localVarPath = `/v1/groups/{group_id}`.replace(
        `{${'group_id'}}`,
        encodeURIComponent(String(groupId))
      )
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = {
        method: 'DELETE',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication api_key required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('api_key')
            : await configuration.apiKey
        localVarQueryParameter['api_key'] = localVarApiKeyValue
      }

      // authentication basic_auth required
      // http basic authentication required
      if (configuration && (configuration.username || configuration.password)) {
        localVarRequestOptions['auth'] = {
          username: configuration.username,
          password: configuration.password,
        }
      }

      // authentication username required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('username')
            : await configuration.apiKey
        localVarQueryParameter['username'] = localVarApiKeyValue
      }

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      localVarUrlObj.search = null
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Gets an individual group by its id
     * @summary Get Group
     * @param {string} groupId The group ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getGroup: async (
      groupId: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'groupId' is not null or undefined
      if (groupId === null || groupId === undefined) {
        throw new RequiredError(
          'groupId',
          'Required parameter groupId was null or undefined when calling getGroup.'
        )
      }
      const localVarPath = `/v1/groups/{group_id}`.replace(
        `{${'group_id'}}`,
        encodeURIComponent(String(groupId))
      )
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication api_key required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('api_key')
            : await configuration.apiKey
        localVarQueryParameter['api_key'] = localVarApiKeyValue
      }

      // authentication basic_auth required
      // http basic authentication required
      if (configuration && (configuration.username || configuration.password)) {
        localVarRequestOptions['auth'] = {
          username: configuration.username,
          password: configuration.password,
        }
      }

      // authentication username required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('username')
            : await configuration.apiKey
        localVarQueryParameter['username'] = localVarApiKeyValue
      }

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      localVarUrlObj.search = null
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Lists contacts in a specified group
     * @summary List Group\'s Contacts
     * @param {string} groupId The group ID
     * @param {number} [limit] (Pagination) How many records to return
     * @param {number} [offset] (Pagination) How many records to skip
     * @param {string} [number] Filters contacts by their phone &#x60;number&#x60;    The value _**must**_ be in the E.164 format and URI-encoded (eg. &#x60;+18004445555&#x60; would become &#x60;%2B18004445555&#x60;)
     * @param {string} [name] Filters contacts by their &#x60;name&#x60; (Will only return contacts whose name matches **exactly**)
     * @param {boolean} [screened] Filters the contacts by their &#x60;screened&#x60; status (eg. if _**you**_ blocked them)
     * @param {boolean} [blocked] Filters the contacts by opt-out status (eg. if they texted &#x60;Stop&#x60;, &#x60;Cancel&#x60;, &#x60;Block&#x60;, &#x60;Quit&#x60; or &#x60;End&#x60; - [more info](https://sendhub.force.com/support/s/article/SendHub-Number-FAQ))
     * @param {'name' | '-name' | 'date_created' | '-date_created' | 'date_modified' | '-date_modified' | 'id' | '-id' | 'blocked' | '-blocked' | 'screened' | '-screened' | 'is_owned' | '-is_owned' | 'keyword' | '-keyword' | 'number' | '-number'} [ordering] Sort contacts by a specified field (prepend a hyphen to reverse order)  **Must** be a built-in contact field, not a custom field
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listGroupContacts: async (
      groupId: string,
      limit?: number,
      offset?: number,
      number?: string,
      name?: string,
      screened?: boolean,
      blocked?: boolean,
      ordering?:
        | 'name'
        | '-name'
        | 'date_created'
        | '-date_created'
        | 'date_modified'
        | '-date_modified'
        | 'id'
        | '-id'
        | 'blocked'
        | '-blocked'
        | 'screened'
        | '-screened'
        | 'is_owned'
        | '-is_owned'
        | 'keyword'
        | '-keyword'
        | 'number'
        | '-number',
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'groupId' is not null or undefined
      if (groupId === null || groupId === undefined) {
        throw new RequiredError(
          'groupId',
          'Required parameter groupId was null or undefined when calling listGroupContacts.'
        )
      }
      const localVarPath = `/v1/groups/{group_id}/contacts`.replace(
        `{${'group_id'}}`,
        encodeURIComponent(String(groupId))
      )
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication api_key required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('api_key')
            : await configuration.apiKey
        localVarQueryParameter['api_key'] = localVarApiKeyValue
      }

      // authentication basic_auth required
      // http basic authentication required
      if (configuration && (configuration.username || configuration.password)) {
        localVarRequestOptions['auth'] = {
          username: configuration.username,
          password: configuration.password,
        }
      }

      // authentication username required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('username')
            : await configuration.apiKey
        localVarQueryParameter['username'] = localVarApiKeyValue
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      if (offset !== undefined) {
        localVarQueryParameter['offset'] = offset
      }

      if (number !== undefined) {
        localVarQueryParameter['number'] = number
      }

      if (name !== undefined) {
        localVarQueryParameter['name'] = name
      }

      if (screened !== undefined) {
        localVarQueryParameter['screened'] = screened
      }

      if (blocked !== undefined) {
        localVarQueryParameter['blocked'] = blocked
      }

      if (ordering !== undefined) {
        localVarQueryParameter['ordering'] = ordering
      }

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      localVarUrlObj.search = null
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Gets a list of groups
     * @summary List Groups
     * @param {number} [limit] (Pagination) How many records to return
     * @param {number} [offset] (Pagination) How many records to skip
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listGroups: async (
      limit?: number,
      offset?: number,
      options: any = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/v1/groups`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication api_key required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('api_key')
            : await configuration.apiKey
        localVarQueryParameter['api_key'] = localVarApiKeyValue
      }

      // authentication basic_auth required
      // http basic authentication required
      if (configuration && (configuration.username || configuration.password)) {
        localVarRequestOptions['auth'] = {
          username: configuration.username,
          password: configuration.password,
        }
      }

      // authentication username required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('username')
            : await configuration.apiKey
        localVarQueryParameter['username'] = localVarApiKeyValue
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      if (offset !== undefined) {
        localVarQueryParameter['offset'] = offset
      }

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      localVarUrlObj.search = null
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Updates an individual group referenced by its id  **Note:** this is a _replace_ operation; any properties the group already has that you don\'t specify in your request will be set to their defaults
     * @summary Update Group
     * @param {string} groupId The group ID
     * @param {InlineObject1} [inlineObject1]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateGroup: async (
      groupId: string,
      inlineObject1?: InlineObject1,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'groupId' is not null or undefined
      if (groupId === null || groupId === undefined) {
        throw new RequiredError(
          'groupId',
          'Required parameter groupId was null or undefined when calling updateGroup.'
        )
      }
      const localVarPath = `/v1/groups/{group_id}`.replace(
        `{${'group_id'}}`,
        encodeURIComponent(String(groupId))
      )
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = {
        method: 'PUT',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication api_key required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('api_key')
            : await configuration.apiKey
        localVarQueryParameter['api_key'] = localVarApiKeyValue
      }

      // authentication basic_auth required
      // http basic authentication required
      if (configuration && (configuration.username || configuration.password)) {
        localVarRequestOptions['auth'] = {
          username: configuration.username,
          password: configuration.password,
        }
      }

      // authentication username required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('username')
            : await configuration.apiKey
        localVarQueryParameter['username'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      localVarUrlObj.search = null
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const needsSerialization =
        typeof inlineObject1 !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(inlineObject1 !== undefined ? inlineObject1 : {})
        : inlineObject1 || ''

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * GroupApi - functional programming interface
 * @export
 */
export const GroupApiFp = function (configuration?: Configuration) {
  return {
    /**
     * Add and/or remove contacts from a group
     * @summary Add/Remove Group\'s Contacts
     * @param {string} groupId The group ID
     * @param {AddRemoveGroupContactsRequest} [addRemoveGroupContactsRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async addRemoveGroupContacts(
      groupId: string,
      addRemoveGroupContactsRequest?: AddRemoveGroupContactsRequest,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<InlineResponse202>
    > {
      const localVarAxiosArgs = await GroupApiAxiosParamCreator(
        configuration
      ).addRemoveGroupContacts(groupId, addRemoveGroupContactsRequest, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Creates a group
     * @summary Create Group
     * @param {InlineObject} [inlineObject]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createGroup(
      inlineObject?: InlineObject,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<InlineResponse201>
    > {
      const localVarAxiosArgs = await GroupApiAxiosParamCreator(
        configuration
      ).createGroup(inlineObject, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Deletes a group
     * @summary Delete Group
     * @param {string} groupId The group ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteGroup(
      groupId: string,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await GroupApiAxiosParamCreator(
        configuration
      ).deleteGroup(groupId, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Gets an individual group by its id
     * @summary Get Group
     * @param {string} groupId The group ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getGroup(
      groupId: string,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<InlineResponse200Objects>
    > {
      const localVarAxiosArgs = await GroupApiAxiosParamCreator(
        configuration
      ).getGroup(groupId, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Lists contacts in a specified group
     * @summary List Group\'s Contacts
     * @param {string} groupId The group ID
     * @param {number} [limit] (Pagination) How many records to return
     * @param {number} [offset] (Pagination) How many records to skip
     * @param {string} [number] Filters contacts by their phone &#x60;number&#x60;    The value _**must**_ be in the E.164 format and URI-encoded (eg. &#x60;+18004445555&#x60; would become &#x60;%2B18004445555&#x60;)
     * @param {string} [name] Filters contacts by their &#x60;name&#x60; (Will only return contacts whose name matches **exactly**)
     * @param {boolean} [screened] Filters the contacts by their &#x60;screened&#x60; status (eg. if _**you**_ blocked them)
     * @param {boolean} [blocked] Filters the contacts by opt-out status (eg. if they texted &#x60;Stop&#x60;, &#x60;Cancel&#x60;, &#x60;Block&#x60;, &#x60;Quit&#x60; or &#x60;End&#x60; - [more info](https://sendhub.force.com/support/s/article/SendHub-Number-FAQ))
     * @param {'name' | '-name' | 'date_created' | '-date_created' | 'date_modified' | '-date_modified' | 'id' | '-id' | 'blocked' | '-blocked' | 'screened' | '-screened' | 'is_owned' | '-is_owned' | 'keyword' | '-keyword' | 'number' | '-number'} [ordering] Sort contacts by a specified field (prepend a hyphen to reverse order)  **Must** be a built-in contact field, not a custom field
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listGroupContacts(
      groupId: string,
      limit?: number,
      offset?: number,
      number?: string,
      name?: string,
      screened?: boolean,
      blocked?: boolean,
      ordering?:
        | 'name'
        | '-name'
        | 'date_created'
        | '-date_created'
        | 'date_modified'
        | '-date_modified'
        | 'id'
        | '-id'
        | 'blocked'
        | '-blocked'
        | 'screened'
        | '-screened'
        | 'is_owned'
        | '-is_owned'
        | 'keyword'
        | '-keyword'
        | 'number'
        | '-number',
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<ListContacts200Response1>
    > {
      const localVarAxiosArgs = await GroupApiAxiosParamCreator(
        configuration
      ).listGroupContacts(
        groupId,
        limit,
        offset,
        number,
        name,
        screened,
        blocked,
        ordering,
        options
      )
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Gets a list of groups
     * @summary List Groups
     * @param {number} [limit] (Pagination) How many records to return
     * @param {number} [offset] (Pagination) How many records to skip
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listGroups(
      limit?: number,
      offset?: number,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<InlineResponse200>
    > {
      const localVarAxiosArgs = await GroupApiAxiosParamCreator(
        configuration
      ).listGroups(limit, offset, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Updates an individual group referenced by its id  **Note:** this is a _replace_ operation; any properties the group already has that you don\'t specify in your request will be set to their defaults
     * @summary Update Group
     * @param {string} groupId The group ID
     * @param {InlineObject1} [inlineObject1]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateGroup(
      groupId: string,
      inlineObject1?: InlineObject1,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<InlineResponse201>
    > {
      const localVarAxiosArgs = await GroupApiAxiosParamCreator(
        configuration
      ).updateGroup(groupId, inlineObject1, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
  }
}

/**
 * GroupApi - factory interface
 * @export
 */
export const GroupApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     * Add and/or remove contacts from a group
     * @summary Add/Remove Group\'s Contacts
     * @param {string} groupId The group ID
     * @param {AddRemoveGroupContactsRequest} [addRemoveGroupContactsRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addRemoveGroupContacts(
      groupId: string,
      addRemoveGroupContactsRequest?: AddRemoveGroupContactsRequest,
      options?: any
    ): AxiosPromise<InlineResponse202> {
      return GroupApiFp(configuration)
        .addRemoveGroupContacts(groupId, addRemoveGroupContactsRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Creates a group
     * @summary Create Group
     * @param {InlineObject} [inlineObject]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createGroup(
      inlineObject?: InlineObject,
      options?: any
    ): AxiosPromise<InlineResponse201> {
      return GroupApiFp(configuration)
        .createGroup(inlineObject, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Deletes a group
     * @summary Delete Group
     * @param {string} groupId The group ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteGroup(groupId: string, options?: any): AxiosPromise<void> {
      return GroupApiFp(configuration)
        .deleteGroup(groupId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Gets an individual group by its id
     * @summary Get Group
     * @param {string} groupId The group ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getGroup(
      groupId: string,
      options?: any
    ): AxiosPromise<InlineResponse200Objects> {
      return GroupApiFp(configuration)
        .getGroup(groupId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Lists contacts in a specified group
     * @summary List Group\'s Contacts
     * @param {string} groupId The group ID
     * @param {number} [limit] (Pagination) How many records to return
     * @param {number} [offset] (Pagination) How many records to skip
     * @param {string} [number] Filters contacts by their phone &#x60;number&#x60;    The value _**must**_ be in the E.164 format and URI-encoded (eg. &#x60;+18004445555&#x60; would become &#x60;%2B18004445555&#x60;)
     * @param {string} [name] Filters contacts by their &#x60;name&#x60; (Will only return contacts whose name matches **exactly**)
     * @param {boolean} [screened] Filters the contacts by their &#x60;screened&#x60; status (eg. if _**you**_ blocked them)
     * @param {boolean} [blocked] Filters the contacts by opt-out status (eg. if they texted &#x60;Stop&#x60;, &#x60;Cancel&#x60;, &#x60;Block&#x60;, &#x60;Quit&#x60; or &#x60;End&#x60; - [more info](https://sendhub.force.com/support/s/article/SendHub-Number-FAQ))
     * @param {'name' | '-name' | 'date_created' | '-date_created' | 'date_modified' | '-date_modified' | 'id' | '-id' | 'blocked' | '-blocked' | 'screened' | '-screened' | 'is_owned' | '-is_owned' | 'keyword' | '-keyword' | 'number' | '-number'} [ordering] Sort contacts by a specified field (prepend a hyphen to reverse order)  **Must** be a built-in contact field, not a custom field
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listGroupContacts(
      groupId: string,
      limit?: number,
      offset?: number,
      number?: string,
      name?: string,
      screened?: boolean,
      blocked?: boolean,
      ordering?:
        | 'name'
        | '-name'
        | 'date_created'
        | '-date_created'
        | 'date_modified'
        | '-date_modified'
        | 'id'
        | '-id'
        | 'blocked'
        | '-blocked'
        | 'screened'
        | '-screened'
        | 'is_owned'
        | '-is_owned'
        | 'keyword'
        | '-keyword'
        | 'number'
        | '-number',
      options?: any
    ): AxiosPromise<ListContacts200Response1> {
      return GroupApiFp(configuration)
        .listGroupContacts(
          groupId,
          limit,
          offset,
          number,
          name,
          screened,
          blocked,
          ordering,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Gets a list of groups
     * @summary List Groups
     * @param {number} [limit] (Pagination) How many records to return
     * @param {number} [offset] (Pagination) How many records to skip
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listGroups(
      limit?: number,
      offset?: number,
      options?: any
    ): AxiosPromise<InlineResponse200> {
      return GroupApiFp(configuration)
        .listGroups(limit, offset, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Updates an individual group referenced by its id  **Note:** this is a _replace_ operation; any properties the group already has that you don\'t specify in your request will be set to their defaults
     * @summary Update Group
     * @param {string} groupId The group ID
     * @param {InlineObject1} [inlineObject1]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateGroup(
      groupId: string,
      inlineObject1?: InlineObject1,
      options?: any
    ): AxiosPromise<InlineResponse201> {
      return GroupApiFp(configuration)
        .updateGroup(groupId, inlineObject1, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * GroupApi - interface
 * @export
 * @interface GroupApi
 */
export interface GroupApiInterface {
  /**
   * Add and/or remove contacts from a group
   * @summary Add/Remove Group\'s Contacts
   * @param {string} groupId The group ID
   * @param {AddRemoveGroupContactsRequest} [addRemoveGroupContactsRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GroupApiInterface
   */
  addRemoveGroupContacts(
    groupId: string,
    addRemoveGroupContactsRequest?: AddRemoveGroupContactsRequest,
    options?: any
  ): AxiosPromise<InlineResponse202>

  /**
   * Creates a group
   * @summary Create Group
   * @param {InlineObject} [inlineObject]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GroupApiInterface
   */
  createGroup(
    inlineObject?: InlineObject,
    options?: any
  ): AxiosPromise<InlineResponse201>

  /**
   * Deletes a group
   * @summary Delete Group
   * @param {string} groupId The group ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GroupApiInterface
   */
  deleteGroup(groupId: string, options?: any): AxiosPromise<void>

  /**
   * Gets an individual group by its id
   * @summary Get Group
   * @param {string} groupId The group ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GroupApiInterface
   */
  getGroup(
    groupId: string,
    options?: any
  ): AxiosPromise<InlineResponse200Objects>

  /**
   * Lists contacts in a specified group
   * @summary List Group\'s Contacts
   * @param {string} groupId The group ID
   * @param {number} [limit] (Pagination) How many records to return
   * @param {number} [offset] (Pagination) How many records to skip
   * @param {string} [number] Filters contacts by their phone &#x60;number&#x60;    The value _**must**_ be in the E.164 format and URI-encoded (eg. &#x60;+18004445555&#x60; would become &#x60;%2B18004445555&#x60;)
   * @param {string} [name] Filters contacts by their &#x60;name&#x60; (Will only return contacts whose name matches **exactly**)
   * @param {boolean} [screened] Filters the contacts by their &#x60;screened&#x60; status (eg. if _**you**_ blocked them)
   * @param {boolean} [blocked] Filters the contacts by opt-out status (eg. if they texted &#x60;Stop&#x60;, &#x60;Cancel&#x60;, &#x60;Block&#x60;, &#x60;Quit&#x60; or &#x60;End&#x60; - [more info](https://sendhub.force.com/support/s/article/SendHub-Number-FAQ))
   * @param {'name' | '-name' | 'date_created' | '-date_created' | 'date_modified' | '-date_modified' | 'id' | '-id' | 'blocked' | '-blocked' | 'screened' | '-screened' | 'is_owned' | '-is_owned' | 'keyword' | '-keyword' | 'number' | '-number'} [ordering] Sort contacts by a specified field (prepend a hyphen to reverse order)  **Must** be a built-in contact field, not a custom field
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GroupApiInterface
   */
  listGroupContacts(
    groupId: string,
    limit?: number,
    offset?: number,
    number?: string,
    name?: string,
    screened?: boolean,
    blocked?: boolean,
    ordering?:
      | 'name'
      | '-name'
      | 'date_created'
      | '-date_created'
      | 'date_modified'
      | '-date_modified'
      | 'id'
      | '-id'
      | 'blocked'
      | '-blocked'
      | 'screened'
      | '-screened'
      | 'is_owned'
      | '-is_owned'
      | 'keyword'
      | '-keyword'
      | 'number'
      | '-number',
    options?: any
  ): AxiosPromise<ListContacts200Response1>

  /**
   * Gets a list of groups
   * @summary List Groups
   * @param {number} [limit] (Pagination) How many records to return
   * @param {number} [offset] (Pagination) How many records to skip
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GroupApiInterface
   */
  listGroups(
    limit?: number,
    offset?: number,
    options?: any
  ): AxiosPromise<InlineResponse200>

  /**
   * Updates an individual group referenced by its id  **Note:** this is a _replace_ operation; any properties the group already has that you don\'t specify in your request will be set to their defaults
   * @summary Update Group
   * @param {string} groupId The group ID
   * @param {InlineObject1} [inlineObject1]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GroupApiInterface
   */
  updateGroup(
    groupId: string,
    inlineObject1?: InlineObject1,
    options?: any
  ): AxiosPromise<InlineResponse201>
}

/**
 * GroupApi - object-oriented interface
 * @export
 * @class GroupApi
 * @extends {BaseAPI}
 */
export class GroupApi extends BaseAPI implements GroupApiInterface {
  /**
   * Add and/or remove contacts from a group
   * @summary Add/Remove Group\'s Contacts
   * @param {string} groupId The group ID
   * @param {AddRemoveGroupContactsRequest} [addRemoveGroupContactsRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GroupApi
   */
  public addRemoveGroupContacts(
    groupId: string,
    addRemoveGroupContactsRequest?: AddRemoveGroupContactsRequest,
    options?: any
  ) {
    return GroupApiFp(this.configuration)
      .addRemoveGroupContacts(groupId, addRemoveGroupContactsRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Creates a group
   * @summary Create Group
   * @param {InlineObject} [inlineObject]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GroupApi
   */
  public createGroup(inlineObject?: InlineObject, options?: any) {
    return GroupApiFp(this.configuration)
      .createGroup(inlineObject, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Deletes a group
   * @summary Delete Group
   * @param {string} groupId The group ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GroupApi
   */
  public deleteGroup(groupId: string, options?: any) {
    return GroupApiFp(this.configuration)
      .deleteGroup(groupId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Gets an individual group by its id
   * @summary Get Group
   * @param {string} groupId The group ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GroupApi
   */
  public getGroup(groupId: string, options?: any) {
    return GroupApiFp(this.configuration)
      .getGroup(groupId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Lists contacts in a specified group
   * @summary List Group\'s Contacts
   * @param {string} groupId The group ID
   * @param {number} [limit] (Pagination) How many records to return
   * @param {number} [offset] (Pagination) How many records to skip
   * @param {string} [number] Filters contacts by their phone &#x60;number&#x60;    The value _**must**_ be in the E.164 format and URI-encoded (eg. &#x60;+18004445555&#x60; would become &#x60;%2B18004445555&#x60;)
   * @param {string} [name] Filters contacts by their &#x60;name&#x60; (Will only return contacts whose name matches **exactly**)
   * @param {boolean} [screened] Filters the contacts by their &#x60;screened&#x60; status (eg. if _**you**_ blocked them)
   * @param {boolean} [blocked] Filters the contacts by opt-out status (eg. if they texted &#x60;Stop&#x60;, &#x60;Cancel&#x60;, &#x60;Block&#x60;, &#x60;Quit&#x60; or &#x60;End&#x60; - [more info](https://sendhub.force.com/support/s/article/SendHub-Number-FAQ))
   * @param {'name' | '-name' | 'date_created' | '-date_created' | 'date_modified' | '-date_modified' | 'id' | '-id' | 'blocked' | '-blocked' | 'screened' | '-screened' | 'is_owned' | '-is_owned' | 'keyword' | '-keyword' | 'number' | '-number'} [ordering] Sort contacts by a specified field (prepend a hyphen to reverse order)  **Must** be a built-in contact field, not a custom field
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GroupApi
   */
  public listGroupContacts(
    groupId: string,
    limit?: number,
    offset?: number,
    number?: string,
    name?: string,
    screened?: boolean,
    blocked?: boolean,
    ordering?:
      | 'name'
      | '-name'
      | 'date_created'
      | '-date_created'
      | 'date_modified'
      | '-date_modified'
      | 'id'
      | '-id'
      | 'blocked'
      | '-blocked'
      | 'screened'
      | '-screened'
      | 'is_owned'
      | '-is_owned'
      | 'keyword'
      | '-keyword'
      | 'number'
      | '-number',
    options?: any
  ) {
    return GroupApiFp(this.configuration)
      .listGroupContacts(
        groupId,
        limit,
        offset,
        number,
        name,
        screened,
        blocked,
        ordering,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Gets a list of groups
   * @summary List Groups
   * @param {number} [limit] (Pagination) How many records to return
   * @param {number} [offset] (Pagination) How many records to skip
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GroupApi
   */
  public listGroups(limit?: number, offset?: number, options?: any) {
    return GroupApiFp(this.configuration)
      .listGroups(limit, offset, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Updates an individual group referenced by its id  **Note:** this is a _replace_ operation; any properties the group already has that you don\'t specify in your request will be set to their defaults
   * @summary Update Group
   * @param {string} groupId The group ID
   * @param {InlineObject1} [inlineObject1]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GroupApi
   */
  public updateGroup(
    groupId: string,
    inlineObject1?: InlineObject1,
    options?: any
  ) {
    return GroupApiFp(this.configuration)
      .updateGroup(groupId, inlineObject1, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * MessageApi - axios parameter creator
 * @export
 */
export const MessageApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Deletes an individual message by its id
     * @summary Delete Message
     * @param {string} messageId The message ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteMessage: async (
      messageId: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'messageId' is not null or undefined
      if (messageId === null || messageId === undefined) {
        throw new RequiredError(
          'messageId',
          'Required parameter messageId was null or undefined when calling deleteMessage.'
        )
      }
      const localVarPath = `/v1/messages/{message_id}`.replace(
        `{${'message_id'}}`,
        encodeURIComponent(String(messageId))
      )
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = {
        method: 'DELETE',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication api_key required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('api_key')
            : await configuration.apiKey
        localVarQueryParameter['api_key'] = localVarApiKeyValue
      }

      // authentication basic_auth required
      // http basic authentication required
      if (configuration && (configuration.username || configuration.password)) {
        localVarRequestOptions['auth'] = {
          username: configuration.username,
          password: configuration.password,
        }
      }

      // authentication username required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('username')
            : await configuration.apiKey
        localVarQueryParameter['username'] = localVarApiKeyValue
      }

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      localVarUrlObj.search = null
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Retrieves an existing message by its Id
     * @summary Get Message
     * @param {string} messageId The message ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMessage: async (
      messageId: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'messageId' is not null or undefined
      if (messageId === null || messageId === undefined) {
        throw new RequiredError(
          'messageId',
          'Required parameter messageId was null or undefined when calling getMessage.'
        )
      }
      const localVarPath = `/v1/messages/{message_id}`.replace(
        `{${'message_id'}}`,
        encodeURIComponent(String(messageId))
      )
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication api_key required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('api_key')
            : await configuration.apiKey
        localVarQueryParameter['api_key'] = localVarApiKeyValue
      }

      // authentication basic_auth required
      // http basic authentication required
      if (configuration && (configuration.username || configuration.password)) {
        localVarRequestOptions['auth'] = {
          username: configuration.username,
          password: configuration.password,
        }
      }

      // authentication username required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('username')
            : await configuration.apiKey
        localVarQueryParameter['username'] = localVarApiKeyValue
      }

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      localVarUrlObj.search = null
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Lists scheduled messages
     * @summary List scheduled messages
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listScheduledMessages: async (options: any = {}): Promise<RequestArgs> => {
      const localVarPath = `/v1/messages/scheduled`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication api_key required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('api_key')
            : await configuration.apiKey
        localVarQueryParameter['api_key'] = localVarApiKeyValue
      }

      // authentication basic_auth required
      // http basic authentication required
      if (configuration && (configuration.username || configuration.password)) {
        localVarRequestOptions['auth'] = {
          username: configuration.username,
          password: configuration.password,
        }
      }

      // authentication username required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('username')
            : await configuration.apiKey
        localVarQueryParameter['username'] = localVarApiKeyValue
      }

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      localVarUrlObj.search = null
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Sends an SMS (or MMS based on your plan) to a list of contacts, phone numbers or groups.
     * @summary Send an SMS or MMS message
     * @param {SendMessageRequest} [sendMessageRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sendMessage: async (
      sendMessageRequest?: SendMessageRequest,
      options: any = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/v1/messages`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication api_key required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('api_key')
            : await configuration.apiKey
        localVarQueryParameter['api_key'] = localVarApiKeyValue
      }

      // authentication basic_auth required
      // http basic authentication required
      if (configuration && (configuration.username || configuration.password)) {
        localVarRequestOptions['auth'] = {
          username: configuration.username,
          password: configuration.password,
        }
      }

      // authentication username required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('username')
            : await configuration.apiKey
        localVarQueryParameter['username'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      localVarUrlObj.search = null
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const needsSerialization =
        typeof sendMessageRequest !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(
            sendMessageRequest !== undefined ? sendMessageRequest : {}
          )
        : sendMessageRequest || ''

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Updates a scheduled message
     * @summary Update Message
     * @param {string} messageId The message ID
     * @param {SendMessageRequest} [sendMessageRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateMessage: async (
      messageId: string,
      sendMessageRequest?: SendMessageRequest,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'messageId' is not null or undefined
      if (messageId === null || messageId === undefined) {
        throw new RequiredError(
          'messageId',
          'Required parameter messageId was null or undefined when calling updateMessage.'
        )
      }
      const localVarPath = `/v1/messages/{message_id}`.replace(
        `{${'message_id'}}`,
        encodeURIComponent(String(messageId))
      )
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = {
        method: 'PUT',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication api_key required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('api_key')
            : await configuration.apiKey
        localVarQueryParameter['api_key'] = localVarApiKeyValue
      }

      // authentication basic_auth required
      // http basic authentication required
      if (configuration && (configuration.username || configuration.password)) {
        localVarRequestOptions['auth'] = {
          username: configuration.username,
          password: configuration.password,
        }
      }

      // authentication username required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('username')
            : await configuration.apiKey
        localVarQueryParameter['username'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      localVarUrlObj.search = null
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const needsSerialization =
        typeof sendMessageRequest !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(
            sendMessageRequest !== undefined ? sendMessageRequest : {}
          )
        : sendMessageRequest || ''

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * MessageApi - functional programming interface
 * @export
 */
export const MessageApiFp = function (configuration?: Configuration) {
  return {
    /**
     * Deletes an individual message by its id
     * @summary Delete Message
     * @param {string} messageId The message ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteMessage(
      messageId: string,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<InlineResponse2004>
    > {
      const localVarAxiosArgs = await MessageApiAxiosParamCreator(
        configuration
      ).deleteMessage(messageId, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Retrieves an existing message by its Id
     * @summary Get Message
     * @param {string} messageId The message ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getMessage(
      messageId: string,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Message>
    > {
      const localVarAxiosArgs = await MessageApiAxiosParamCreator(
        configuration
      ).getMessage(messageId, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Lists scheduled messages
     * @summary List scheduled messages
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listScheduledMessages(
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<InlineResponse2005>
    > {
      const localVarAxiosArgs = await MessageApiAxiosParamCreator(
        configuration
      ).listScheduledMessages(options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Sends an SMS (or MMS based on your plan) to a list of contacts, phone numbers or groups.
     * @summary Send an SMS or MMS message
     * @param {SendMessageRequest} [sendMessageRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async sendMessage(
      sendMessageRequest?: SendMessageRequest,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<InlineResponse2011>
    > {
      const localVarAxiosArgs = await MessageApiAxiosParamCreator(
        configuration
      ).sendMessage(sendMessageRequest, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Updates a scheduled message
     * @summary Update Message
     * @param {string} messageId The message ID
     * @param {SendMessageRequest} [sendMessageRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateMessage(
      messageId: string,
      sendMessageRequest?: SendMessageRequest,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<SendMessageRequest>
    > {
      const localVarAxiosArgs = await MessageApiAxiosParamCreator(
        configuration
      ).updateMessage(messageId, sendMessageRequest, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
  }
}

/**
 * MessageApi - factory interface
 * @export
 */
export const MessageApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     * Deletes an individual message by its id
     * @summary Delete Message
     * @param {string} messageId The message ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteMessage(
      messageId: string,
      options?: any
    ): AxiosPromise<InlineResponse2004> {
      return MessageApiFp(configuration)
        .deleteMessage(messageId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Retrieves an existing message by its Id
     * @summary Get Message
     * @param {string} messageId The message ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMessage(messageId: string, options?: any): AxiosPromise<Message> {
      return MessageApiFp(configuration)
        .getMessage(messageId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Lists scheduled messages
     * @summary List scheduled messages
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listScheduledMessages(options?: any): AxiosPromise<InlineResponse2005> {
      return MessageApiFp(configuration)
        .listScheduledMessages(options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Sends an SMS (or MMS based on your plan) to a list of contacts, phone numbers or groups.
     * @summary Send an SMS or MMS message
     * @param {SendMessageRequest} [sendMessageRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sendMessage(
      sendMessageRequest?: SendMessageRequest,
      options?: any
    ): AxiosPromise<InlineResponse2011> {
      return MessageApiFp(configuration)
        .sendMessage(sendMessageRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Updates a scheduled message
     * @summary Update Message
     * @param {string} messageId The message ID
     * @param {SendMessageRequest} [sendMessageRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateMessage(
      messageId: string,
      sendMessageRequest?: SendMessageRequest,
      options?: any
    ): AxiosPromise<SendMessageRequest> {
      return MessageApiFp(configuration)
        .updateMessage(messageId, sendMessageRequest, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * MessageApi - interface
 * @export
 * @interface MessageApi
 */
export interface MessageApiInterface {
  /**
   * Deletes an individual message by its id
   * @summary Delete Message
   * @param {string} messageId The message ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MessageApiInterface
   */
  deleteMessage(
    messageId: string,
    options?: any
  ): AxiosPromise<InlineResponse2004>

  /**
   * Retrieves an existing message by its Id
   * @summary Get Message
   * @param {string} messageId The message ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MessageApiInterface
   */
  getMessage(messageId: string, options?: any): AxiosPromise<Message>

  /**
   * Lists scheduled messages
   * @summary List scheduled messages
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MessageApiInterface
   */
  listScheduledMessages(options?: any): AxiosPromise<InlineResponse2005>

  /**
   * Sends an SMS (or MMS based on your plan) to a list of contacts, phone numbers or groups.
   * @summary Send an SMS or MMS message
   * @param {SendMessageRequest} [sendMessageRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MessageApiInterface
   */
  sendMessage(
    sendMessageRequest?: SendMessageRequest,
    options?: any
  ): AxiosPromise<InlineResponse2011>

  /**
   * Updates a scheduled message
   * @summary Update Message
   * @param {string} messageId The message ID
   * @param {SendMessageRequest} [sendMessageRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MessageApiInterface
   */
  updateMessage(
    messageId: string,
    sendMessageRequest?: SendMessageRequest,
    options?: any
  ): AxiosPromise<SendMessageRequest>
}

/**
 * MessageApi - object-oriented interface
 * @export
 * @class MessageApi
 * @extends {BaseAPI}
 */
export class MessageApi extends BaseAPI implements MessageApiInterface {
  /**
   * Deletes an individual message by its id
   * @summary Delete Message
   * @param {string} messageId The message ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MessageApi
   */
  public deleteMessage(messageId: string, options?: any) {
    return MessageApiFp(this.configuration)
      .deleteMessage(messageId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Retrieves an existing message by its Id
   * @summary Get Message
   * @param {string} messageId The message ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MessageApi
   */
  public getMessage(messageId: string, options?: any) {
    return MessageApiFp(this.configuration)
      .getMessage(messageId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Lists scheduled messages
   * @summary List scheduled messages
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MessageApi
   */
  public listScheduledMessages(options?: any) {
    return MessageApiFp(this.configuration)
      .listScheduledMessages(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Sends an SMS (or MMS based on your plan) to a list of contacts, phone numbers or groups.
   * @summary Send an SMS or MMS message
   * @param {SendMessageRequest} [sendMessageRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MessageApi
   */
  public sendMessage(sendMessageRequest?: SendMessageRequest, options?: any) {
    return MessageApiFp(this.configuration)
      .sendMessage(sendMessageRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Updates a scheduled message
   * @summary Update Message
   * @param {string} messageId The message ID
   * @param {SendMessageRequest} [sendMessageRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MessageApi
   */
  public updateMessage(
    messageId: string,
    sendMessageRequest?: SendMessageRequest,
    options?: any
  ) {
    return MessageApiFp(this.configuration)
      .updateMessage(messageId, sendMessageRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * ProfileApi - axios parameter creator
 * @export
 */
export const ProfileApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Gets your enterprise account\'s details
     * @summary Get Enterprise (Account)
     * @param {string} enterpriseId Your enterprise account\&#39;s ID  **Note:** You can find your &#x60;enterprise_id&#x60; in the &#x60;/v1/settings&#x60; or &#x60;/v1/profile&#x60; endpoints
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getEnterprise: async (
      enterpriseId: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'enterpriseId' is not null or undefined
      if (enterpriseId === null || enterpriseId === undefined) {
        throw new RequiredError(
          'enterpriseId',
          'Required parameter enterpriseId was null or undefined when calling getEnterprise.'
        )
      }
      const localVarPath = `/v1/enterprises/{enterprise_id}`.replace(
        `{${'enterprise_id'}}`,
        encodeURIComponent(String(enterpriseId))
      )
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication api_key required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('api_key')
            : await configuration.apiKey
        localVarQueryParameter['api_key'] = localVarApiKeyValue
      }

      // authentication basic_auth required
      // http basic authentication required
      if (configuration && (configuration.username || configuration.password)) {
        localVarRequestOptions['auth'] = {
          username: configuration.username,
          password: configuration.password,
        }
      }

      // authentication username required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('username')
            : await configuration.apiKey
        localVarQueryParameter['username'] = localVarApiKeyValue
      }

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      localVarUrlObj.search = null
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Gets details about your SendHub line
     * @summary Get Profile
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProfile: async (options: any = {}): Promise<RequestArgs> => {
      const localVarPath = `/v1/profile`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication api_key required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('api_key')
            : await configuration.apiKey
        localVarQueryParameter['api_key'] = localVarApiKeyValue
      }

      // authentication basic_auth required
      // http basic authentication required
      if (configuration && (configuration.username || configuration.password)) {
        localVarRequestOptions['auth'] = {
          username: configuration.username,
          password: configuration.password,
        }
      }

      // authentication username required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('username')
            : await configuration.apiKey
        localVarQueryParameter['username'] = localVarApiKeyValue
      }

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      localVarUrlObj.search = null
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Gets your line\'s Settings
     * @summary Get Settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSettings: async (options: any = {}): Promise<RequestArgs> => {
      const localVarPath = `/v1/settings`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication api_key required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('api_key')
            : await configuration.apiKey
        localVarQueryParameter['api_key'] = localVarApiKeyValue
      }

      // authentication basic_auth required
      // http basic authentication required
      if (configuration && (configuration.username || configuration.password)) {
        localVarRequestOptions['auth'] = {
          username: configuration.username,
          password: configuration.password,
        }
      }

      // authentication username required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('username')
            : await configuration.apiKey
        localVarQueryParameter['username'] = localVarApiKeyValue
      }

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      localVarUrlObj.search = null
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Gets a user (line)
     * @summary Get User
     * @param {string} enterpriseId Your enterprise account\&#39;s ID  **Note:** You can find your &#x60;enterprise_id&#x60; in the &#x60;/v1/settings&#x60; or &#x60;/v1/profile&#x60; endpoints
     * @param {number} userId The SendHub user (line)\&#39;s ID  **Note:** You can find your &#x60;user_id&#x60; in the &#x60;/v1/profile&#x60; endpoint You can list all the users in your account via the &#x60;/v1/enterprises/{enterprise_id}/users&#x60; endpoint
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUser: async (
      enterpriseId: string,
      userId: number,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'enterpriseId' is not null or undefined
      if (enterpriseId === null || enterpriseId === undefined) {
        throw new RequiredError(
          'enterpriseId',
          'Required parameter enterpriseId was null or undefined when calling getUser.'
        )
      }
      // verify required parameter 'userId' is not null or undefined
      if (userId === null || userId === undefined) {
        throw new RequiredError(
          'userId',
          'Required parameter userId was null or undefined when calling getUser.'
        )
      }
      const localVarPath = `/v1/enterprises/{enterprise_id}/users/{user_id}`
        .replace(
          `{${'enterprise_id'}}`,
          encodeURIComponent(String(enterpriseId))
        )
        .replace(`{${'user_id'}}`, encodeURIComponent(String(userId)))
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication api_key required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('api_key')
            : await configuration.apiKey
        localVarQueryParameter['api_key'] = localVarApiKeyValue
      }

      // authentication basic_auth required
      // http basic authentication required
      if (configuration && (configuration.username || configuration.password)) {
        localVarRequestOptions['auth'] = {
          username: configuration.username,
          password: configuration.password,
        }
      }

      // authentication username required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('username')
            : await configuration.apiKey
        localVarQueryParameter['username'] = localVarApiKeyValue
      }

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      localVarUrlObj.search = null
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Lists your enterprise account\'s users (lines)
     * @summary List Users
     * @param {string} enterpriseId Your enterprise account\&#39;s ID  **Note:** You can find your &#x60;enterprise_id&#x60; in the &#x60;/v1/settings&#x60; or &#x60;/v1/profile&#x60; endpoints
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listUsers: async (
      enterpriseId: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'enterpriseId' is not null or undefined
      if (enterpriseId === null || enterpriseId === undefined) {
        throw new RequiredError(
          'enterpriseId',
          'Required parameter enterpriseId was null or undefined when calling listUsers.'
        )
      }
      const localVarPath = `/v1/enterprises/{enterprise_id}/users`.replace(
        `{${'enterprise_id'}}`,
        encodeURIComponent(String(enterpriseId))
      )
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication api_key required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('api_key')
            : await configuration.apiKey
        localVarQueryParameter['api_key'] = localVarApiKeyValue
      }

      // authentication basic_auth required
      // http basic authentication required
      if (configuration && (configuration.username || configuration.password)) {
        localVarRequestOptions['auth'] = {
          username: configuration.username,
          password: configuration.password,
        }
      }

      // authentication username required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('username')
            : await configuration.apiKey
        localVarQueryParameter['username'] = localVarApiKeyValue
      }

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      localVarUrlObj.search = null
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Updates your SendHub line\'s settings
     * @summary Update Settings
     * @param {UpdateSettings} [updateSettings]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateSettings: async (
      updateSettings?: UpdateSettings,
      options: any = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/v1/settings`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = {
        method: 'PUT',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication api_key required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('api_key')
            : await configuration.apiKey
        localVarQueryParameter['api_key'] = localVarApiKeyValue
      }

      // authentication basic_auth required
      // http basic authentication required
      if (configuration && (configuration.username || configuration.password)) {
        localVarRequestOptions['auth'] = {
          username: configuration.username,
          password: configuration.password,
        }
      }

      // authentication username required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('username')
            : await configuration.apiKey
        localVarQueryParameter['username'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      localVarUrlObj.search = null
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const needsSerialization =
        typeof updateSettings !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(updateSettings !== undefined ? updateSettings : {})
        : updateSettings || ''

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * ProfileApi - functional programming interface
 * @export
 */
export const ProfileApiFp = function (configuration?: Configuration) {
  return {
    /**
     * Gets your enterprise account\'s details
     * @summary Get Enterprise (Account)
     * @param {string} enterpriseId Your enterprise account\&#39;s ID  **Note:** You can find your &#x60;enterprise_id&#x60; in the &#x60;/v1/settings&#x60; or &#x60;/v1/profile&#x60; endpoints
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getEnterprise(
      enterpriseId: string,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<EnterpriseAccount>
    > {
      const localVarAxiosArgs = await ProfileApiAxiosParamCreator(
        configuration
      ).getEnterprise(enterpriseId, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Gets details about your SendHub line
     * @summary Get Profile
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getProfile(
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserProfile>
    > {
      const localVarAxiosArgs = await ProfileApiAxiosParamCreator(
        configuration
      ).getProfile(options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Gets your line\'s Settings
     * @summary Get Settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getSettings(
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Settings>
    > {
      const localVarAxiosArgs = await ProfileApiAxiosParamCreator(
        configuration
      ).getSettings(options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Gets a user (line)
     * @summary Get User
     * @param {string} enterpriseId Your enterprise account\&#39;s ID  **Note:** You can find your &#x60;enterprise_id&#x60; in the &#x60;/v1/settings&#x60; or &#x60;/v1/profile&#x60; endpoints
     * @param {number} userId The SendHub user (line)\&#39;s ID  **Note:** You can find your &#x60;user_id&#x60; in the &#x60;/v1/profile&#x60; endpoint You can list all the users in your account via the &#x60;/v1/enterprises/{enterprise_id}/users&#x60; endpoint
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getUser(
      enterpriseId: string,
      userId: number,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>
    > {
      const localVarAxiosArgs = await ProfileApiAxiosParamCreator(
        configuration
      ).getUser(enterpriseId, userId, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Lists your enterprise account\'s users (lines)
     * @summary List Users
     * @param {string} enterpriseId Your enterprise account\&#39;s ID  **Note:** You can find your &#x60;enterprise_id&#x60; in the &#x60;/v1/settings&#x60; or &#x60;/v1/profile&#x60; endpoints
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listUsers(
      enterpriseId: string,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<ListUsersResponse>
    > {
      const localVarAxiosArgs = await ProfileApiAxiosParamCreator(
        configuration
      ).listUsers(enterpriseId, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Updates your SendHub line\'s settings
     * @summary Update Settings
     * @param {UpdateSettings} [updateSettings]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateSettings(
      updateSettings?: UpdateSettings,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserSettings>
    > {
      const localVarAxiosArgs = await ProfileApiAxiosParamCreator(
        configuration
      ).updateSettings(updateSettings, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
  }
}

/**
 * ProfileApi - factory interface
 * @export
 */
export const ProfileApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     * Gets your enterprise account\'s details
     * @summary Get Enterprise (Account)
     * @param {string} enterpriseId Your enterprise account\&#39;s ID  **Note:** You can find your &#x60;enterprise_id&#x60; in the &#x60;/v1/settings&#x60; or &#x60;/v1/profile&#x60; endpoints
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getEnterprise(
      enterpriseId: string,
      options?: any
    ): AxiosPromise<EnterpriseAccount> {
      return ProfileApiFp(configuration)
        .getEnterprise(enterpriseId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Gets details about your SendHub line
     * @summary Get Profile
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProfile(options?: any): AxiosPromise<UserProfile> {
      return ProfileApiFp(configuration)
        .getProfile(options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Gets your line\'s Settings
     * @summary Get Settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSettings(options?: any): AxiosPromise<Settings> {
      return ProfileApiFp(configuration)
        .getSettings(options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Gets a user (line)
     * @summary Get User
     * @param {string} enterpriseId Your enterprise account\&#39;s ID  **Note:** You can find your &#x60;enterprise_id&#x60; in the &#x60;/v1/settings&#x60; or &#x60;/v1/profile&#x60; endpoints
     * @param {number} userId The SendHub user (line)\&#39;s ID  **Note:** You can find your &#x60;user_id&#x60; in the &#x60;/v1/profile&#x60; endpoint You can list all the users in your account via the &#x60;/v1/enterprises/{enterprise_id}/users&#x60; endpoint
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUser(
      enterpriseId: string,
      userId: number,
      options?: any
    ): AxiosPromise<User> {
      return ProfileApiFp(configuration)
        .getUser(enterpriseId, userId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Lists your enterprise account\'s users (lines)
     * @summary List Users
     * @param {string} enterpriseId Your enterprise account\&#39;s ID  **Note:** You can find your &#x60;enterprise_id&#x60; in the &#x60;/v1/settings&#x60; or &#x60;/v1/profile&#x60; endpoints
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listUsers(
      enterpriseId: string,
      options?: any
    ): AxiosPromise<ListUsersResponse> {
      return ProfileApiFp(configuration)
        .listUsers(enterpriseId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Updates your SendHub line\'s settings
     * @summary Update Settings
     * @param {UpdateSettings} [updateSettings]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateSettings(
      updateSettings?: UpdateSettings,
      options?: any
    ): AxiosPromise<UserSettings> {
      return ProfileApiFp(configuration)
        .updateSettings(updateSettings, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * ProfileApi - interface
 * @export
 * @interface ProfileApi
 */
export interface ProfileApiInterface {
  /**
   * Gets your enterprise account\'s details
   * @summary Get Enterprise (Account)
   * @param {string} enterpriseId Your enterprise account\&#39;s ID  **Note:** You can find your &#x60;enterprise_id&#x60; in the &#x60;/v1/settings&#x60; or &#x60;/v1/profile&#x60; endpoints
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProfileApiInterface
   */
  getEnterprise(
    enterpriseId: string,
    options?: any
  ): AxiosPromise<EnterpriseAccount>

  /**
   * Gets details about your SendHub line
   * @summary Get Profile
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProfileApiInterface
   */
  getProfile(options?: any): AxiosPromise<UserProfile>

  /**
   * Gets your line\'s Settings
   * @summary Get Settings
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProfileApiInterface
   */
  getSettings(options?: any): AxiosPromise<Settings>

  /**
   * Gets a user (line)
   * @summary Get User
   * @param {string} enterpriseId Your enterprise account\&#39;s ID  **Note:** You can find your &#x60;enterprise_id&#x60; in the &#x60;/v1/settings&#x60; or &#x60;/v1/profile&#x60; endpoints
   * @param {number} userId The SendHub user (line)\&#39;s ID  **Note:** You can find your &#x60;user_id&#x60; in the &#x60;/v1/profile&#x60; endpoint You can list all the users in your account via the &#x60;/v1/enterprises/{enterprise_id}/users&#x60; endpoint
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProfileApiInterface
   */
  getUser(
    enterpriseId: string,
    userId: number,
    options?: any
  ): AxiosPromise<User>

  /**
   * Lists your enterprise account\'s users (lines)
   * @summary List Users
   * @param {string} enterpriseId Your enterprise account\&#39;s ID  **Note:** You can find your &#x60;enterprise_id&#x60; in the &#x60;/v1/settings&#x60; or &#x60;/v1/profile&#x60; endpoints
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProfileApiInterface
   */
  listUsers(
    enterpriseId: string,
    options?: any
  ): AxiosPromise<ListUsersResponse>

  /**
   * Updates your SendHub line\'s settings
   * @summary Update Settings
   * @param {UpdateSettings} [updateSettings]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProfileApiInterface
   */
  updateSettings(
    updateSettings?: UpdateSettings,
    options?: any
  ): AxiosPromise<UserSettings>
}

/**
 * ProfileApi - object-oriented interface
 * @export
 * @class ProfileApi
 * @extends {BaseAPI}
 */
export class ProfileApi extends BaseAPI implements ProfileApiInterface {
  /**
   * Gets your enterprise account\'s details
   * @summary Get Enterprise (Account)
   * @param {string} enterpriseId Your enterprise account\&#39;s ID  **Note:** You can find your &#x60;enterprise_id&#x60; in the &#x60;/v1/settings&#x60; or &#x60;/v1/profile&#x60; endpoints
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProfileApi
   */
  public getEnterprise(enterpriseId: string, options?: any) {
    return ProfileApiFp(this.configuration)
      .getEnterprise(enterpriseId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Gets details about your SendHub line
   * @summary Get Profile
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProfileApi
   */
  public getProfile(options?: any) {
    return ProfileApiFp(this.configuration)
      .getProfile(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Gets your line\'s Settings
   * @summary Get Settings
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProfileApi
   */
  public getSettings(options?: any) {
    return ProfileApiFp(this.configuration)
      .getSettings(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Gets a user (line)
   * @summary Get User
   * @param {string} enterpriseId Your enterprise account\&#39;s ID  **Note:** You can find your &#x60;enterprise_id&#x60; in the &#x60;/v1/settings&#x60; or &#x60;/v1/profile&#x60; endpoints
   * @param {number} userId The SendHub user (line)\&#39;s ID  **Note:** You can find your &#x60;user_id&#x60; in the &#x60;/v1/profile&#x60; endpoint You can list all the users in your account via the &#x60;/v1/enterprises/{enterprise_id}/users&#x60; endpoint
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProfileApi
   */
  public getUser(enterpriseId: string, userId: number, options?: any) {
    return ProfileApiFp(this.configuration)
      .getUser(enterpriseId, userId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Lists your enterprise account\'s users (lines)
   * @summary List Users
   * @param {string} enterpriseId Your enterprise account\&#39;s ID  **Note:** You can find your &#x60;enterprise_id&#x60; in the &#x60;/v1/settings&#x60; or &#x60;/v1/profile&#x60; endpoints
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProfileApi
   */
  public listUsers(enterpriseId: string, options?: any) {
    return ProfileApiFp(this.configuration)
      .listUsers(enterpriseId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Updates your SendHub line\'s settings
   * @summary Update Settings
   * @param {UpdateSettings} [updateSettings]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProfileApi
   */
  public updateSettings(updateSettings?: UpdateSettings, options?: any) {
    return ProfileApiFp(this.configuration)
      .updateSettings(updateSettings, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * ThreadApi - axios parameter creator
 * @export
 */
export const ThreadApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Deletes an individual thread by its id
     * @summary Delete thread
     * @param {number} threadId The thread ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteThread: async (
      threadId: number,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'threadId' is not null or undefined
      if (threadId === null || threadId === undefined) {
        throw new RequiredError(
          'threadId',
          'Required parameter threadId was null or undefined when calling deleteThread.'
        )
      }
      const localVarPath = `/v1/threads/{thread_id}`.replace(
        `{${'thread_id'}}`,
        encodeURIComponent(String(threadId))
      )
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = {
        method: 'DELETE',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication api_key required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('api_key')
            : await configuration.apiKey
        localVarQueryParameter['api_key'] = localVarApiKeyValue
      }

      // authentication basic_auth required
      // http basic authentication required
      if (configuration && (configuration.username || configuration.password)) {
        localVarRequestOptions['auth'] = {
          username: configuration.username,
          password: configuration.password,
        }
      }

      // authentication username required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('username')
            : await configuration.apiKey
        localVarQueryParameter['username'] = localVarApiKeyValue
      }

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      localVarUrlObj.search = null
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Gets an individual thread by its id
     * @summary Get thread
     * @param {number} threadId The thread ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getThread: async (
      threadId: number,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'threadId' is not null or undefined
      if (threadId === null || threadId === undefined) {
        throw new RequiredError(
          'threadId',
          'Required parameter threadId was null or undefined when calling getThread.'
        )
      }
      const localVarPath = `/v1/threads/{thread_id}`.replace(
        `{${'thread_id'}}`,
        encodeURIComponent(String(threadId))
      )
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication api_key required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('api_key')
            : await configuration.apiKey
        localVarQueryParameter['api_key'] = localVarApiKeyValue
      }

      // authentication basic_auth required
      // http basic authentication required
      if (configuration && (configuration.username || configuration.password)) {
        localVarRequestOptions['auth'] = {
          username: configuration.username,
          password: configuration.password,
        }
      }

      // authentication username required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('username')
            : await configuration.apiKey
        localVarQueryParameter['username'] = localVarApiKeyValue
      }

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      localVarUrlObj.search = null
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Gets a list of inbox threads  **Note:** the URL **must** include the forward-slash after /v1/inbox  The `next` field in the `meta` object doesn\'t include this forward-slash in the URI it provides  We suggest constructing your URIs via your code and using the `next` field to determine if there\'s a next page (eg. if `next` is null)
     * @summary List Threads
     * @param {number} [limit] (Pagination) How many records to return
     * @param {number} [offset] (Pagination) How many records to skip
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listThreads: async (
      limit?: number,
      offset?: number,
      options: any = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/v1/inbox`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication api_key required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('api_key')
            : await configuration.apiKey
        localVarQueryParameter['api_key'] = localVarApiKeyValue
      }

      // authentication basic_auth required
      // http basic authentication required
      if (configuration && (configuration.username || configuration.password)) {
        localVarRequestOptions['auth'] = {
          username: configuration.username,
          password: configuration.password,
        }
      }

      // authentication username required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('username')
            : await configuration.apiKey
        localVarQueryParameter['username'] = localVarApiKeyValue
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      if (offset !== undefined) {
        localVarQueryParameter['offset'] = offset
      }

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      localVarUrlObj.search = null
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * ThreadApi - functional programming interface
 * @export
 */
export const ThreadApiFp = function (configuration?: Configuration) {
  return {
    /**
     * Deletes an individual thread by its id
     * @summary Delete thread
     * @param {number} threadId The thread ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteThread(
      threadId: number,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<InlineResponse2003>
    > {
      const localVarAxiosArgs = await ThreadApiAxiosParamCreator(
        configuration
      ).deleteThread(threadId, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Gets an individual thread by its id
     * @summary Get thread
     * @param {number} threadId The thread ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getThread(
      threadId: number,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<InlineResponse2002>
    > {
      const localVarAxiosArgs = await ThreadApiAxiosParamCreator(
        configuration
      ).getThread(threadId, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Gets a list of inbox threads  **Note:** the URL **must** include the forward-slash after /v1/inbox  The `next` field in the `meta` object doesn\'t include this forward-slash in the URI it provides  We suggest constructing your URIs via your code and using the `next` field to determine if there\'s a next page (eg. if `next` is null)
     * @summary List Threads
     * @param {number} [limit] (Pagination) How many records to return
     * @param {number} [offset] (Pagination) How many records to skip
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listThreads(
      limit?: number,
      offset?: number,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<InlineResponse2001>
    > {
      const localVarAxiosArgs = await ThreadApiAxiosParamCreator(
        configuration
      ).listThreads(limit, offset, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
  }
}

/**
 * ThreadApi - factory interface
 * @export
 */
export const ThreadApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     * Deletes an individual thread by its id
     * @summary Delete thread
     * @param {number} threadId The thread ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteThread(
      threadId: number,
      options?: any
    ): AxiosPromise<InlineResponse2003> {
      return ThreadApiFp(configuration)
        .deleteThread(threadId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Gets an individual thread by its id
     * @summary Get thread
     * @param {number} threadId The thread ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getThread(
      threadId: number,
      options?: any
    ): AxiosPromise<InlineResponse2002> {
      return ThreadApiFp(configuration)
        .getThread(threadId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Gets a list of inbox threads  **Note:** the URL **must** include the forward-slash after /v1/inbox  The `next` field in the `meta` object doesn\'t include this forward-slash in the URI it provides  We suggest constructing your URIs via your code and using the `next` field to determine if there\'s a next page (eg. if `next` is null)
     * @summary List Threads
     * @param {number} [limit] (Pagination) How many records to return
     * @param {number} [offset] (Pagination) How many records to skip
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listThreads(
      limit?: number,
      offset?: number,
      options?: any
    ): AxiosPromise<InlineResponse2001> {
      return ThreadApiFp(configuration)
        .listThreads(limit, offset, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * ThreadApi - interface
 * @export
 * @interface ThreadApi
 */
export interface ThreadApiInterface {
  /**
   * Deletes an individual thread by its id
   * @summary Delete thread
   * @param {number} threadId The thread ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ThreadApiInterface
   */
  deleteThread(
    threadId: number,
    options?: any
  ): AxiosPromise<InlineResponse2003>

  /**
   * Gets an individual thread by its id
   * @summary Get thread
   * @param {number} threadId The thread ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ThreadApiInterface
   */
  getThread(threadId: number, options?: any): AxiosPromise<InlineResponse2002>

  /**
   * Gets a list of inbox threads  **Note:** the URL **must** include the forward-slash after /v1/inbox  The `next` field in the `meta` object doesn\'t include this forward-slash in the URI it provides  We suggest constructing your URIs via your code and using the `next` field to determine if there\'s a next page (eg. if `next` is null)
   * @summary List Threads
   * @param {number} [limit] (Pagination) How many records to return
   * @param {number} [offset] (Pagination) How many records to skip
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ThreadApiInterface
   */
  listThreads(
    limit?: number,
    offset?: number,
    options?: any
  ): AxiosPromise<InlineResponse2001>
}

/**
 * ThreadApi - object-oriented interface
 * @export
 * @class ThreadApi
 * @extends {BaseAPI}
 */
export class ThreadApi extends BaseAPI implements ThreadApiInterface {
  /**
   * Deletes an individual thread by its id
   * @summary Delete thread
   * @param {number} threadId The thread ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ThreadApi
   */
  public deleteThread(threadId: number, options?: any) {
    return ThreadApiFp(this.configuration)
      .deleteThread(threadId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Gets an individual thread by its id
   * @summary Get thread
   * @param {number} threadId The thread ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ThreadApi
   */
  public getThread(threadId: number, options?: any) {
    return ThreadApiFp(this.configuration)
      .getThread(threadId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Gets a list of inbox threads  **Note:** the URL **must** include the forward-slash after /v1/inbox  The `next` field in the `meta` object doesn\'t include this forward-slash in the URI it provides  We suggest constructing your URIs via your code and using the `next` field to determine if there\'s a next page (eg. if `next` is null)
   * @summary List Threads
   * @param {number} [limit] (Pagination) How many records to return
   * @param {number} [offset] (Pagination) How many records to skip
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ThreadApi
   */
  public listThreads(limit?: number, offset?: number, options?: any) {
    return ThreadApiFp(this.configuration)
      .listThreads(limit, offset, options)
      .then((request) => request(this.axios, this.basePath))
  }
}
